
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("8Ixq2", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $cO1el = parcelRequire("cO1el");


var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");

var $9a5d2e1dc949170f$exports = {};
$9a5d2e1dc949170f$exports = new URL("error-icon.fcea7b28.svg", import.meta.url).toString();



var $cgtv4 = parcelRequire("cgtv4");

const $5b6387ec245f27f4$var$_default_1 = (0, $cgtv4.defineMessages)({
    genericErrorHeading: {
        id: "company-hub.generic-error-page.heading",
        defaultMessage: "We're on it"
    },
    genericErrorDescription: {
        id: "company-hub.generic-error-page.description",
        defaultMessage: "An unexpected error has occured when processing your request. Our team is working to get things back up and running."
    }
});
var $5b6387ec245f27f4$export$2e2bcd8739ae039 = $5b6387ec245f27f4$var$_default_1;


const $86003185bc750c17$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $86003185bc750c17$export$5d76009b056f3e5d = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $86003185bc750c17$var$styles.root,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9a5d2e1dc949170f$exports))),
                alt: "error page",
                className: (0, $gMc0m.default)([
                    $86003185bc750c17$var$styles.image
                ])
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $86003185bc750c17$var$styles.content
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                            size: "xlarge",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $5b6387ec245f27f4$export$2e2bcd8739ae039).genericErrorHeading
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $5b6387ec245f27f4$export$2e2bcd8739ae039).genericErrorDescription
                            })
                        })
                    ]
                })
            })
        ]
    });
};
module.exports["GenericErrorPage"] = $86003185bc750c17$export$5d76009b056f3e5d;

});

parcelRegister("jrlgF", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $eduVw = parcelRequire("eduVw");


var $kDHbX = parcelRequire("kDHbX");

const $5e95ffc879c03128$var$isFetchClientError = (err)=>{
    return err?.status < 500;
};
const $5e95ffc879c03128$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError })=>{
    const logError = (0, $eduVw.useUFOReportError)();
    const onError = (error)=>{
        if ($5e95ffc879c03128$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $kDHbX.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                }
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        onError: onError,
        fallback: fallback,
        children: children
    });
};
module.exports["HubErrorBoundary"] = $5e95ffc879c03128$export$ba2f52e216142b3d;

});

parcelRegister("1u5CA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fQWPs = parcelRequire("fQWPs");


var $koWgP = parcelRequire("koWgP");


var $19TyP = parcelRequire("19TyP");

/** This is a map of commonly used ADS colors, a well-balanced spread of the color palette
 * There are 3 unique sets of tokens for background, text, and border.
 * Highlight colors, otherwise known as foreground colors, are the same as text colors
 * because text colors are handpicked to complement background colors at the appropriate AA contrast ratio
 * contrast standards should be met between foreground/background as text/background does
 */ const $1ca59d92efd5b213$var$ELEVATION_SURFACE_TOKEN = "var(--ds-surface, #FFFFFF)";
const $1ca59d92efd5b213$var$ELEVATION_SURFACE_OVERLAY_TOKEN = "var(--ds-surface-overlay, #FFFFFF)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN = "var(--ds-background-accent-magenta-subtlest, #FFECF8)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN = "var(--ds-background-accent-red-subtlest, #FFECEB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN = "var(--ds-background-accent-orange-subtlest, #FFF5DB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN = "var(--ds-background-accent-yellow-subtlest, #FEF7C8)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN = "var(--ds-background-accent-lime-subtlest, #EFFFD6)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN = "var(--ds-background-accent-green-subtlest, #DCFFF1)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN = "var(--ds-background-accent-teal-subtlest, #E7F9FF)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN = "var(--ds-background-accent-purple-subtler, #EED7FC)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN = "var(--ds-background-accent-magenta-subtler, #FDD0EC)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN = "var(--ds-background-accent-red-subtler, #FFD5D2)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN = "var(--ds-background-accent-orange-subtler, #FCE4A6)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN = "var(--ds-background-accent-yellow-subtler, #F5E989)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN = "var(--ds-background-accent-lime-subtler, #D3F1A7)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN = "var(--ds-background-accent-green-subtler, #BAF3DB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN = "var(--ds-background-accent-teal-subtler, #C6EDFB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN = "var(--ds-background-accent-gray-subtle, #8C8F97)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN = "var(--ds-background-accent-blue-subtle, #669DF1)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN = "var(--ds-background-accent-purple-subtle, #C97CF4)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN = "var(--ds-background-accent-magenta-subtle, #E774BB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN = "var(--ds-background-accent-red-subtle, #F87168)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN = "var(--ds-background-accent-orange-subtle, #FCA700)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN = "var(--ds-background-accent-yellow-subtle, #EED12B)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN = "var(--ds-background-accent-lime-subtle, #94C748)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN = "var(--ds-background-accent-green-subtle, #4BCE97)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN = "var(--ds-background-accent-teal-subtle, #6CC3E0)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN = "var(--ds-background-accent-gray-bolder, #6B6E76)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN = "var(--ds-background-accent-blue-bolder, #1868DB)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN = "var(--ds-background-accent-purple-bolder, #964AC0)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN = "var(--ds-background-accent-magenta-bolder, #AE4787)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN = "var(--ds-background-accent-red-bolder, #C9372C)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN = "var(--ds-background-accent-orange-bolder, #BD5B00)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN = "var(--ds-background-accent-yellow-bolder, #946F00)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN = "var(--ds-background-accent-lime-bolder, #5B7F24)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN = "var(--ds-background-accent-green-bolder, #1F845A)";
const $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN = "var(--ds-background-accent-teal-bolder, #227D9B)";
const $1ca59d92efd5b213$export$1ca6214429b36a67 = [
    $1ca59d92efd5b213$var$ELEVATION_SURFACE_OVERLAY_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN,
    $1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN
];
const $1ca59d92efd5b213$export$596441732422b61d = {
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$ELEVATION_SURFACE_TOKEN)]: "var(--ds-surface-hovered, #F0F1F2)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$ELEVATION_SURFACE_OVERLAY_TOKEN)]: "var(--ds-surface-overlay-hovered, #F0F1F2)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLEST_TOKEN)]: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLEST_TOKEN)]: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLEST_TOKEN)]: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLEST_TOKEN)]: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLEST_TOKEN)]: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLEST_TOKEN)]: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLEST_TOKEN)]: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLER_TOKEN)]: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLER_TOKEN)]: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLER_TOKEN)]: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLER_TOKEN)]: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLER_TOKEN)]: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLER_TOKEN)]: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLER_TOKEN)]: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLER_TOKEN)]: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLER_TOKEN)]: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLER_TOKEN)]: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_SUBTLE_TOKEN)]: "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_SUBTLE_TOKEN)]: "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_SUBTLE_TOKEN)]: "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_SUBTLE_TOKEN)]: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_SUBTLE_TOKEN)]: "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_SUBTLE_TOKEN)]: "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_SUBTLE_TOKEN)]: "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_SUBTLE_TOKEN)]: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_SUBTLE_TOKEN)]: "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_SUBTLE_TOKEN)]: "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GRAY_BOLDER_TOKEN)]: "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_BLUE_BOLDER_TOKEN)]: "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_PURPLE_BOLDER_TOKEN)]: "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_MAGENTA_BOLDER_TOKEN)]: "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_RED_BOLDER_TOKEN)]: "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_ORANGE_BOLDER_TOKEN)]: "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_YELLOW_BOLDER_TOKEN)]: "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_LIME_BOLDER_TOKEN)]: "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_GREEN_BOLDER_TOKEN)]: "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    [(0, $fQWPs.extractToken)($1ca59d92efd5b213$var$COLOR_BACKGROUND_ACCENT_TEAL_BOLDER_TOKEN)]: "var(--ds-background-accent-teal-bolder-hovered, #206A83)"
};
const $1ca59d92efd5b213$export$4b7f6299a52ab6c0 = (color)=>{
    return $1ca59d92efd5b213$export$596441732422b61d[(0, $fQWPs.extractToken)(color)];
};
// New row of background colors are not semantically correct,
// and will be replaced by actual background colors from ADS
// when available.
// For now, we use these to solve a customer problem by helping
// them select a correctly theme-responsive token value instead
// of having to resort to custom hex codes to get a dark background
// color. Custom hex color codes don't always work well when used alongside
// tokenized text colors because the ADS color tokens will switch
// to a contrasting value in the opposite theme mode, but the custom
// hex background color will stay the same (we only change custom hex
// code values by darkening them if it is a light value selected in light mode).
const $1ca59d92efd5b213$var$additionalBackgroundColors = [
    "var(--ds-text-accent-gray-bolder, #1E1F21)",
    "var(--ds-text-accent-blue-bolder, #123263)",
    "var(--ds-text-accent-purple-bolder, #48245D)",
    "var(--ds-text-accent-magenta-bolder, #50253F)",
    "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "var(--ds-text-accent-orange-bolder, #693200)",
    "var(--ds-text-accent-yellow-bolder, #533F04)",
    "var(--ds-text-accent-lime-bolder, #37471F)",
    "var(--ds-text-accent-green-bolder, #164B35)",
    "var(--ds-text-accent-teal-bolder, #164555)"
];
const $1ca59d92efd5b213$var$knownTextColors = [
    "var(--ds-text, #292A2E)",
    "var(--ds-text-accent-blue-bolder, #123263)",
    "var(--ds-text-accent-purple-bolder, #48245D)",
    "var(--ds-text-accent-magenta-bolder, #50253F)",
    "var(--ds-text-accent-red-bolder, #5D1F1A)",
    "var(--ds-text-accent-orange-bolder, #693200)",
    "var(--ds-text-accent-yellow-bolder, #533F04)",
    "var(--ds-text-accent-lime-bolder, #37471F)",
    "var(--ds-text-accent-green-bolder, #164B35)",
    "var(--ds-text-accent-teal-bolder, #164555)",
    "var(--ds-text-subtle, #505258)",
    "var(--ds-text-accent-blue, #1558BC)",
    "var(--ds-text-accent-purple, #803FA5)",
    "var(--ds-text-accent-magenta, #943D73)",
    "var(--ds-text-accent-red, #AE2E24)",
    "var(--ds-text-accent-orange, #9E4C00)",
    "var(--ds-text-accent-yellow, #7F5F01)",
    "var(--ds-text-accent-lime, #4C6B1F)",
    "var(--ds-text-accent-green, #216E4E)",
    "var(--ds-text-accent-teal, #206A83)",
    "var(--ds-text-inverse, #FFFFFF)",
    "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    "var(--ds-background-accent-purple-subtler, #EED7FC)",
    "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "var(--ds-background-accent-red-subtler, #FFD5D2)",
    "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    "var(--ds-background-accent-yellow-subtler, #F5E989)",
    "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "var(--ds-background-accent-green-subtler, #BAF3DB)",
    "var(--ds-background-accent-teal-subtler, #C6EDFB)"
];
const $1ca59d92efd5b213$var$knownBorderColors = [
    "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    "var(--ds-border-accent-blue, #357DE8)",
    "var(--ds-border-accent-purple, #AF59E1)",
    "var(--ds-border-accent-magenta, #CD519D)",
    "var(--ds-border-accent-red, #E2483D)",
    "var(--ds-border-accent-orange, #E06C00)",
    "var(--ds-border-accent-yellow, #B38600)",
    "var(--ds-border-accent-lime, #6A9A23)",
    "var(--ds-border-accent-green, #22A06B)",
    "var(--ds-border-accent-teal, #2898BD)",
    "var(--ds-border-inverse, #FFFFFF)",
    "var(--ds-border-accent-gray, #7D818A)"
];
const $1ca59d92efd5b213$var$knownHighlightColors = $1ca59d92efd5b213$var$knownTextColors;
const $1ca59d92efd5b213$export$16ac295f28be8745 = (isSSRProductInDarkMode)=>{
    const { getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor } = (0, $19TyP.useDarkModeColors)(isSSRProductInDarkMode);
    return (0, $42omo.useMemo)(()=>{
        const backgroundColorMap = (0, $koWgP.createBuiltInColorMap)({
            knownColors: [
                ...$1ca59d92efd5b213$export$1ca6214429b36a67,
                ...$1ca59d92efd5b213$var$additionalBackgroundColors
            ],
            getResponsiveColor: (color)=>{
                return getDarkModeCompatibleBackgroundColor(color);
            }
        });
        const borderColorMap = (0, $koWgP.createBuiltInColorMap)({
            knownColors: $1ca59d92efd5b213$var$knownBorderColors
        });
        const textColorMap = (0, $koWgP.createBuiltInColorMap)({
            knownColors: $1ca59d92efd5b213$var$knownTextColors
        });
        const highlightColorMap = (0, $koWgP.createBuiltInColorMap)({
            knownColors: $1ca59d92efd5b213$var$knownHighlightColors
        });
        const emptyColorMap = (0, $koWgP.createBuiltInColorMap)({
            knownColors: []
        });
        return {
            backgroundColorMap: backgroundColorMap,
            borderColorMap: borderColorMap,
            textColorMap: textColorMap,
            highlightColorMap: highlightColorMap,
            emptyColorMap: emptyColorMap
        };
    }, [
        getDarkModeCompatibleBackgroundColor
    ]);
};
module.exports["knownBackgroundColors"] = $1ca59d92efd5b213$export$1ca6214429b36a67;
module.exports["getBackgroundHoveredColor"] = $1ca59d92efd5b213$export$4b7f6299a52ab6c0;
module.exports["useBuiltInColorMap"] = $1ca59d92efd5b213$export$16ac295f28be8745;

});

parcelRegister("fQWPs", function(module, exports) {

var $31mWx = parcelRequire("31mWx");

/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $8796cf7741d234da$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $8796cf7741d234da$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $8796cf7741d234da$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $8796cf7741d234da$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $8796cf7741d234da$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $8796cf7741d234da$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $8796cf7741d234da$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $8796cf7741d234da$var$isValidVarColor(color) {
    const matches = $8796cf7741d234da$var$VAR_MATCH.exec(color);
    if (matches) {
        const fallback = matches[3]?.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $8796cf7741d234da$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $8796cf7741d234da$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $8796cf7741d234da$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $8796cf7741d234da$var$isValidVarColor(color) || $8796cf7741d234da$var$SHORT_NUMERIC_MATCH.test(color) || $8796cf7741d234da$var$LONG_NUMERIC_MATCH.test(color) || $8796cf7741d234da$var$RGB_MATCH.test(color) || $8796cf7741d234da$var$PERC_MATCH.test(color) || $8796cf7741d234da$var$RGBA_MATCH.test(color) || $8796cf7741d234da$var$HSL_MATCH.test(color);
}
function $8796cf7741d234da$export$b2b344a3caf230bf(color) {
    if (!$8796cf7741d234da$export$35fa9d266cdb6f09(color)) return (0, $31mWx.default)('invalid');
    const colorCode = $8796cf7741d234da$var$extractColorCode(color);
    return (0, $31mWx.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $8796cf7741d234da$var$extractColorCode(color) {
    const matches = $8796cf7741d234da$var$VAR_MATCH.exec(color);
    if (matches) {
        const fallback = matches[3]?.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $8796cf7741d234da$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $8796cf7741d234da$export$5039139b891079e8(color = '') {
    const matches = $8796cf7741d234da$var$VAR_MATCH.exec(color);
    return matches?.[1].toLowerCase() ?? color;
}
function $8796cf7741d234da$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($8796cf7741d234da$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$8796cf7741d234da$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $8796cf7741d234da$export$342249704b28d862(color) {
    const converted = $8796cf7741d234da$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $8796cf7741d234da$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $8796cf7741d234da$var$extractColorCode(backgroundColor);
    const highlightCode = $8796cf7741d234da$var$extractColorCode(highlightColor);
    return (0, $31mWx.default).isReadable(backgroundCode, highlightCode);
}
function $8796cf7741d234da$export$21e0b327e0d86beb(color) {
    color = $8796cf7741d234da$var$extractColorCode(color);
    return (0, $31mWx.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $8796cf7741d234da$export$bf60f520e1f9cbf8(color1, color2) {
    return $8796cf7741d234da$var$extractColorCode(color1) === $8796cf7741d234da$var$extractColorCode(color2);
}
module.exports["isValidColor"] = $8796cf7741d234da$export$35fa9d266cdb6f09;
module.exports["convertLegacyColor"] = $8796cf7741d234da$export$b2b344a3caf230bf;
module.exports["extractToken"] = $8796cf7741d234da$export$5039139b891079e8;
module.exports["getSanitizedColor"] = $8796cf7741d234da$export$d16dc80c78f978b3;
module.exports["isReadable"] = $8796cf7741d234da$export$3fe5b5ca1e6a6a28;
module.exports["getMostReadableColor"] = $8796cf7741d234da$export$21e0b327e0d86beb;

});

parcelRegister("koWgP", function(module, exports) {

var $fQWPs = parcelRequire("fQWPs");


var $abHkh = parcelRequire("abHkh");

const $b434df0efd3417e7$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $abHkh.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $abHkh.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $abHkh.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $abHkh.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $abHkh.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $abHkh.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $abHkh.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $abHkh.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $abHkh.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $abHkh.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $abHkh.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $abHkh.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $abHkh.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $abHkh.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $abHkh.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $abHkh.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $abHkh.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $abHkh.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $abHkh.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $abHkh.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $abHkh.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $abHkh.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $abHkh.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $abHkh.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $abHkh.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $abHkh.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $abHkh.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $abHkh.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $abHkh.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $abHkh.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $abHkh.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $abHkh.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $abHkh.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $abHkh.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $abHkh.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $abHkh.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $abHkh.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $abHkh.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $abHkh.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $abHkh.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $abHkh.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $abHkh.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $abHkh.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $abHkh.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $abHkh.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $abHkh.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $abHkh.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $abHkh.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $abHkh.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $abHkh.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $abHkh.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $abHkh.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $abHkh.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $abHkh.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $abHkh.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $abHkh.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $abHkh.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $abHkh.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $abHkh.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $abHkh.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $abHkh.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $abHkh.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $abHkh.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $abHkh.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $abHkh.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $abHkh.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $abHkh.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $abHkh.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $abHkh.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $abHkh.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $abHkh.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $abHkh.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $abHkh.colorNames).gray
    ]
]);


const $40a0bd200326582f$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $fQWPs.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $fQWPs.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $b434df0efd3417e7$export$37744bda14f72c19).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $b434df0efd3417e7$export$37744bda14f72c19);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};
module.exports["createBuiltInColorMap"] = $40a0bd200326582f$export$a4af15b2fa34f34e;

});

parcelRegister("abHkh", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c8d2720d871df770$export$88bbe6beac980300 = (0, $cgtv4.defineMessages)({
    defaultWhite: {
        id: "company-hub.color-picker.default-white",
        defaultMessage: "Default white"
    },
    white: {
        id: "company-hub.color-picker.white",
        defaultMessage: "White"
    },
    lightGray: {
        id: "company-hub.color-picker.light-gray",
        defaultMessage: "Light gray"
    },
    lightBlue: {
        id: "company-hub.color-picker.light-blue",
        defaultMessage: "Light blue"
    },
    lightPurple: {
        id: "company-hub.color-picker.light-purple",
        defaultMessage: "Light purple"
    },
    lightMagenta: {
        id: "company-hub.color-picker.light-magenta",
        defaultMessage: "Light magenta"
    },
    lightRed: {
        id: "company-hub.color-picker.light-red",
        defaultMessage: "Light red"
    },
    lightOrange: {
        id: "company-hub.color-picker.light-orange",
        defaultMessage: "Light orange"
    },
    lightYellow: {
        id: "company-hub.color-picker.light-yellow",
        defaultMessage: "Light yellow"
    },
    lightLime: {
        id: "company-hub.color-picker.light-lime",
        defaultMessage: "Light lime"
    },
    lightGreen: {
        id: "company-hub.color-picker.light-green",
        defaultMessage: "Light green"
    },
    lightTeal: {
        id: "company-hub.color-picker.light-teal",
        defaultMessage: "Light teal"
    },
    subtleGray: {
        id: "company-hub.color-picker.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    subtleBlue: {
        id: "company-hub.color-picker.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    subtlePurple: {
        id: "company-hub.color-picker.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    subtleMagenta: {
        id: "company-hub.color-picker.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    subtleRed: {
        id: "company-hub.color-picker.subtle-red",
        defaultMessage: "Subtle red"
    },
    subtleOrange: {
        id: "company-hub.color-picker.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    subtleYellow: {
        id: "company-hub.color-picker.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    subtleLime: {
        id: "company-hub.color-picker.subtle-lime",
        defaultMessage: "Subtle lime"
    },
    subtleGreen: {
        id: "company-hub.color-picker.subtle-green",
        defaultMessage: "Subtle green"
    },
    subtleTeal: {
        id: "company-hub.color-picker.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    gray: {
        id: "company-hub.color-picker.gray",
        defaultMessage: "Gray"
    },
    blue: {
        id: "company-hub.color-picker.blue",
        defaultMessage: "Blue"
    },
    purple: {
        id: "company-hub.color-picker.purple",
        defaultMessage: "Purple"
    },
    magenta: {
        id: "company-hub.color-picker.magenta",
        defaultMessage: "Magenta"
    },
    red: {
        id: "company-hub.color-picker.red",
        defaultMessage: "Red"
    },
    orange: {
        id: "company-hub.color-picker.orange",
        defaultMessage: "Orange"
    },
    yellow: {
        id: "company-hub.color-picker.yellow",
        defaultMessage: "Yellow"
    },
    lime: {
        id: "company-hub.color-picker.lime",
        defaultMessage: "Lime"
    },
    green: {
        id: "company-hub.color-picker.green",
        defaultMessage: "Green"
    },
    teal: {
        id: "company-hub.color-picker.teal",
        defaultMessage: "Teal"
    },
    boldGray: {
        id: "company-hub.color-picker.bold-gray",
        defaultMessage: "Bold gray"
    },
    boldBlue: {
        id: "company-hub.color-picker.bold-blue",
        defaultMessage: "Bold blue"
    },
    boldPurple: {
        id: "company-hub.color-picker.bold-purple",
        defaultMessage: "Bold purple"
    },
    boldMagenta: {
        id: "company-hub.color-picker.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    boldRed: {
        id: "company-hub.color-picker.bold-red",
        defaultMessage: "Bold red"
    },
    boldOrange: {
        id: "company-hub.color-picker.bold-orange",
        defaultMessage: "Bold orange"
    },
    boldYellow: {
        id: "company-hub.color-picker.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    boldLime: {
        id: "company-hub.color-picker.bold-lime",
        defaultMessage: "Bold lime"
    },
    boldGreen: {
        id: "company-hub.color-picker.bold-green",
        defaultMessage: "Bold green"
    },
    boldTeal: {
        id: "company-hub.color-picker.bold-teal",
        defaultMessage: "Bold teal"
    },
    defaultBlue: {
        id: "company-hub.color-picker.default-blue",
        defaultMessage: "Default blue"
    }
});
module.exports["colorNames"] = $c8d2720d871df770$export$88bbe6beac980300;

});

parcelRegister("19TyP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1To4a = parcelRequire("1To4a");

var $cOrQJ = parcelRequire("cOrQJ");


var $fZitC = parcelRequire("fZitC");

const $ade17845e0ac479a$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $ade17845e0ac479a$var$TEXT_LIGHTNESS_MIN = 90;
const $ade17845e0ac479a$export$f11b6ab43332cfcf = (lightModeColor)=>{
    if (lightModeColor === '#FFFFFF') return (0, $1To4a.default)('elevation.surface.overlay', '#1D2125');
    else {
        const lightnessPercentage = (0, $fZitC.getLightnessPercentage)(lightModeColor);
        if (lightnessPercentage === undefined) return lightModeColor;
        return lightnessPercentage > $ade17845e0ac479a$var$BACKGROUND_LIGHTNESS_MAX ? (0, $fZitC.reduceLightness)(lightModeColor, $ade17845e0ac479a$var$BACKGROUND_LIGHTNESS_MAX) : lightModeColor;
    }
};
const $ade17845e0ac479a$export$c17d6b0d1b5d5ab6 = (isSSRProductInDarkMode)=>{
    const isSpaAkThemeInDarkMode = (0, $cOrQJ.default)().colorMode === 'dark';
    const shouldEvaluateLightness = isSpaAkThemeInDarkMode;
    const getDarkModeCompatibleBackgroundColor = (0, $42omo.useCallback)((backgroundColor)=>{
        return shouldEvaluateLightness ? $ade17845e0ac479a$export$f11b6ab43332cfcf(backgroundColor) : backgroundColor;
    }, [
        shouldEvaluateLightness
    ]);
    const getDarkModeCompatibleTextColor = (0, $42omo.useCallback)((textColor)=>{
        return shouldEvaluateLightness ? (0, $fZitC.increaseLightness)(textColor, $ade17845e0ac479a$var$TEXT_LIGHTNESS_MIN) : textColor;
    }, [
        shouldEvaluateLightness
    ]);
    return {
        shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
        getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor,
        getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor
    };
};
module.exports["useDarkModeColors"] = $ade17845e0ac479a$export$c17d6b0d1b5d5ab6;

});

parcelRegister("7q60U", function(module, exports) {
const $a5eaa64c2546cc45$export$9860c2f1456a166d = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    return editorActions.replaceSelection(updatedNodeSelection, true);
};
const $a5eaa64c2546cc45$export$39874bca494f9ba3 = (editorActions, nodeAdf)=>{
    return editorActions.replaceSelection(nodeAdf, true);
};
module.exports["updateNodeParameters"] = $a5eaa64c2546cc45$export$9860c2f1456a166d;
module.exports["replaceSelectedNode"] = $a5eaa64c2546cc45$export$39874bca494f9ba3;

});

parcelRegister("fcAaV", function(module, exports) {
const $c1ea6453cef5d97d$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};
module.exports["getExtensionManifest"] = $c1ea6453cef5d97d$export$573ee875a39e7e73;

});

parcelRegister("6r7Ix", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $6fjxX = parcelRequire("6fjxX");


var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $fOKpq = parcelRequire("fOKpq");


var $cgtv4 = parcelRequire("cgtv4");

const $d5107e637292572c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    shareFeedbackButtonTextExtension: {
        id: "company-hub.company-hub-common.config-panel.feedback-section.share-feedback-button.text-extension",
        defaultMessage: "{type, select, Cards {Give feedback on Cards} Carousel {Give feedback on Carousel} Linksmenu {Give feedback on Links menu} Spotlight {Give feedback on Spotlight} Section {Give feedback on Section} Customsearch {Give feedback on Custom Search} Companyhub {Give feedback on Company hub} other {Share your thoughts}}"
    },
    feedbackCollectorModalPreambleFirstLine: {
        id: "company-hub.company-hub-common.config-panel.feedback-collector.preamble.first-line",
        defaultMessage: "Your input is valuable and allows us to better meet your needs. What could be improved?"
    },
    feedbackCollectorModalSummaryPlaceholder: {
        id: "company-hub.company-hub-common.config-panel.feedback-collector.summary-placeholder",
        defaultMessage: "What works well? What could be improved?"
    },
    feedbackCollectorButtonPreamble: {
        id: "company-hub.company-hub-common.config-panel.feedback-section.preamble",
        defaultMessage: "Your feedback helps us improve."
    }
});


const $16ae89d10b8914a5$var$buttonContentWrapperStyles = (0, $ecnYn.xcss)({
    height: '20px'
});
const $16ae89d10b8914a5$var$buttonStyles = (0, $ecnYn.xcss)({
    width: '100%',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral.subtle',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    color: 'color.text',
    paddingInline: 'space.200',
    paddingBlock: 'space.050',
    alignItems: 'center',
    ':hover': {
        cursor: 'pointer',
        backgroundColor: 'color.background.accent.gray.subtlest.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtlest.pressed'
    }
});
const $16ae89d10b8914a5$export$266666366970ab01 = ({ source: source, type: type })=>{
    const { useFeedbackCollector: useFeedbackCollector } = (0, $fOKpq.useProductDependencies)();
    const openFeedbackCollector = useFeedbackCollector?.({
        source: source,
        type: type
    });
    // Feedback button won't render if it isn't provided in the product dependencies
    if (!useFeedbackCollector) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        xcss: $16ae89d10b8914a5$var$buttonStyles,
        onClick: openFeedbackCollector,
        testId: "feedback-collector-button",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.100",
            xcss: $16ae89d10b8914a5$var$buttonContentWrapperStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                    label: ""
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $d5107e637292572c$export$defe85febe8b728c).shareFeedbackButtonTextExtension,
                    values: {
                        type: type.replace(/\s/g, '')
                    }
                })
            ]
        })
    });
};
module.exports["ConfigPanelFeedbackCollector"] = $16ae89d10b8914a5$export$266666366970ab01;

});

parcelRegister("6UUyu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $1qfLF = parcelRequire("1qfLF");


var $dpPtd = parcelRequire("dpPtd");


var $hmuev = parcelRequire("hmuev");


var $5nBzc = parcelRequire("5nBzc");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $cgtv4 = parcelRequire("cgtv4");

const $acfac70e00e8ecae$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    close: {
        id: "company-hub-common.config-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    },
    newLozengeLabel: {
        id: "company-hub-common.config-panel.new-lozenge-label",
        defaultMessage: "NEW"
    }
});


const $4db84fd20afd4ac9$var$titleWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: '270px',
    paddingBlock: 'space.100'
});
const $4db84fd20afd4ac9$var$iconContainerStyles = (0, $ecnYn.xcss)({
    height: '40px',
    borderColor: 'color.border',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.small'
});
const $4db84fd20afd4ac9$var$closeIconWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'auto'
});
const $4db84fd20afd4ac9$var$containerStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $4db84fd20afd4ac9$export$e1b80720de5d513e = ({ title: title, icon: icon, children: children, footerComponent: footerComponent, buttonIcon: buttonIcon = null, shouldUseCardV2Styles: shouldUseCardV2Styles = false, closeConfigPanel: closeConfigPanel, lozenge: lozenge })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            columnGap: "space.300",
            justifyContent: "space-between",
            direction: "column",
            xcss: $4db84fd20afd4ac9$var$containerStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.300",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                            justifyContent: "start",
                            alignItems: "center",
                            gap: "space.100",
                            xcss: $4db84fd20afd4ac9$var$titleWrapperStyles,
                            children: [
                                buttonIcon,
                                icon && !shouldUseCardV2Styles && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    testId: "config-panel-icon",
                                    xcss: $4db84fd20afd4ac9$var$iconContainerStyles,
                                    children: icon
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                    size: "large",
                                    weight: shouldUseCardV2Styles ? 'medium' : 'bold',
                                    children: title
                                }),
                                !shouldUseCardV2Styles && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                        appearance: "new",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $acfac70e00e8ecae$export$defe85febe8b728c).newLozengeLabel
                                        })
                                    })
                                }),
                                lozenge && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                    alignItems: "center",
                                    children: lozenge
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                    xcss: $4db84fd20afd4ac9$var$closeIconWrapperStyles,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                        hideTooltipOnClick: true,
                                        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...(0, $acfac70e00e8ecae$export$defe85febe8b728c).close
                                        }),
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                            onClick: closeConfigPanel,
                                            appearance: "subtle",
                                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                                            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $acfac70e00e8ecae$export$defe85febe8b728c).close
                                            }),
                                            testId: "panel-close-button",
                                            isTooltipDisabled: false
                                        })
                                    })
                                })
                            ]
                        }),
                        children
                    ]
                }),
                footerComponent && footerComponent({})
            ]
        })
    });
};
module.exports["ExtensionsConfigWrapper"] = $4db84fd20afd4ac9$export$e1b80720de5d513e;

});

parcelRegister("3VS69", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");

const $7968be4e3aca5dcf$export$104752126b2ea779 = ({ feature: feature, children: children })=>{
    const { ConfigUpsellScreen: ConfigUpsellScreen } = (0, $fOKpq.useProductDependencies)();
    return ConfigUpsellScreen ? /*#__PURE__*/ (0, $l998X.jsx)(ConfigUpsellScreen, {
        feature: feature
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["PremiumGateForExtensionConfigPanel"] = $7968be4e3aca5dcf$export$104752126b2ea779;

});

parcelRegister("5n7dr", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $hgHrd = parcelRequire("hgHrd");








var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");




var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");




var $cla1z = parcelRequire("cla1z");


var $cgtv4 = parcelRequire("cgtv4");

const $417294d35dae9afa$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    triggerPrefixLabel: {
        id: "company-hub.color-picker.trigger.prefix.label",
        defaultMessage: "color"
    },
    triggerPostfixLabel: {
        id: "company-hub.color-picker.trigger.postfix.label",
        defaultMessage: "trigger"
    }
});





parcelRequire("42omo");


var $5gydP = parcelRequire("5gydP");






const $3c2fb3b83ece6521$var$barStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    left: 'space.0',
    right: 'space.0',
    top: '18px',
    margin: 'auto',
    width: "var(--ds-space-200, 16px)",
    height: '3px'
});
const $3c2fb3b83ece6521$var$textColorIconWrapper = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $3c2fb3b83ece6521$export$36ed63fbff8ebdac = ({ selectedColor: selectedColor, isSelected: isSelected = false, testId: testId, isDisabled: isDisabled })=>{
    let textColor = isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        testId: testId,
        xcss: $3c2fb3b83ece6521$var$textColorIconWrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
                label: "",
                spacing: "spacious",
                color: textColor
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                style: {
                    background: isDisabled ? "var(--ds-background-disabled, #17171708)" : selectedColor
                },
                xcss: $3c2fb3b83ece6521$var$barStyles
            })
        ]
    });
};


const $3be2a185a087f146$var$triggerStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    transition: 'background 0.1s ease-out',
    borderRadius: 'radius.small',
    padding: 'space.100',
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.overlay.pressed'
    }
});
const $3be2a185a087f146$var$selectedButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    borderColor: 'color.border.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $3be2a185a087f146$var$borderLessStyle = (0, $ecnYn.xcss)({
    border: 'none'
});
const $3be2a185a087f146$var$fullWidthStyle = (0, $ecnYn.xcss)({
    width: '240px'
});
const $3be2a185a087f146$var$iconOnlyStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050'
});
const $3be2a185a087f146$var$triggerContentStyles = (0, $ecnYn.xcss)({
    alignItems: 'center'
});
const $3be2a185a087f146$var$iconOnlyContentStyles = (0, $ecnYn.xcss)({
    gap: 'space.100'
});
const $3be2a185a087f146$var$fullWidthContentStyles = (0, $ecnYn.xcss)({
    gap: 'space.075'
});
const $3be2a185a087f146$var$colorLabelStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    display: 'inline-block',
    flex: '1 0 0',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $3be2a185a087f146$export$b76ce78c787fa4d2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ builtInColorMap: builtInColorMap, value: value, analyticsSource: analyticsSource, pickerTitle: pickerTitle, isFullWidth: isFullWidth = false, showTextIcon: showTextIcon = false, enableBorderLessStyle: enableBorderLessStyle = false, isDisabled: isDisabled = false, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const colorName = builtInColorMap.humanReadableColors.get(value);
    const size = !isFullWidth ? '16' : '24';
    const spacing = !isFullWidth ? 'none' : 'spacious';
    const padding = size === '16' ? 'space.050' : 'space.0';
    const isOpen = props['aria-expanded'];
    const label = `${formatMessage(pickerTitle || (0, $417294d35dae9afa$export$defe85febe8b728c).triggerPrefixLabel)} ${formatMessage((0, $417294d35dae9afa$export$defe85febe8b728c).triggerPostfixLabel)}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        ...props,
        "aria-label": label,
        title: label,
        isDisabled: isDisabled,
        "aria-disabled": isDisabled,
        ref: ref,
        xcss: [
            $3be2a185a087f146$var$triggerStyles,
            isFullWidth ? $3be2a185a087f146$var$fullWidthStyle : $3be2a185a087f146$var$iconOnlyStyle,
            isOpen && $3be2a185a087f146$var$selectedButtonStyles,
            enableBorderLessStyle && $3be2a185a087f146$var$borderLessStyle
        ],
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            xcss: [
                $3be2a185a087f146$var$triggerContentStyles,
                isFullWidth ? $3be2a185a087f146$var$fullWidthContentStyles : $3be2a185a087f146$var$iconOnlyContentStyles
            ],
            children: [
                showTextIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3c2fb3b83ece6521$export$36ed63fbff8ebdac), {
                    testId: "color-picker-trigger-text-icon",
                    selectedColor: value,
                    isSelected: isOpen,
                    isDisabled: isDisabled
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    padding: padding,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cla1z.ColorTile), {
                        testId: "color-picker-trigger-color-tile",
                        size: size,
                        builtInColorMap: builtInColorMap,
                        value: value
                    })
                }),
                isFullWidth && /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    xcss: $3be2a185a087f146$var$colorLabelStyles,
                    children: colorName ? formatMessage(colorName) : value.toUpperCase()
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($3be2a185a087f146$var$ExpandCollapseIcon, {
                    spacing: spacing,
                    isExpanded: isOpen,
                    isDisabled: isDisabled
                })
            ]
        })
    });
});
const $3be2a185a087f146$var$iconContainerStyles = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $3be2a185a087f146$var$chevronPaddingStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.050'
});
const $3be2a185a087f146$var$ExpandCollapseIcon = ({ isExpanded: isExpanded = false, spacing: spacing, isDisabled: isDisabled })=>{
    let textColor = isExpanded ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtle, #505258)";
    if (isDisabled) textColor = "var(--ds-text-disabled, #080F214A)";
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $3be2a185a087f146$var$iconContainerStyles,
            spacing === 'none' && $3be2a185a087f146$var$chevronPaddingStyles
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            spacing: spacing,
            label: "",
            color: textColor,
            size: "small"
        })
    });
};


const $1299ce75afa40b46$var$popupComponentStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    padding: 'space.150'
});
const $1299ce75afa40b46$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'data-testid': testId, ...props }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: testId,
        ...props,
        ref: ref,
        xcss: $1299ce75afa40b46$var$popupComponentStyles
    }));
const $1299ce75afa40b46$export$9feb1bc2e5f1ccb3 = ({ builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, value: value, isFullWidth: isFullWidth, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: showResetButton, showTextIcon: showTextIcon, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, analyticsSource: analyticsSource, isDisabled: isDisabled = false, showCloseButton: showCloseButton = false, enableBorderLessStyle: enableBorderLessStyle = false, isOpen: isOpen = false })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPopupClose = ()=>setIsPopupOpen(false);
    const onTriggerClick = (0, $42omo.useCallback)(()=>{
        if (analyticsSource && !isPopupOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'colorPickerOpened',
                source: analyticsSource
            }
        }).fire();
        setIsPopupOpen((prev)=>!prev);
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isPopupOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        autoFocus: false,
        content: (contentProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hgHrd.ColorPickerDropdown), {
                ...contentProps,
                analyticsSource: analyticsSource,
                builtInColorMap: builtInColorMap,
                isReadableColor: isReadableColor,
                onChange: onChange,
                value: value,
                pickerTitle: pickerTitle,
                showCustomPalette: showCustomPalette,
                showResetButton: showResetButton,
                validationSuccessMessage: validationSuccessMessage,
                validationFailMessage: validationFailMessage,
                showCloseButton: showCloseButton
            }),
        isOpen: isPopupOpen,
        onClose: onPopupClose,
        placement: "bottom-end",
        fallbackPlacements: [
            'left-start'
        ],
        testId: "color-picker-popup",
        popupComponent: $1299ce75afa40b46$var$PopupComponent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3be2a185a087f146$export$b76ce78c787fa4d2), {
                ...triggerProps,
                builtInColorMap: builtInColorMap,
                onClick: onTriggerClick,
                value: value,
                isDisabled: isDisabled,
                analyticsSource: analyticsSource,
                isFullWidth: isFullWidth,
                showTextIcon: showTextIcon,
                pickerTitle: pickerTitle,
                enableBorderLessStyle: enableBorderLessStyle
            })
    });
};
module.exports["ColorPicker"] = $1299ce75afa40b46$export$9feb1bc2e5f1ccb3;

});

parcelRegister("hgHrd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");


var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $4OyNx = parcelRequire("4OyNx");










var $8C5kA = parcelRequire("8C5kA");


var $31mWx = parcelRequire("31mWx");





var $bfgIy = parcelRequire("bfgIy");


var $6f0Oj = parcelRequire("6f0Oj");








var $6T8v4 = parcelRequire("6T8v4");


var $fQWPs = parcelRequire("fQWPs");




parcelRequire("42omo");


var $7rxjP = parcelRequire("7rxjP");





var $inPa6 = parcelRequire("inPa6");






const $dd7a712c596b977a$var$saturationStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    height: '137px',
    position: 'relative',
    width: '100%'
});
const $dd7a712c596b977a$var$hueStyles = (0, $ecnYn.xcss)({
    cursor: 'pointer',
    height: '8px',
    position: 'relative',
    width: '100%'
});
const $dd7a712c596b977a$export$9fe2579179d7c943 = ({ analyticsSource: analyticsSource, value: value, onChange: onChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hsl = value.toHsl();
    const hsv = value.toHsv();
    const onHueOrSaturationChange = (color)=>{
        onChange((0, $31mWx.default)(color).toHexString());
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'CustomColor',
                actionSubjectId: 'customPalette',
                source: analyticsSource
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $dd7a712c596b977a$var$saturationStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rxjP.Saturation), {
                    hsl: hsl,
                    hsv: hsv,
                    onChange: onHueOrSaturationChange,
                    pointer: $dd7a712c596b977a$var$EllipsePointer,
                    radius: "4px"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $dd7a712c596b977a$var$hueStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rxjP.Hue), {
                    direction: "horizontal",
                    hsl: hsl,
                    onChange: onHueOrSaturationChange,
                    pointer: $dd7a712c596b977a$var$EllipsePointer,
                    radius: "100px"
                })
            })
        ]
    });
};
const $dd7a712c596b977a$var$pointerStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width-selected, 2px)"} solid white`,
    borderRadius: 'radius.full',
    cursor: 'pointer',
    height: '8px',
    width: '8px'
});
const $dd7a712c596b977a$var$EllipsePointer = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $dd7a712c596b977a$var$pointerStyles
    });

















var $4noo5 = parcelRequire("4noo5");


var $cla1z = parcelRequire("cla1z");

const $a5969ac228965698$var$colorTileContainerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    paddingLeft: 'space.100'
});
const $a5969ac228965698$export$5a1d7ca0a925d9c2 = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, children: children, id: id, name: name, onChange: onChange, value: value })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    value = value.toLowerCase();
    const onTextFieldChange = (0, $42omo.useCallback)((event)=>{
        onChange(event.currentTarget.value.toLowerCase());
    }, [
        onChange
    ]);
    const onTextFieldFocus = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'CustomColor',
                actionSubjectId: 'customPalette',
                source: analyticsSource
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
        id: id,
        name: name,
        elemAfterInput: children,
        elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            xcss: $a5969ac228965698$var$colorTileContainerStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cla1z.ColorTile), {
                builtInColorMap: builtInColorMap,
                value: value
            })
        }),
        onChange: onTextFieldChange,
        onFocus: onTextFieldFocus,
        value: value.toUpperCase()
    });
};



var $cgtv4 = parcelRequire("cgtv4");

const $62d26d0325515dc8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    addButtonText: {
        id: "company-hub.color-picker.custom-palette.add-button-text",
        defaultMessage: "Add"
    },
    colorCodeSelectorLabel: {
        id: "company-hub.color-picker.custom-palette.color-code-selector-label",
        defaultMessage: "Color format"
    },
    colorInputLabel: {
        id: "company-hub.color-picker.custom-palette.color-input-label",
        defaultMessage: "Color value"
    }
});


const $de09622bf0be3140$var$containerStyles = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    gap: 'space.100',
    width: '292px'
});
const $de09622bf0be3140$var$addButtonContainerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    paddingRight: 'space.100'
});
const $de09622bf0be3140$var$COLOR_CODE_OPTIONS = [
    {
        label: 'Hex',
        value: '#'
    },
    {
        label: 'RGB',
        value: 'rgb'
    },
    {
        label: 'HSL',
        value: 'hsl'
    }
];
const $de09622bf0be3140$export$cd12f2785bdbccdb = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, customColorRef: customColorRef, onChange: onChange, onSelectColor: onSelectColor, value: value })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [colorToBeAdded, setColorToBeAdded] = (0, $42omo.useState)(value);
    (0, $42omo.useEffect)(()=>{
        setColorToBeAdded(value);
    }, [
        value
    ]);
    (0, $42omo.useEffect)(()=>{
        onSelectColor?.(colorToBeAdded);
    }, [
        colorToBeAdded,
        onSelectColor
    ]);
    const convertedValue = (0, $fQWPs.convertLegacyColor)(value);
    const convertedColorToBeAdded = (0, $fQWPs.convertLegacyColor)(colorToBeAdded);
    const isColorToBeAddedValid = convertedColorToBeAdded.isValid();
    const colorForHueAndSaturation = isColorToBeAddedValid ? convertedColorToBeAdded : convertedValue;
    //
    // Add button
    //
    /* isColorStaged: either the color is already staged, saved, or of default Atlassian theme
   * isColorInCurated: custom color is already elevated as one of eight default tiles in Curated palette
   * isTokenizedColorInCurated: custom color is already elevated as first of nine default tiles in Curated palette. The first of nine is a placeholder for custom color.
   */ const isColorStaged = colorToBeAdded === value;
    const isColorInCurated = builtInColorMap.knownTokens.includes((0, $fQWPs.extractToken)(colorToBeAdded));
    const isTokenizedColorInCurated = (0, $fQWPs.extractToken)(customColorRef.current) === (0, $fQWPs.extractToken)(colorToBeAdded);
    const isAddButtonDisabled = !isColorToBeAddedValid || isColorStaged || isColorInCurated || isTokenizedColorInCurated;
    const onAddClick = ()=>{
        if (isColorToBeAddedValid) {
            const sanitizedColor = (0, $fQWPs.getSanitizedColor)(builtInColorMap, colorToBeAdded);
            onChange(sanitizedColor);
        }
    };
    const getColorCode = (color)=>{
        if (color.startsWith('rgb')) return $de09622bf0be3140$var$COLOR_CODE_OPTIONS[1];
        if (color.startsWith('hsl')) return $de09622bf0be3140$var$COLOR_CODE_OPTIONS[2];
        return $de09622bf0be3140$var$COLOR_CODE_OPTIONS[0];
    };
    const [selectedColorCode, setSelectedColorCode] = (0, $42omo.useState)(getColorCode(value));
    (0, $42omo.useEffect)(()=>{
        setSelectedColorCode(getColorCode(colorToBeAdded));
    }, [
        colorToBeAdded
    ]);
    const onHueAndSaturationChange = (0, $42omo.useCallback)((color)=>{
        if (selectedColorCode?.value === 'rgb') setColorToBeAdded((0, $31mWx.default)(color).toRgbString());
        else if (selectedColorCode?.value === 'hsl') setColorToBeAdded((0, $31mWx.default)(color).toHslString());
        else setColorToBeAdded(color);
    }, [
        selectedColorCode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        xcss: $de09622bf0be3140$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $dd7a712c596b977a$export$9fe2579179d7c943), {
                analyticsSource: analyticsSource,
                onChange: onHueAndSaturationChange,
                value: colorForHueAndSaturation
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                        label: formatMessage((0, $62d26d0325515dc8$export$defe85febe8b728c).colorCodeSelectorLabel),
                        classNamePrefix: "AkSelect",
                        id: "color-code-selector",
                        inputId: "color-code-selector-input",
                        options: $de09622bf0be3140$var$COLOR_CODE_OPTIONS,
                        value: selectedColorCode,
                        onChange: setSelectedColorCode
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: "color-input",
                        children: formatMessage((0, $62d26d0325515dc8$export$defe85febe8b728c).colorInputLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
                        space: "space.100",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5969ac228965698$export$5a1d7ca0a925d9c2), {
                            id: "color-input",
                            name: "color-input",
                            analyticsSource: analyticsSource,
                            builtInColorMap: builtInColorMap,
                            onChange: (color = '')=>setColorToBeAdded(color),
                            value: colorToBeAdded,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                                xcss: $de09622bf0be3140$var$addButtonContainerStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                    isDisabled: isAddButtonDisabled,
                                    onClick: onAddClick,
                                    spacing: "compact",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $62d26d0325515dc8$export$defe85febe8b728c).addButtonText
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};





const $4114e70cea25a986$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    closeButtonLabel: {
        id: "company-hub.color-picker.color-picker-dropdown.close-button-label",
        defaultMessage: "Close"
    },
    headerText: {
        id: "company-hub.color-picker.color-picker-dropdown.header-text",
        defaultMessage: "Select a color"
    },
    resetButtonText: {
        id: "company-hub.color-picker.color-picker-dropdown.reset-button-text",
        defaultMessage: "Reset to default"
    }
});





parcelRequire("42omo");





var $gQhRa = parcelRequire("gQhRa");







const $46524bc88c524af2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    confirmationMessage: {
        id: "company-hub.color-picker.color-validation-messages.confirmation-message",
        defaultMessage: "Color selection added"
    },
    errorMessage: {
        id: "company-hub.color-picker.color-validation-messages.error-message",
        defaultMessage: "Enter a valid color"
    },
    contrastRatioPassMessage: {
        id: "company-hub.color-picker.color-validation-messages.contrast-ratio-pass-message",
        defaultMessage: "Passes accessibility standards"
    },
    contrastRatioFailMessage: {
        id: "company-hub.color-picker.color-validation-messages.contrast-ratio-fail-message",
        defaultMessage: "Does not pass accessibility standards"
    }
});


const $80610772aae89619$export$66fe3ef300963542 = ({ selectedColor: selectedColor, isReadableColor: isReadableColor, showConfirmation: showConfirmation, preSelectedColor: preSelectedColor, validationFailMessage: validationFailMessage, validationSuccessMessage: validationSuccessMessage })=>{
    const convertedColor = (0, $fQWPs.convertLegacyColor)(selectedColor);
    const isInvalid = !convertedColor.isValid();
    if (isInvalid || !preSelectedColor) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $46524bc88c524af2$export$defe85febe8b728c).errorMessage
        })
    });
    if (showConfirmation) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ValidMessage), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $46524bc88c524af2$export$defe85febe8b728c).confirmationMessage
        })
    });
    if (isReadableColor) {
        if (isReadableColor(selectedColor)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ValidMessage), {
            children: validationSuccessMessage || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $46524bc88c524af2$export$defe85febe8b728c).contrastRatioPassMessage
            })
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
            children: validationFailMessage || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $46524bc88c524af2$export$defe85febe8b728c).contrastRatioFailMessage
            })
        });
    }
    return null;
};


const $e0f3bb7f752e79fd$var$containerStyles = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    gap: 'space.200',
    width: '292px'
});
const $e0f3bb7f752e79fd$var$headerStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    alignSelf: 'stretch',
    justifyContent: 'space-between'
});
const $e0f3bb7f752e79fd$var$resetButtonStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050'
});
const $e0f3bb7f752e79fd$export$bce475685b0e6f7c = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isReadableColor: isReadableColor, onChange: onChange, onClose: onClose, value: value, pickerTitle: pickerTitle, showCustomPalette: showCustomPalette, showResetButton: showResetButton = false, showCloseButton: showCloseButton = false, validationSuccessMessage: validationSuccessMessage, validationFailMessage: validationFailMessage, enableBorderLessStyle: enableBorderLessStyle = false, ...props })=>{
    const [showConfirmation, setShowConfirmation] = (0, $42omo.useState)(false);
    const [preSelectedColor, setPreSelectedColor] = (0, $42omo.useState)(value);
    const customColorRef = (0, $42omo.useRef)();
    const onCuratedColorSelect = (0, $42omo.useCallback)((color)=>{
        onChange(color);
        setPreSelectedColor(color);
    }, [
        onChange
    ]);
    const onPreSelectCustomColor = (0, $42omo.useCallback)((color)=>{
        setPreSelectedColor(color);
        setShowConfirmation(false);
    }, [
        setPreSelectedColor,
        setShowConfirmation
    ]);
    const onAddCustomColor = (0, $42omo.useCallback)((color)=>{
        onChange(color);
        setPreSelectedColor(color);
        setShowConfirmation(true);
    }, [
        onChange
    ]);
    const onResetClick = (0, $42omo.useCallback)(()=>{
        onChange(undefined);
        setShowConfirmation(false);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        ...props,
        xcss: $e0f3bb7f752e79fd$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                        xcss: $e0f3bb7f752e79fd$var$headerStyles,
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text",
                                size: "small",
                                weight: "bold",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...pickerTitle || (0, $4114e70cea25a986$export$defe85febe8b728c).headerText
                                })
                            }),
                            showCloseButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                appearance: "subtle",
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #292A2E)"
                                    }),
                                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $4114e70cea25a986$export$defe85febe8b728c).closeButtonLabel
                                }),
                                onClick: onClose,
                                spacing: "compact"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4OyNx.CuratedPalette), {
                        analyticsSource: analyticsSource,
                        builtInColorMap: builtInColorMap,
                        customColorRef: customColorRef,
                        onChange: onCuratedColorSelect,
                        value: value
                    }),
                    showCustomPalette && /*#__PURE__*/ (0, $l998X.jsx)((0, $de09622bf0be3140$export$cd12f2785bdbccdb), {
                        analyticsSource: analyticsSource,
                        builtInColorMap: builtInColorMap,
                        customColorRef: customColorRef,
                        onChange: onAddCustomColor,
                        onSelectColor: onPreSelectCustomColor,
                        value: value
                    }),
                    (isReadableColor || showCustomPalette) && /*#__PURE__*/ (0, $l998X.jsx)((0, $80610772aae89619$export$66fe3ef300963542), {
                        selectedColor: showCustomPalette ? preSelectedColor || value : value,
                        preSelectedColor: preSelectedColor,
                        showConfirmation: showConfirmation,
                        isReadableColor: isReadableColor,
                        validationSuccessMessage: validationSuccessMessage,
                        validationFailMessage: validationFailMessage
                    })
                ]
            }),
            showResetButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                alignItems: "end",
                xcss: $e0f3bb7f752e79fd$var$resetButtonStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    onClick: onResetClick,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $4114e70cea25a986$export$defe85febe8b728c).resetButtonText
                    })
                })
            })
        ]
    });
};
module.exports["ColorPickerDropdown"] = $e0f3bb7f752e79fd$export$bce475685b0e6f7c;

});

parcelRegister("4OyNx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $cvXh8 = parcelRequire("cvXh8");




parcelRequire("42omo");


var $gZTYb = parcelRequire("gZTYb");

/**
 * __ZoomIn__
 *
 * Will over zoom an element into position.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $87260b878377f345$var$ZoomIn = ({ children: children, duration: duration = 'small', isPaused: isPaused, onFinish: onFinish })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gZTYb.default), {
        duration: duration,
        enteringAnimation: "zoom-in",
        exitingAnimation: "zoom-out",
        animationTimingFunction: "ease-in-out",
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $87260b878377f345$export$2e2bcd8739ae039 = $87260b878377f345$var$ZoomIn;



var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $cla1z = parcelRequire("cla1z");


var $fQWPs = parcelRequire("fQWPs");


var $cgtv4 = parcelRequire("cgtv4");

const $9c4c05dd86b57022$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    checkIconLabel: {
        id: "company-hub.color-picker.pressable-color-tile.check-icon-label",
        defaultMessage: "Selected"
    }
});


const $9fbcd9e044ebaafb$var$checkIconContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute'
});
const $9fbcd9e044ebaafb$var$pressableStyles = (0, $ecnYn.xcss)({
    background: 'none',
    alignItems: 'center',
    display: 'flex',
    height: '24px',
    justifyContent: 'center',
    width: '24px'
});
const $9fbcd9e044ebaafb$export$7efe82073e3977ee = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, isSelected: isSelected, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onPressableClick = ()=>{
        onChange(value);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'SelectItem',
                actionSubjectId: 'curatedPalette',
                source: analyticsSource
            }
        }).fire();
    };
    const colorName = builtInColorMap.humanReadableColors.get(value);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2W0qg.default), {
        "aria-pressed": isSelected,
        onClick: onPressableClick,
        xcss: $9fbcd9e044ebaafb$var$pressableStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cla1z.ColorTile), {
                        builtInColorMap: builtInColorMap,
                        value: value
                    }),
                    isSelected && /*#__PURE__*/ (0, $l998X.jsx)((0, $87260b878377f345$export$2e2bcd8739ae039), {
                        children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                ...props,
                                xcss: $9fbcd9e044ebaafb$var$checkIconContainerStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                                    label: formatMessage((0, $9c4c05dd86b57022$export$defe85febe8b728c).checkIconLabel),
                                    color: (0, $fQWPs.getMostReadableColor)(value),
                                    spacing: "spacious"
                                })
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: colorName ? formatMessage(colorName) : value
            })
        ]
    });
};


const $aa110a33b9076cb9$export$2d5c37fc2a13c79c = 10;
function $aa110a33b9076cb9$var$getColorsPerRowFromPalette(colors) {
    return colors.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / $aa110a33b9076cb9$export$2d5c37fc2a13c79c);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
const $aa110a33b9076cb9$export$7076a6e7211abb82 = ({ analyticsSource: analyticsSource, builtInColorMap: builtInColorMap, customColorRef: customColorRef, onChange: onChange, value: value })=>{
    const { knownColors: knownColors } = builtInColorMap;
    // lowercasing value here since all knownColors are lowercased to support legacy colors
    value = value.toLowerCase();
    if (!knownColors.includes(value)) customColorRef.current = value;
    const customColor = customColorRef.current;
    let colors = knownColors;
    if (customColor && !colors.includes(customColor)) {
        if (colors.length >= $aa110a33b9076cb9$export$2d5c37fc2a13c79c) colors = [
            ...knownColors,
            customColor
        ];
        else colors = [
            customColor,
            ...knownColors
        ];
    }
    const colorTiles = colors.map((color)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $9fbcd9e044ebaafb$export$7efe82073e3977ee), {
            analyticsSource: analyticsSource,
            builtInColorMap: builtInColorMap,
            isSelected: color === value,
            onChange: onChange,
            value: color
        }, color));
    const colorTilesMap = $aa110a33b9076cb9$var$getColorsPerRowFromPalette(colorTiles);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        space: "space.075",
        children: colorTilesMap.map((rowColors, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                space: "space.075",
                testId: `curated-palette-row-${index}`,
                children: rowColors
            }, `curated-palette-row-${index}-key`))
    });
};
module.exports["CuratedPalette"] = $aa110a33b9076cb9$export$7076a6e7211abb82;

});

parcelRegister("j7yqm", function(module, exports) {

var $8tFmL = parcelRequire("8tFmL");

var $e5f7c1f3c542be74$exports = {};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e5f7c1f3c542be74$var$stubFalse() {
    return false;
}
$e5f7c1f3c542be74$exports = $e5f7c1f3c542be74$var$stubFalse;


/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8tFmL.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $e5f7c1f3c542be74$exports;
module.exports = isBuffer;

});

parcelRegister("llRc8", function(module, exports) {

var $fEGkT = parcelRequire("fEGkT");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $fEGkT.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("cZKRB", function(module, exports) {

var $8tFmL = parcelRequire("8tFmL");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8tFmL.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("hhJJH", function(module, exports) {

var $lHZjR = parcelRequire("lHZjR");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $lHZjR.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("b0TBZ", function(module, exports) {

var $lHZjR = parcelRequire("lHZjR");

var $6113f5ea850d43a9$exports = {};
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6113f5ea850d43a9$var$stubFalse() {
    return false;
}
$6113f5ea850d43a9$exports = $6113f5ea850d43a9$var$stubFalse;


/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $lHZjR.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $6113f5ea850d43a9$exports;
module.exports = isBuffer;

});

parcelRegister("baAzW", function(module, exports) {

var $7ZxIG = parcelRequire("7ZxIG");

/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $7ZxIG.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("6N7Vt", function(module, exports) {
var $03fdd00253d41446$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $03fdd00253d41446$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$03fdd00253d41446$exports = $03fdd00253d41446$var$arrayEach;


var $2e3fc99380f546ad$exports = {};
var $a83be1b15ef27b11$exports = {};

var $4SKGa = parcelRequire("4SKGa");

var $a7f5f4ab67a12e38$exports = {};

var $7BwDL = parcelRequire("7BwDL");

var $e2cbdbe7e9368bb7$exports = {};

var $p2YZ9 = parcelRequire("p2YZ9");

var $37110de7d2c368cd$exports = {};

var $2M85Y = parcelRequire("2M85Y");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $37110de7d2c368cd$var$nativeKeys = $2M85Y(Object.keys, Object);
$37110de7d2c368cd$exports = $37110de7d2c368cd$var$nativeKeys;


/** Used for built-in method references. */ var $e2cbdbe7e9368bb7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e2cbdbe7e9368bb7$var$hasOwnProperty = $e2cbdbe7e9368bb7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e2cbdbe7e9368bb7$var$baseKeys(object) {
    if (!$p2YZ9(object)) return $37110de7d2c368cd$exports(object);
    var result = [];
    for(var key in Object(object))if ($e2cbdbe7e9368bb7$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$e2cbdbe7e9368bb7$exports = $e2cbdbe7e9368bb7$var$baseKeys;



var $1tRgx = parcelRequire("1tRgx");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $a7f5f4ab67a12e38$var$keys(object) {
    return $1tRgx(object) ? $7BwDL(object) : $e2cbdbe7e9368bb7$exports(object);
}
$a7f5f4ab67a12e38$exports = $a7f5f4ab67a12e38$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $a83be1b15ef27b11$var$baseForOwn(object, iteratee) {
    return object && $4SKGa(object, iteratee, $a7f5f4ab67a12e38$exports);
}
$a83be1b15ef27b11$exports = $a83be1b15ef27b11$var$baseForOwn;


var $f8490a251ebfd5da$exports = {};



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f8490a251ebfd5da$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$1tRgx(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$f8490a251ebfd5da$exports = $f8490a251ebfd5da$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $2e3fc99380f546ad$var$baseEach = $f8490a251ebfd5da$exports($a83be1b15ef27b11$exports);
$2e3fc99380f546ad$exports = $2e3fc99380f546ad$var$baseEach;


var $800bcbde1f5195ff$exports = {};

var $g6oan = parcelRequire("g6oan");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $800bcbde1f5195ff$var$castFunction(value) {
    return typeof value == 'function' ? value : $g6oan;
}
$800bcbde1f5195ff$exports = $800bcbde1f5195ff$var$castFunction;



var $23IbN = parcelRequire("23IbN");

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $4f1d77a41b5ccd9c$var$forEach(collection, iteratee) {
    var func = $23IbN(collection) ? $03fdd00253d41446$exports : $2e3fc99380f546ad$exports;
    return func(collection, $800bcbde1f5195ff$exports(iteratee));
}
module.exports = $4f1d77a41b5ccd9c$var$forEach;

});

parcelRegister("kO1Y5", function(module, exports) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleFocus = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var _react2 = _interopRequireDefault($42omo);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint-disable no-invalid-this */ 
var handleFocus = exports.handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, _react2.default.createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }(_react2.default.Component);
};

});

parcelRegister("4K9rx", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $95d65816892f601e$var$svgStyles = null;
const $95d65816892f601e$export$d094da8d87fa1043 = ({ color: color, label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        height: "16px",
        width: "16px",
        style: {
            color: color ?? "var(--ds-text, #292A2E)"
        },
        "aria-label": label || undefined,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.5714 0H6.8571C3.07 0 0 3.07 0 6.8571V8.5714H2.5714V6.8571C2.5714 4.4902 4.4902 2.5714 6.8571 2.5714H8.5714V0ZM8.5714 21.4286H6.8571C4.4902 21.4286 2.5714 19.5098 2.5714 17.1429V15.4286H0V17.1429C0 20.9299 3.07 24 6.8571 24H8.5714V21.4286ZM15.4286 24V21.4286H17.1429C19.5098 21.4286 21.4286 19.5098 21.4286 17.1429V15.4286H24V17.1429C24 20.9299 20.9299 24 17.1429 24H15.4286ZM15.4286 2.5714V0H17.1429C20.9299 0 24 3.07 24 6.8571V8.5714H21.4286V6.8571C21.4286 4.4902 19.5098 2.5714 17.1429 2.5714H15.4286Z",
            fill: "currentColor"
        })
    });
};
module.exports["RoundCornerIcon"] = $95d65816892f601e$export$d094da8d87fa1043;

});

parcelRegister("4VyWY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $fa4a18a3a4cde342$var$svgStyles = null;
const $fa4a18a3a4cde342$export$5853d29f01a5c20 = ({ color: color, label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        viewBox: "0 0 24 24",
        height: "16px",
        width: "16px",
        style: {
            color: color ?? "var(--ds-text, #292A2E)"
        },
        "aria-label": label || undefined,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 2H9V4.25H3.75V9.5H1.5V4.25 2H3.75ZM1.5 15.5V20.75 23H3.75 9V20.75H3.75V15.5H1.5ZM20.25 15.5V20.75H15V23H20.25 22.5V20.75 15.5H20.25ZM22.5 9.5V4.25 2H20.25 15V4.25H20.25V9.5H22.5Z"
        })
    });
};
module.exports["SharpCornerIcon"] = $fa4a18a3a4cde342$export$5853d29f01a5c20;

});

parcelRegister("31mWx", function(module, exports) {
// This file is autogenerated. It's used to publish ESM to npm.
function $2333431a2f7377f1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2333431a2f7377f1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2333431a2f7377f1$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $2333431a2f7377f1$var$trimLeft = /^\s+/;
var $2333431a2f7377f1$var$trimRight = /\s+$/;
function $2333431a2f7377f1$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $2333431a2f7377f1$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $2333431a2f7377f1$export$2e2bcd8739ae039)) return new $2333431a2f7377f1$export$2e2bcd8739ae039(color, opts);
    var rgb = $2333431a2f7377f1$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$2333431a2f7377f1$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $2333431a2f7377f1$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $2333431a2f7377f1$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $2333431a2f7377f1$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $2333431a2f7377f1$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $2333431a2f7377f1$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $2333431a2f7377f1$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $2333431a2f7377f1$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($2333431a2f7377f1$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($2333431a2f7377f1$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($2333431a2f7377f1$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($2333431a2f7377f1$var$bound01(this._r, 255) * 100) + "%, " + Math.round($2333431a2f7377f1$var$bound01(this._g, 255) * 100) + "%, " + Math.round($2333431a2f7377f1$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($2333431a2f7377f1$var$bound01(this._r, 255) * 100) + "%, " + Math.round($2333431a2f7377f1$var$bound01(this._g, 255) * 100) + "%, " + Math.round($2333431a2f7377f1$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $2333431a2f7377f1$var$hexNames[$2333431a2f7377f1$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $2333431a2f7377f1$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $2333431a2f7377f1$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $2333431a2f7377f1$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $2333431a2f7377f1$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($2333431a2f7377f1$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($2333431a2f7377f1$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($2333431a2f7377f1$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($2333431a2f7377f1$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($2333431a2f7377f1$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($2333431a2f7377f1$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($2333431a2f7377f1$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($2333431a2f7377f1$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($2333431a2f7377f1$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($2333431a2f7377f1$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($2333431a2f7377f1$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($2333431a2f7377f1$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($2333431a2f7377f1$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$2333431a2f7377f1$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($2333431a2f7377f1$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $2333431a2f7377f1$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $2333431a2f7377f1$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $2333431a2f7377f1$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $2333431a2f7377f1$var$stringInputToObject(color);
    if ($2333431a2f7377f1$var$_typeof(color) == "object") {
        if ($2333431a2f7377f1$var$isValidCSSUnit(color.r) && $2333431a2f7377f1$var$isValidCSSUnit(color.g) && $2333431a2f7377f1$var$isValidCSSUnit(color.b)) {
            rgb = $2333431a2f7377f1$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($2333431a2f7377f1$var$isValidCSSUnit(color.h) && $2333431a2f7377f1$var$isValidCSSUnit(color.s) && $2333431a2f7377f1$var$isValidCSSUnit(color.v)) {
            s = $2333431a2f7377f1$var$convertToPercentage(color.s);
            v = $2333431a2f7377f1$var$convertToPercentage(color.v);
            rgb = $2333431a2f7377f1$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($2333431a2f7377f1$var$isValidCSSUnit(color.h) && $2333431a2f7377f1$var$isValidCSSUnit(color.s) && $2333431a2f7377f1$var$isValidCSSUnit(color.l)) {
            s = $2333431a2f7377f1$var$convertToPercentage(color.s);
            l = $2333431a2f7377f1$var$convertToPercentage(color.l);
            rgb = $2333431a2f7377f1$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $2333431a2f7377f1$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $2333431a2f7377f1$var$rgbToRgb(r, g, b) {
    return {
        r: $2333431a2f7377f1$var$bound01(r, 255) * 255,
        g: $2333431a2f7377f1$var$bound01(g, 255) * 255,
        b: $2333431a2f7377f1$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $2333431a2f7377f1$var$rgbToHsl(r, g, b) {
    r = $2333431a2f7377f1$var$bound01(r, 255);
    g = $2333431a2f7377f1$var$bound01(g, 255);
    b = $2333431a2f7377f1$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $2333431a2f7377f1$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $2333431a2f7377f1$var$bound01(h, 360);
    s = $2333431a2f7377f1$var$bound01(s, 100);
    l = $2333431a2f7377f1$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $2333431a2f7377f1$var$rgbToHsv(r, g, b) {
    r = $2333431a2f7377f1$var$bound01(r, 255);
    g = $2333431a2f7377f1$var$bound01(g, 255);
    b = $2333431a2f7377f1$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $2333431a2f7377f1$var$hsvToRgb(h, s, v) {
    h = $2333431a2f7377f1$var$bound01(h, 360) * 6;
    s = $2333431a2f7377f1$var$bound01(s, 100);
    v = $2333431a2f7377f1$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $2333431a2f7377f1$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $2333431a2f7377f1$var$pad2(Math.round(r).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(g).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $2333431a2f7377f1$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $2333431a2f7377f1$var$pad2(Math.round(r).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(g).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(b).toString(16)),
        $2333431a2f7377f1$var$pad2($2333431a2f7377f1$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $2333431a2f7377f1$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $2333431a2f7377f1$var$pad2($2333431a2f7377f1$var$convertDecimalToHex(a)),
        $2333431a2f7377f1$var$pad2(Math.round(r).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(g).toString(16)),
        $2333431a2f7377f1$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$2333431a2f7377f1$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $2333431a2f7377f1$export$2e2bcd8739ae039(color1).toRgbString() == $2333431a2f7377f1$export$2e2bcd8739ae039(color2).toRgbString();
};
$2333431a2f7377f1$export$2e2bcd8739ae039.random = function() {
    return $2333431a2f7377f1$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $2333431a2f7377f1$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $2333431a2f7377f1$var$clamp01(hsl.s);
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
function $2333431a2f7377f1$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $2333431a2f7377f1$var$clamp01(hsl.s);
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
function $2333431a2f7377f1$var$_greyscale(color) {
    return $2333431a2f7377f1$export$2e2bcd8739ae039(color).desaturate(100);
}
function $2333431a2f7377f1$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $2333431a2f7377f1$var$clamp01(hsl.l);
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
function $2333431a2f7377f1$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $2333431a2f7377f1$export$2e2bcd8739ae039(rgb);
}
function $2333431a2f7377f1$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $2333431a2f7377f1$var$clamp01(hsl.l);
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $2333431a2f7377f1$var$_spin(color, amount) {
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $2333431a2f7377f1$var$_complement(color) {
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $2333431a2f7377f1$export$2e2bcd8739ae039(hsl);
}
function $2333431a2f7377f1$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $2333431a2f7377f1$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($2333431a2f7377f1$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $2333431a2f7377f1$var$_splitcomplement(color) {
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $2333431a2f7377f1$export$2e2bcd8739ae039(color),
        $2333431a2f7377f1$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $2333431a2f7377f1$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $2333431a2f7377f1$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $2333431a2f7377f1$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($2333431a2f7377f1$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $2333431a2f7377f1$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $2333431a2f7377f1$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($2333431a2f7377f1$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$2333431a2f7377f1$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $2333431a2f7377f1$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $2333431a2f7377f1$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $2333431a2f7377f1$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$2333431a2f7377f1$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $2333431a2f7377f1$export$2e2bcd8739ae039(color1);
    var c2 = $2333431a2f7377f1$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$2333431a2f7377f1$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $2333431a2f7377f1$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $2333431a2f7377f1$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$2333431a2f7377f1$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $2333431a2f7377f1$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $2333431a2f7377f1$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($2333431a2f7377f1$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $2333431a2f7377f1$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $2333431a2f7377f1$var$names = $2333431a2f7377f1$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $2333431a2f7377f1$var$hexNames = $2333431a2f7377f1$export$2e2bcd8739ae039.hexNames = $2333431a2f7377f1$var$flip($2333431a2f7377f1$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $2333431a2f7377f1$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $2333431a2f7377f1$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $2333431a2f7377f1$var$bound01(n, max) {
    if ($2333431a2f7377f1$var$isOnePointZero(n)) n = "100%";
    var processPercent = $2333431a2f7377f1$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $2333431a2f7377f1$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $2333431a2f7377f1$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $2333431a2f7377f1$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $2333431a2f7377f1$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $2333431a2f7377f1$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $2333431a2f7377f1$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $2333431a2f7377f1$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $2333431a2f7377f1$var$convertHexToDecimal(h) {
    return $2333431a2f7377f1$var$parseIntFromHex(h) / 255;
}
var $2333431a2f7377f1$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $2333431a2f7377f1$var$isValidCSSUnit(color) {
    return !!$2333431a2f7377f1$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $2333431a2f7377f1$var$stringInputToObject(color) {
    color = color.replace($2333431a2f7377f1$var$trimLeft, "").replace($2333431a2f7377f1$var$trimRight, "").toLowerCase();
    var named = false;
    if ($2333431a2f7377f1$var$names[color]) {
        color = $2333431a2f7377f1$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $2333431a2f7377f1$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $2333431a2f7377f1$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $2333431a2f7377f1$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $2333431a2f7377f1$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $2333431a2f7377f1$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $2333431a2f7377f1$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $2333431a2f7377f1$var$matchers.hex8.exec(color)) return {
        r: $2333431a2f7377f1$var$parseIntFromHex(match[1]),
        g: $2333431a2f7377f1$var$parseIntFromHex(match[2]),
        b: $2333431a2f7377f1$var$parseIntFromHex(match[3]),
        a: $2333431a2f7377f1$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $2333431a2f7377f1$var$matchers.hex6.exec(color)) return {
        r: $2333431a2f7377f1$var$parseIntFromHex(match[1]),
        g: $2333431a2f7377f1$var$parseIntFromHex(match[2]),
        b: $2333431a2f7377f1$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $2333431a2f7377f1$var$matchers.hex4.exec(color)) return {
        r: $2333431a2f7377f1$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $2333431a2f7377f1$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $2333431a2f7377f1$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $2333431a2f7377f1$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $2333431a2f7377f1$var$matchers.hex3.exec(color)) return {
        r: $2333431a2f7377f1$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $2333431a2f7377f1$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $2333431a2f7377f1$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $2333431a2f7377f1$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}
module.exports["default"] = $2333431a2f7377f1$export$2e2bcd8739ae039;

});

parcelRegister("7rxjP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c7Odh = parcelRequire("c7Odh");

Object.defineProperty(module.exports, 'Alpha', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($c7Odh).default;
    }
});

var $30RJX = parcelRequire("30RJX");

Object.defineProperty(module.exports, 'Checkboard', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($30RJX).default;
    }
});

var $5rF4J = parcelRequire("5rF4J");

Object.defineProperty(module.exports, 'EditableInput', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($5rF4J).default;
    }
});

var $7jhT0 = parcelRequire("7jhT0");

Object.defineProperty(module.exports, 'Hue', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($7jhT0).default;
    }
});

var $eUXsL = parcelRequire("eUXsL");

Object.defineProperty(module.exports, 'Raised', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($eUXsL).default;
    }
});

var $3FOwJ = parcelRequire("3FOwJ");

Object.defineProperty(module.exports, 'Saturation', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($3FOwJ).default;
    }
});

var $8umxE = parcelRequire("8umxE");

Object.defineProperty(module.exports, 'ColorWrap', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($8umxE).default;
    }
});

var $k4noF = parcelRequire("k4noF");

Object.defineProperty(module.exports, 'Swatch', {
    enumerable: true,
    get: function get() {
        return $016603b78b501c2b$var$_interopRequireDefault($k4noF).default;
    }
});
function $016603b78b501c2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});

parcelRegister("cla1z", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $fQWPs = parcelRequire("fQWPs");

const $1bb5dc695464bed5$var$colorTileStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $1bb5dc695464bed5$export$2640496e4bfb3b8c = ({ builtInColorMap: builtInColorMap, value: value, size: size = '24', testId: testId })=>{
    value = (0, $fQWPs.isValidColor)(value) ? builtInColorMap.getResponsiveColor(value) : "var(--ds-surface-overlay, #FFFFFF)";
    size = `${size}px`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: testId ?? 'color-tile',
        xcss: $1bb5dc695464bed5$var$colorTileStyles,
        style: {
            backgroundColor: value,
            height: size,
            width: size
        }
    });
};
module.exports["ColorTile"] = $1bb5dc695464bed5$export$2640496e4bfb3b8c;

});

parcelRegister("fEGkT", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $b65b6e7e3441707a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $b65b6e7e3441707a$var$freeGlobal;

});

parcelRegister("8tFmL", function(module, exports) {

var $fEGkT = parcelRequire("fEGkT");

/** Detect free variable `self`. */ var $62c11e9b05a71c3d$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $62c11e9b05a71c3d$var$root = $fEGkT || $62c11e9b05a71c3d$var$freeSelf || Function('return this')();
module.exports = $62c11e9b05a71c3d$var$root;

});

parcelRegister("lHZjR", function(module, exports) {

var $7ZxIG = parcelRequire("7ZxIG");

/** Detect free variable `self`. */ var $fcdd2de2c541c0c4$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $fcdd2de2c541c0c4$var$root = $7ZxIG || $fcdd2de2c541c0c4$var$freeSelf || Function('return this')();
module.exports = $fcdd2de2c541c0c4$var$root;

});

parcelRegister("7ZxIG", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $5d1862f07be18c28$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $5d1862f07be18c28$var$freeGlobal;

});

parcelRegister("c7Odh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Alpha = undefined;
var $8d3d16c610280f79$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8d3d16c610280f79$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $8d3d16c610280f79$var$_react2 = $8d3d16c610280f79$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $8d3d16c610280f79$var$_reactcss2 = $8d3d16c610280f79$var$_interopRequireDefault($RqPIr);

var $lH0bc = parcelRequire("lH0bc");

var $8d3d16c610280f79$var$alpha = $8d3d16c610280f79$var$_interopRequireWildcard($lH0bc);

var $30RJX = parcelRequire("30RJX");

var $8d3d16c610280f79$var$_Checkboard2 = $8d3d16c610280f79$var$_interopRequireDefault($30RJX);
function $8d3d16c610280f79$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $8d3d16c610280f79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d3d16c610280f79$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8d3d16c610280f79$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8d3d16c610280f79$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8d3d16c610280f79$var$Alpha = module.exports.Alpha = function(_ref) {
    $8d3d16c610280f79$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $8d3d16c610280f79$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $8d3d16c610280f79$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $8d3d16c610280f79$var$alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), $8d3d16c610280f79$var$_possibleConstructorReturn(_this, _ret);
    }
    $8d3d16c610280f79$var$_createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, $8d3d16c610280f79$var$_reactcss2.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': $8d3d16c610280f79$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.alpha
                }, $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.checkboard
                }, $8d3d16c610280f79$var$_react2.default.createElement($8d3d16c610280f79$var$_Checkboard2.default, {
                    renderers: this.props.renderers
                })), $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.gradient
                }), $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $8d3d16c610280f79$var$_react2.default.createElement(this.props.pointer, this.props) : $8d3d16c610280f79$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}($42omo.PureComponent || $42omo.Component);
module.exports.default = $8d3d16c610280f79$var$Alpha;

});

parcelRegister("30RJX", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Checkboard = undefined;
var $231b0edb0f66b116$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $42omo = parcelRequire("42omo");

var $231b0edb0f66b116$var$_react2 = $231b0edb0f66b116$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $231b0edb0f66b116$var$_reactcss2 = $231b0edb0f66b116$var$_interopRequireDefault($RqPIr);

var $5cc5D = parcelRequire("5cc5D");

var $231b0edb0f66b116$var$checkboard = $231b0edb0f66b116$var$_interopRequireWildcard($5cc5D);
function $231b0edb0f66b116$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $231b0edb0f66b116$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $231b0edb0f66b116$var$Checkboard = module.exports.Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, $231b0edb0f66b116$var$_reactcss2.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + $231b0edb0f66b116$var$checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, $42omo.isValidElement)(children) ? $231b0edb0f66b116$var$_react2.default.cloneElement(children, $231b0edb0f66b116$var$_extends({}, children.props, {
        style: $231b0edb0f66b116$var$_extends({}, children.props.style, styles.grid)
    })) : $231b0edb0f66b116$var$_react2.default.createElement('div', {
        style: styles.grid
    });
};
$231b0edb0f66b116$var$Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
module.exports.default = $231b0edb0f66b116$var$Checkboard;

});

parcelRegister("5rF4J", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EditableInput = undefined;
var $3f6f56101263a271$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $3f6f56101263a271$var$_react2 = $3f6f56101263a271$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $3f6f56101263a271$var$_reactcss2 = $3f6f56101263a271$var$_interopRequireDefault($RqPIr);
function $3f6f56101263a271$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f6f56101263a271$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f6f56101263a271$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3f6f56101263a271$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3f6f56101263a271$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3f6f56101263a271$var$DEFAULT_ARROW_OFFSET = 1;
var $3f6f56101263a271$var$UP_KEY_CODE = 38;
var $3f6f56101263a271$var$DOWN_KEY_CODE = 40;
var $3f6f56101263a271$var$VALID_KEY_CODES = [
    $3f6f56101263a271$var$UP_KEY_CODE,
    $3f6f56101263a271$var$DOWN_KEY_CODE
];
var $3f6f56101263a271$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $3f6f56101263a271$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $3f6f56101263a271$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var $3f6f56101263a271$var$idCounter = 1;
var $3f6f56101263a271$var$EditableInput = module.exports.EditableInput = function(_ref) {
    $3f6f56101263a271$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $3f6f56101263a271$var$_classCallCheck(this, EditableInput);
        var _this = $3f6f56101263a271$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $3f6f56101263a271$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $3f6f56101263a271$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $3f6f56101263a271$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + $3f6f56101263a271$var$idCounter++;
        return _this;
    }
    $3f6f56101263a271$var$_createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return $3f6f56101263a271$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || $3f6f56101263a271$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, $3f6f56101263a271$var$_reactcss2.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return $3f6f56101263a271$var$_react2.default.createElement('div', {
                    style: styles.wrap
                }, $3f6f56101263a271$var$_react2.default.createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? $3f6f56101263a271$var$_react2.default.createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}($42omo.PureComponent || $42omo.Component);
module.exports.default = $3f6f56101263a271$var$EditableInput;

});

parcelRegister("7jhT0", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hue = undefined;
var $55282e9943f07e68$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $55282e9943f07e68$var$_react2 = $55282e9943f07e68$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $55282e9943f07e68$var$_reactcss2 = $55282e9943f07e68$var$_interopRequireDefault($RqPIr);

var $1Zih2 = parcelRequire("1Zih2");

var $55282e9943f07e68$var$hue = $55282e9943f07e68$var$_interopRequireWildcard($1Zih2);
function $55282e9943f07e68$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $55282e9943f07e68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55282e9943f07e68$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $55282e9943f07e68$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $55282e9943f07e68$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $55282e9943f07e68$var$Hue = module.exports.Hue = function(_ref) {
    $55282e9943f07e68$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $55282e9943f07e68$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $55282e9943f07e68$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $55282e9943f07e68$var$hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $55282e9943f07e68$var$_possibleConstructorReturn(_this, _ret);
    }
    $55282e9943f07e68$var$_createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, $55282e9943f07e68$var$_reactcss2.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return $55282e9943f07e68$var$_react2.default.createElement('div', {
                    style: styles.hue
                }, $55282e9943f07e68$var$_react2.default.createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $55282e9943f07e68$var$_react2.default.createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), $55282e9943f07e68$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $55282e9943f07e68$var$_react2.default.createElement(this.props.pointer, this.props) : $55282e9943f07e68$var$_react2.default.createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}($42omo.PureComponent || $42omo.Component);
module.exports.default = $55282e9943f07e68$var$Hue;

});

parcelRegister("eUXsL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Raised = undefined;

var $42omo = parcelRequire("42omo");

var $adc46bbe7f7c9584$var$_react2 = $adc46bbe7f7c9584$var$_interopRequireDefault($42omo);

var $4xcIM = parcelRequire("4xcIM");

var $adc46bbe7f7c9584$var$_propTypes2 = $adc46bbe7f7c9584$var$_interopRequireDefault($4xcIM);

var $RqPIr = parcelRequire("RqPIr");

var $adc46bbe7f7c9584$var$_reactcss2 = $adc46bbe7f7c9584$var$_interopRequireDefault($RqPIr);
var $3b3ba6283598aa39$exports = {};
var $b0d9cacc6a1d9e19$exports = {};
var $719c999f233dca91$exports = {};
var $7425221bcb3ccaf1$exports = {};
var $ef16738a8309ada7$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $ef16738a8309ada7$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$ef16738a8309ada7$exports = $ef16738a8309ada7$var$listCacheClear;


var $fb9c1823604419ee$exports = {};
var $4a5fd3c1e1159199$exports = {};
var $60548ee52cee8593$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $60548ee52cee8593$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$60548ee52cee8593$exports = $60548ee52cee8593$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4a5fd3c1e1159199$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($60548ee52cee8593$exports(array[length][0], key)) return length;
    }
    return -1;
}
$4a5fd3c1e1159199$exports = $4a5fd3c1e1159199$var$assocIndexOf;


/** Used for built-in method references. */ var $fb9c1823604419ee$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $fb9c1823604419ee$var$splice = $fb9c1823604419ee$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fb9c1823604419ee$var$listCacheDelete(key) {
    var data = this.__data__, index = $4a5fd3c1e1159199$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $fb9c1823604419ee$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$fb9c1823604419ee$exports = $fb9c1823604419ee$var$listCacheDelete;


var $79050f1c695fd3ad$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $79050f1c695fd3ad$var$listCacheGet(key) {
    var data = this.__data__, index = $4a5fd3c1e1159199$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$79050f1c695fd3ad$exports = $79050f1c695fd3ad$var$listCacheGet;


var $5b2af085743fcb24$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5b2af085743fcb24$var$listCacheHas(key) {
    return $4a5fd3c1e1159199$exports(this.__data__, key) > -1;
}
$5b2af085743fcb24$exports = $5b2af085743fcb24$var$listCacheHas;


var $ec45f2c4f885bb22$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ec45f2c4f885bb22$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4a5fd3c1e1159199$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$ec45f2c4f885bb22$exports = $ec45f2c4f885bb22$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7425221bcb3ccaf1$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$7425221bcb3ccaf1$var$ListCache.prototype.clear = $ef16738a8309ada7$exports;
$7425221bcb3ccaf1$var$ListCache.prototype['delete'] = $fb9c1823604419ee$exports;
$7425221bcb3ccaf1$var$ListCache.prototype.get = $79050f1c695fd3ad$exports;
$7425221bcb3ccaf1$var$ListCache.prototype.has = $5b2af085743fcb24$exports;
$7425221bcb3ccaf1$var$ListCache.prototype.set = $ec45f2c4f885bb22$exports;
$7425221bcb3ccaf1$exports = $7425221bcb3ccaf1$var$ListCache;


var $1f79c942752139ef$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $1f79c942752139ef$var$stackClear() {
    this.__data__ = new $7425221bcb3ccaf1$exports;
    this.size = 0;
}
$1f79c942752139ef$exports = $1f79c942752139ef$var$stackClear;


var $7adc21f91d8b06e6$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $7adc21f91d8b06e6$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$7adc21f91d8b06e6$exports = $7adc21f91d8b06e6$var$stackDelete;


var $c61be17ee7e1793b$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c61be17ee7e1793b$var$stackGet(key) {
    return this.__data__.get(key);
}
$c61be17ee7e1793b$exports = $c61be17ee7e1793b$var$stackGet;


var $53ab57f0f36e70be$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $53ab57f0f36e70be$var$stackHas(key) {
    return this.__data__.has(key);
}
$53ab57f0f36e70be$exports = $53ab57f0f36e70be$var$stackHas;


var $3097e79911666f71$exports = {};

var $b74df6206a4433c6$exports = {};
var $7091b699574b4379$exports = {};
var $7ec82b1f40decf69$exports = {};

var $22zFL = parcelRequire("22zFL");

var $79985998dffcec77$exports = {};
var $8ac3736d74b11b70$exports = {};

var $lHZjR = parcelRequire("lHZjR");

/** Used to detect overreaching core-js shims. */ var $8ac3736d74b11b70$var$coreJsData = $lHZjR["__core-js_shared__"];
$8ac3736d74b11b70$exports = $8ac3736d74b11b70$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $79985998dffcec77$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($8ac3736d74b11b70$exports && $8ac3736d74b11b70$exports.keys && $8ac3736d74b11b70$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $79985998dffcec77$var$isMasked(func) {
    return !!$79985998dffcec77$var$maskSrcKey && $79985998dffcec77$var$maskSrcKey in func;
}
$79985998dffcec77$exports = $79985998dffcec77$var$isMasked;



var $b5U5s = parcelRequire("b5U5s");

var $e7c8c57107c86977$exports = {};
/** Used for built-in method references. */ var $e7c8c57107c86977$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $e7c8c57107c86977$var$funcToString = $e7c8c57107c86977$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $e7c8c57107c86977$var$toSource(func) {
    if (func != null) {
        try {
            return $e7c8c57107c86977$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$e7c8c57107c86977$exports = $e7c8c57107c86977$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7ec82b1f40decf69$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $7ec82b1f40decf69$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $7ec82b1f40decf69$var$funcProto = Function.prototype, $7ec82b1f40decf69$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7ec82b1f40decf69$var$funcToString = $7ec82b1f40decf69$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7ec82b1f40decf69$var$hasOwnProperty = $7ec82b1f40decf69$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $7ec82b1f40decf69$var$reIsNative = RegExp('^' + $7ec82b1f40decf69$var$funcToString.call($7ec82b1f40decf69$var$hasOwnProperty).replace($7ec82b1f40decf69$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7ec82b1f40decf69$var$baseIsNative(value) {
    if (!$b5U5s(value) || $79985998dffcec77$exports(value)) return false;
    var pattern = $22zFL(value) ? $7ec82b1f40decf69$var$reIsNative : $7ec82b1f40decf69$var$reIsHostCtor;
    return pattern.test($e7c8c57107c86977$exports(value));
}
$7ec82b1f40decf69$exports = $7ec82b1f40decf69$var$baseIsNative;


var $80c45a566806a143$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $80c45a566806a143$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$80c45a566806a143$exports = $80c45a566806a143$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7091b699574b4379$var$getNative(object, key) {
    var value = $80c45a566806a143$exports(object, key);
    return $7ec82b1f40decf69$exports(value) ? value : undefined;
}
$7091b699574b4379$exports = $7091b699574b4379$var$getNative;





/* Built-in method references that are verified to be native. */ var $b74df6206a4433c6$var$Map = $7091b699574b4379$exports($lHZjR, 'Map');
$b74df6206a4433c6$exports = $b74df6206a4433c6$var$Map;


var $761309d9a32eea86$exports = {};
var $75bb629fbc87032a$exports = {};
var $bd9f3c5bb634b833$exports = {};
var $0677767db496a87e$exports = {};
var $70ce06b0a43585e8$exports = {};

/* Built-in method references that are verified to be native. */ var $70ce06b0a43585e8$var$nativeCreate = $7091b699574b4379$exports(Object, 'create');
$70ce06b0a43585e8$exports = $70ce06b0a43585e8$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $0677767db496a87e$var$hashClear() {
    this.__data__ = $70ce06b0a43585e8$exports ? $70ce06b0a43585e8$exports(null) : {};
    this.size = 0;
}
$0677767db496a87e$exports = $0677767db496a87e$var$hashClear;


var $22ebc42af993b927$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $22ebc42af993b927$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$22ebc42af993b927$exports = $22ebc42af993b927$var$hashDelete;


var $990e8f5915c56edc$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $990e8f5915c56edc$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $990e8f5915c56edc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $990e8f5915c56edc$var$hasOwnProperty = $990e8f5915c56edc$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $990e8f5915c56edc$var$hashGet(key) {
    var data = this.__data__;
    if ($70ce06b0a43585e8$exports) {
        var result = data[key];
        return result === $990e8f5915c56edc$var$HASH_UNDEFINED ? undefined : result;
    }
    return $990e8f5915c56edc$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$990e8f5915c56edc$exports = $990e8f5915c56edc$var$hashGet;


var $c49a6fa50d6d3af7$exports = {};

/** Used for built-in method references. */ var $c49a6fa50d6d3af7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c49a6fa50d6d3af7$var$hasOwnProperty = $c49a6fa50d6d3af7$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c49a6fa50d6d3af7$var$hashHas(key) {
    var data = this.__data__;
    return $70ce06b0a43585e8$exports ? data[key] !== undefined : $c49a6fa50d6d3af7$var$hasOwnProperty.call(data, key);
}
$c49a6fa50d6d3af7$exports = $c49a6fa50d6d3af7$var$hashHas;


var $ac40e401b589fb2e$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $ac40e401b589fb2e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ac40e401b589fb2e$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $70ce06b0a43585e8$exports && value === undefined ? $ac40e401b589fb2e$var$HASH_UNDEFINED : value;
    return this;
}
$ac40e401b589fb2e$exports = $ac40e401b589fb2e$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bd9f3c5bb634b833$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$bd9f3c5bb634b833$var$Hash.prototype.clear = $0677767db496a87e$exports;
$bd9f3c5bb634b833$var$Hash.prototype['delete'] = $22ebc42af993b927$exports;
$bd9f3c5bb634b833$var$Hash.prototype.get = $990e8f5915c56edc$exports;
$bd9f3c5bb634b833$var$Hash.prototype.has = $c49a6fa50d6d3af7$exports;
$bd9f3c5bb634b833$var$Hash.prototype.set = $ac40e401b589fb2e$exports;
$bd9f3c5bb634b833$exports = $bd9f3c5bb634b833$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $75bb629fbc87032a$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $bd9f3c5bb634b833$exports,
        'map': new ($b74df6206a4433c6$exports || $7425221bcb3ccaf1$exports),
        'string': new $bd9f3c5bb634b833$exports
    };
}
$75bb629fbc87032a$exports = $75bb629fbc87032a$var$mapCacheClear;


var $e3d534da4d485945$exports = {};
var $1fabd46bdc97e8e5$exports = {};
var $52a8154accd2f592$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $52a8154accd2f592$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$52a8154accd2f592$exports = $52a8154accd2f592$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $1fabd46bdc97e8e5$var$getMapData(map, key) {
    var data = map.__data__;
    return $52a8154accd2f592$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$1fabd46bdc97e8e5$exports = $1fabd46bdc97e8e5$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e3d534da4d485945$var$mapCacheDelete(key) {
    var result = $1fabd46bdc97e8e5$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$e3d534da4d485945$exports = $e3d534da4d485945$var$mapCacheDelete;


var $c22f2be6ab6e6ec0$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $c22f2be6ab6e6ec0$var$mapCacheGet(key) {
    return $1fabd46bdc97e8e5$exports(this, key).get(key);
}
$c22f2be6ab6e6ec0$exports = $c22f2be6ab6e6ec0$var$mapCacheGet;


var $665f9277c3cc0335$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $665f9277c3cc0335$var$mapCacheHas(key) {
    return $1fabd46bdc97e8e5$exports(this, key).has(key);
}
$665f9277c3cc0335$exports = $665f9277c3cc0335$var$mapCacheHas;


var $9dc9f4a82a3d7095$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $9dc9f4a82a3d7095$var$mapCacheSet(key, value) {
    var data = $1fabd46bdc97e8e5$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$9dc9f4a82a3d7095$exports = $9dc9f4a82a3d7095$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $761309d9a32eea86$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$761309d9a32eea86$var$MapCache.prototype.clear = $75bb629fbc87032a$exports;
$761309d9a32eea86$var$MapCache.prototype['delete'] = $e3d534da4d485945$exports;
$761309d9a32eea86$var$MapCache.prototype.get = $c22f2be6ab6e6ec0$exports;
$761309d9a32eea86$var$MapCache.prototype.has = $665f9277c3cc0335$exports;
$761309d9a32eea86$var$MapCache.prototype.set = $9dc9f4a82a3d7095$exports;
$761309d9a32eea86$exports = $761309d9a32eea86$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $3097e79911666f71$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $3097e79911666f71$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $7425221bcb3ccaf1$exports) {
        var pairs = data.__data__;
        if (!$b74df6206a4433c6$exports || pairs.length < $3097e79911666f71$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $761309d9a32eea86$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$3097e79911666f71$exports = $3097e79911666f71$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $719c999f233dca91$var$Stack(entries) {
    var data = this.__data__ = new $7425221bcb3ccaf1$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$719c999f233dca91$var$Stack.prototype.clear = $1f79c942752139ef$exports;
$719c999f233dca91$var$Stack.prototype['delete'] = $7adc21f91d8b06e6$exports;
$719c999f233dca91$var$Stack.prototype.get = $c61be17ee7e1793b$exports;
$719c999f233dca91$var$Stack.prototype.has = $53ab57f0f36e70be$exports;
$719c999f233dca91$var$Stack.prototype.set = $3097e79911666f71$exports;
$719c999f233dca91$exports = $719c999f233dca91$var$Stack;


var $7f1b6bd1cb999493$exports = {};
var $d1c896f271e3839f$exports = {};
var $e7ba1fa13f388db0$exports = {};

var $e7ba1fa13f388db0$var$defineProperty = function() {
    try {
        var func = $7091b699574b4379$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$e7ba1fa13f388db0$exports = $e7ba1fa13f388db0$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d1c896f271e3839f$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $e7ba1fa13f388db0$exports) $e7ba1fa13f388db0$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$d1c896f271e3839f$exports = $d1c896f271e3839f$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7f1b6bd1cb999493$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$60548ee52cee8593$exports(object[key], value) || value === undefined && !(key in object)) $d1c896f271e3839f$exports(object, key, value);
}
$7f1b6bd1cb999493$exports = $7f1b6bd1cb999493$var$assignMergeValue;



var $4SKGa = parcelRequire("4SKGa");

var $e3f412ce3c2323b7$exports = {};


var $hhJJH = parcelRequire("hhJJH");

var $899ecb974c02a929$exports = {};
var $a5b01f6a9650f304$exports = {};
var $cda56191d3b95a95$exports = {};



/** Built-in value references. */ var $cda56191d3b95a95$var$Uint8Array = $lHZjR.Uint8Array;
$cda56191d3b95a95$exports = $cda56191d3b95a95$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $a5b01f6a9650f304$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $cda56191d3b95a95$exports(result).set(new $cda56191d3b95a95$exports(arrayBuffer));
    return result;
}
$a5b01f6a9650f304$exports = $a5b01f6a9650f304$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $899ecb974c02a929$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $a5b01f6a9650f304$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$899ecb974c02a929$exports = $899ecb974c02a929$var$cloneTypedArray;


var $ffb3186abb951e5e$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $ffb3186abb951e5e$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$ffb3186abb951e5e$exports = $ffb3186abb951e5e$var$copyArray;


var $ac1f4cf2d68e9613$exports = {};
var $9bc188779b3b3d33$exports = {};



/** Built-in value references. */ var $9bc188779b3b3d33$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $9bc188779b3b3d33$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$b5U5s(proto)) return {};
        if ($9bc188779b3b3d33$var$objectCreate) return $9bc188779b3b3d33$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$9bc188779b3b3d33$exports = $9bc188779b3b3d33$var$baseCreate;


var $374fce4b0670c33a$exports = {};

var $2M85Y = parcelRequire("2M85Y");

/** Built-in value references. */ var $374fce4b0670c33a$var$getPrototype = $2M85Y(Object.getPrototypeOf, Object);
$374fce4b0670c33a$exports = $374fce4b0670c33a$var$getPrototype;



var $p2YZ9 = parcelRequire("p2YZ9");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ac1f4cf2d68e9613$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$p2YZ9(object) ? $9bc188779b3b3d33$exports($374fce4b0670c33a$exports(object)) : {};
}
$ac1f4cf2d68e9613$exports = $ac1f4cf2d68e9613$var$initCloneObject;



var $kxqKq = parcelRequire("kxqKq");


var $23IbN = parcelRequire("23IbN");

var $0db411e0fcb2712d$exports = {};

var $1tRgx = parcelRequire("1tRgx");


var $pARw7 = parcelRequire("pARw7");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $0db411e0fcb2712d$var$isArrayLikeObject(value) {
    return $pARw7(value) && $1tRgx(value);
}
$0db411e0fcb2712d$exports = $0db411e0fcb2712d$var$isArrayLikeObject;



var $b0TBZ = parcelRequire("b0TBZ");







var $499c895a9624d191$exports = {};

var $et6E7 = parcelRequire("et6E7");





/** `Object#toString` result references. */ var $499c895a9624d191$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $499c895a9624d191$var$funcProto = Function.prototype, $499c895a9624d191$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $499c895a9624d191$var$funcToString = $499c895a9624d191$var$funcProto.toString;
/** Used to check objects for own properties. */ var $499c895a9624d191$var$hasOwnProperty = $499c895a9624d191$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $499c895a9624d191$var$objectCtorString = $499c895a9624d191$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $499c895a9624d191$var$isPlainObject(value) {
    if (!$pARw7(value) || $et6E7(value) != $499c895a9624d191$var$objectTag) return false;
    var proto = $374fce4b0670c33a$exports(value);
    if (proto === null) return true;
    var Ctor = $499c895a9624d191$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $499c895a9624d191$var$funcToString.call(Ctor) == $499c895a9624d191$var$objectCtorString;
}
$499c895a9624d191$exports = $499c895a9624d191$var$isPlainObject;



var $jxBcJ = parcelRequire("jxBcJ");

var $5fb421f10549b37c$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $5fb421f10549b37c$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$5fb421f10549b37c$exports = $5fb421f10549b37c$var$safeGet;


var $06cc6fac587c1f29$exports = {};
var $aa5acb4ee02643c2$exports = {};
var $b642fc18bfbd3a87$exports = {};


/** Used for built-in method references. */ var $b642fc18bfbd3a87$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b642fc18bfbd3a87$var$hasOwnProperty = $b642fc18bfbd3a87$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b642fc18bfbd3a87$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($b642fc18bfbd3a87$var$hasOwnProperty.call(object, key) && $60548ee52cee8593$exports(objValue, value)) || value === undefined && !(key in object)) $d1c896f271e3839f$exports(object, key, value);
}
$b642fc18bfbd3a87$exports = $b642fc18bfbd3a87$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $aa5acb4ee02643c2$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $d1c896f271e3839f$exports(object, key, newValue);
        else $b642fc18bfbd3a87$exports(object, key, newValue);
    }
    return object;
}
$aa5acb4ee02643c2$exports = $aa5acb4ee02643c2$var$copyObject;


var $5873ee0248553f8d$exports = {};

var $7BwDL = parcelRequire("7BwDL");

var $9e64674b5ed50658$exports = {};






var $7db974b011e89e39$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7db974b011e89e39$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$7db974b011e89e39$exports = $7db974b011e89e39$var$nativeKeysIn;


/** Used for built-in method references. */ var $9e64674b5ed50658$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9e64674b5ed50658$var$hasOwnProperty = $9e64674b5ed50658$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $9e64674b5ed50658$var$baseKeysIn(object) {
    if (!$b5U5s(object)) return $7db974b011e89e39$exports(object);
    var isProto = $p2YZ9(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$9e64674b5ed50658$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$9e64674b5ed50658$exports = $9e64674b5ed50658$var$baseKeysIn;





/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5873ee0248553f8d$var$keysIn(object) {
    return $1tRgx(object) ? $7BwDL(object, true) : $9e64674b5ed50658$exports(object);
}
$5873ee0248553f8d$exports = $5873ee0248553f8d$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $06cc6fac587c1f29$var$toPlainObject(value) {
    return $aa5acb4ee02643c2$exports(value, $5873ee0248553f8d$exports(value));
}
$06cc6fac587c1f29$exports = $06cc6fac587c1f29$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $e3f412ce3c2323b7$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $5fb421f10549b37c$exports(object, key), srcValue = $5fb421f10549b37c$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7f1b6bd1cb999493$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $23IbN(srcValue), isBuff = !isArr && $b0TBZ(srcValue), isTyped = !isArr && !isBuff && $jxBcJ(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($23IbN(objValue)) newValue = objValue;
            else if ($0db411e0fcb2712d$exports(objValue)) newValue = $ffb3186abb951e5e$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $hhJJH(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $899ecb974c02a929$exports(srcValue, true);
            } else newValue = [];
        } else if ($499c895a9624d191$exports(srcValue) || $kxqKq(srcValue)) {
            newValue = objValue;
            if ($kxqKq(objValue)) newValue = $06cc6fac587c1f29$exports(objValue);
            else if (!$b5U5s(objValue) || $22zFL(objValue)) newValue = $ac1f4cf2d68e9613$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $7f1b6bd1cb999493$exports(object, key, newValue);
}
$e3f412ce3c2323b7$exports = $e3f412ce3c2323b7$var$baseMergeDeep;







/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $b0d9cacc6a1d9e19$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $4SKGa(source, function(srcValue, key) {
        stack || (stack = new $719c999f233dca91$exports);
        if ($b5U5s(srcValue)) $e3f412ce3c2323b7$exports(object, source, key, srcIndex, $b0d9cacc6a1d9e19$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($5fb421f10549b37c$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7f1b6bd1cb999493$exports(object, key, newValue);
        }
    }, $5873ee0248553f8d$exports);
}
$b0d9cacc6a1d9e19$exports = $b0d9cacc6a1d9e19$var$baseMerge;


var $3e16f937026040f1$exports = {};
var $c0038ab38d1d26e5$exports = {};

var $g6oan = parcelRequire("g6oan");

var $a86f29956d0b2fe4$exports = {};
var $565e22640198c48c$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $565e22640198c48c$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$565e22640198c48c$exports = $565e22640198c48c$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $a86f29956d0b2fe4$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $a86f29956d0b2fe4$var$overRest(func, start, transform) {
    start = $a86f29956d0b2fe4$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $a86f29956d0b2fe4$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $565e22640198c48c$exports(func, this, otherArgs);
    };
}
$a86f29956d0b2fe4$exports = $a86f29956d0b2fe4$var$overRest;


var $bb394c237c2d4622$exports = {};
var $3e271f2900d4b216$exports = {};
var $bc3512ed3b96e359$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $bc3512ed3b96e359$var$constant(value) {
    return function() {
        return value;
    };
}
$bc3512ed3b96e359$exports = $bc3512ed3b96e359$var$constant;






/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3e271f2900d4b216$var$baseSetToString = !$e7ba1fa13f388db0$exports ? $g6oan : function(func, string) {
    return $e7ba1fa13f388db0$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $bc3512ed3b96e359$exports(string),
        'writable': true
    });
};
$3e271f2900d4b216$exports = $3e271f2900d4b216$var$baseSetToString;


var $54bf5836331eda53$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $54bf5836331eda53$var$HOT_COUNT = 800, $54bf5836331eda53$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $54bf5836331eda53$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $54bf5836331eda53$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $54bf5836331eda53$var$nativeNow(), remaining = $54bf5836331eda53$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $54bf5836331eda53$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$54bf5836331eda53$exports = $54bf5836331eda53$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $bb394c237c2d4622$var$setToString = $54bf5836331eda53$exports($3e271f2900d4b216$exports);
$bb394c237c2d4622$exports = $bb394c237c2d4622$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $c0038ab38d1d26e5$var$baseRest(func, start) {
    return $bb394c237c2d4622$exports($a86f29956d0b2fe4$exports(func, start, $g6oan), func + '');
}
$c0038ab38d1d26e5$exports = $c0038ab38d1d26e5$var$baseRest;


var $cba20ef8fff2f644$exports = {};





var $hYxPn = parcelRequire("hYxPn");




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $cba20ef8fff2f644$var$isIterateeCall(value, index, object) {
    if (!$b5U5s(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $1tRgx(object) && $hYxPn(index, object.length) : type == 'string' && index in object) return $60548ee52cee8593$exports(object[index], value);
    return false;
}
$cba20ef8fff2f644$exports = $cba20ef8fff2f644$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $3e16f937026040f1$var$createAssigner(assigner) {
    return $c0038ab38d1d26e5$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $cba20ef8fff2f644$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$3e16f937026040f1$exports = $3e16f937026040f1$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $3b3ba6283598aa39$var$merge = $3e16f937026040f1$exports(function(object, source, srcIndex) {
    $b0d9cacc6a1d9e19$exports(object, source, srcIndex);
});
$3b3ba6283598aa39$exports = $3b3ba6283598aa39$var$merge;


var $adc46bbe7f7c9584$var$_merge2 = $adc46bbe7f7c9584$var$_interopRequireDefault($3b3ba6283598aa39$exports);
function $adc46bbe7f7c9584$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $adc46bbe7f7c9584$var$Raised = module.exports.Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, $adc46bbe7f7c9584$var$_reactcss2.default)((0, $adc46bbe7f7c9584$var$_merge2.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return $adc46bbe7f7c9584$var$_react2.default.createElement('div', {
        style: styles.wrap
    }, $adc46bbe7f7c9584$var$_react2.default.createElement('div', {
        style: styles.bg
    }), $adc46bbe7f7c9584$var$_react2.default.createElement('div', {
        style: styles.content
    }, children));
};
$adc46bbe7f7c9584$var$Raised.propTypes = {
    background: $adc46bbe7f7c9584$var$_propTypes2.default.string,
    zDepth: $adc46bbe7f7c9584$var$_propTypes2.default.oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: $adc46bbe7f7c9584$var$_propTypes2.default.number,
    styles: $adc46bbe7f7c9584$var$_propTypes2.default.object
};
$adc46bbe7f7c9584$var$Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
module.exports.default = $adc46bbe7f7c9584$var$Raised;

});

parcelRegister("3FOwJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Saturation = undefined;
var $2acc6508df04c45a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $2acc6508df04c45a$var$_react2 = $2acc6508df04c45a$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $2acc6508df04c45a$var$_reactcss2 = $2acc6508df04c45a$var$_interopRequireDefault($RqPIr);
var $2e218348b7238b61$exports = {};

var $59urx = parcelRequire("59urx");


var $b5U5s = parcelRequire("b5U5s");

/** Error message constants. */ var $2e218348b7238b61$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2e218348b7238b61$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($2e218348b7238b61$var$FUNC_ERROR_TEXT);
    if ($b5U5s(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $59urx(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$2e218348b7238b61$exports = $2e218348b7238b61$var$throttle;


var $2acc6508df04c45a$var$_throttle2 = $2acc6508df04c45a$var$_interopRequireDefault($2e218348b7238b61$exports);

var $80b2b = parcelRequire("80b2b");

var $2acc6508df04c45a$var$saturation = $2acc6508df04c45a$var$_interopRequireWildcard($80b2b);
function $2acc6508df04c45a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $2acc6508df04c45a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2acc6508df04c45a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2acc6508df04c45a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2acc6508df04c45a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2acc6508df04c45a$var$Saturation = module.exports.Saturation = function(_ref) {
    $2acc6508df04c45a$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $2acc6508df04c45a$var$_classCallCheck(this, Saturation);
        var _this = $2acc6508df04c45a$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, $2acc6508df04c45a$var$saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $2acc6508df04c45a$var$_throttle2.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $2acc6508df04c45a$var$_createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, $2acc6508df04c45a$var$_reactcss2.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return $2acc6508df04c45a$var$_react2.default.createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, $2acc6508df04c45a$var$_react2.default.createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), $2acc6508df04c45a$var$_react2.default.createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, $2acc6508df04c45a$var$_react2.default.createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), $2acc6508df04c45a$var$_react2.default.createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? $2acc6508df04c45a$var$_react2.default.createElement(this.props.pointer, this.props) : $2acc6508df04c45a$var$_react2.default.createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}($42omo.PureComponent || $42omo.Component);
module.exports.default = $2acc6508df04c45a$var$Saturation;

});

parcelRegister("8umxE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ColorWrap = undefined;
var $62e29c622e295dd8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $62e29c622e295dd8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $62e29c622e295dd8$var$_react2 = $62e29c622e295dd8$var$_interopRequireDefault($42omo);

var $59urx = parcelRequire("59urx");

var $62e29c622e295dd8$var$_debounce2 = $62e29c622e295dd8$var$_interopRequireDefault($59urx);

var $1SITn = parcelRequire("1SITn");

var $62e29c622e295dd8$var$color = $62e29c622e295dd8$var$_interopRequireWildcard($1SITn);
function $62e29c622e295dd8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $62e29c622e295dd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $62e29c622e295dd8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $62e29c622e295dd8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $62e29c622e295dd8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $62e29c622e295dd8$var$ColorWrap = module.exports.ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $62e29c622e295dd8$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $62e29c622e295dd8$var$_classCallCheck(this, ColorPicker);
            var _this = $62e29c622e295dd8$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $62e29c622e295dd8$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $62e29c622e295dd8$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $62e29c622e295dd8$var$color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = $62e29c622e295dd8$var$color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $62e29c622e295dd8$var$_extends({}, $62e29c622e295dd8$var$color.toState(props.color, 0));
            _this.debounce = (0, $62e29c622e295dd8$var$_debounce2.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $62e29c622e295dd8$var$_createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return $62e29c622e295dd8$var$_react2.default.createElement(Picker, $62e29c622e295dd8$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $62e29c622e295dd8$var$_extends({}, $62e29c622e295dd8$var$color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }($42omo.PureComponent || $42omo.Component);
    ColorPicker.propTypes = $62e29c622e295dd8$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $62e29c622e295dd8$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
module.exports.default = $62e29c622e295dd8$var$ColorWrap;

});

parcelRegister("k4noF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Swatch = undefined;
var $03c5436d755d0c4f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $42omo = parcelRequire("42omo");

var $03c5436d755d0c4f$var$_react2 = $03c5436d755d0c4f$var$_interopRequireDefault($42omo);

var $RqPIr = parcelRequire("RqPIr");

var $03c5436d755d0c4f$var$_reactcss2 = $03c5436d755d0c4f$var$_interopRequireDefault($RqPIr);

var $kO1Y5 = parcelRequire("kO1Y5");


var $30RJX = parcelRequire("30RJX");

var $03c5436d755d0c4f$var$_Checkboard2 = $03c5436d755d0c4f$var$_interopRequireDefault($30RJX);
function $03c5436d755d0c4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $03c5436d755d0c4f$var$ENTER = 13;
var $03c5436d755d0c4f$var$Swatch = module.exports.Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, $03c5436d755d0c4f$var$_reactcss2.default)({
        default: {
            swatch: $03c5436d755d0c4f$var$_extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $03c5436d755d0c4f$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return $03c5436d755d0c4f$var$_react2.default.createElement('div', $03c5436d755d0c4f$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && $03c5436d755d0c4f$var$_react2.default.createElement($03c5436d755d0c4f$var$_Checkboard2.default, {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
module.exports.default = (0, $kO1Y5.handleFocus)($03c5436d755d0c4f$var$Swatch);

});

parcelRegister("RqPIr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReactCSS = module.exports.loop = module.exports.handleActive = module.exports.handleHover = module.exports.hover = undefined;

var $4vcQK = parcelRequire("4vcQK");

var $0a09c3da14a034f1$var$_flattenNames2 = $0a09c3da14a034f1$var$_interopRequireDefault($4vcQK);

var $4DHhB = parcelRequire("4DHhB");

var $0a09c3da14a034f1$var$_mergeClasses2 = $0a09c3da14a034f1$var$_interopRequireDefault($4DHhB);

var $9O6Wo = parcelRequire("9O6Wo");

var $0a09c3da14a034f1$var$_autoprefix2 = $0a09c3da14a034f1$var$_interopRequireDefault($9O6Wo);

var $4Yofb = parcelRequire("4Yofb");

var $0a09c3da14a034f1$var$_hover3 = $0a09c3da14a034f1$var$_interopRequireDefault($4Yofb);

var $7Mo1n = parcelRequire("7Mo1n");

var $0a09c3da14a034f1$var$_active2 = $0a09c3da14a034f1$var$_interopRequireDefault($7Mo1n);

var $d7XbQ = parcelRequire("d7XbQ");

var $0a09c3da14a034f1$var$_loop3 = $0a09c3da14a034f1$var$_interopRequireDefault($d7XbQ);
function $0a09c3da14a034f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.hover = $0a09c3da14a034f1$var$_hover3.default;
module.exports.handleHover = $0a09c3da14a034f1$var$_hover3.default;
module.exports.handleActive = $0a09c3da14a034f1$var$_active2.default;
module.exports.loop = $0a09c3da14a034f1$var$_loop3.default;
var $0a09c3da14a034f1$var$ReactCSS = module.exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $0a09c3da14a034f1$var$_flattenNames2.default)(activations);
    var merged = (0, $0a09c3da14a034f1$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $0a09c3da14a034f1$var$_autoprefix2.default)(merged);
};
module.exports.default = $0a09c3da14a034f1$var$ReactCSS;

});

parcelRegister("lH0bc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fcadc0ced5010978$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};

});

parcelRegister("5cc5D", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3c8773837971e9c2$var$checkboardCache = {};
var $3c8773837971e9c2$var$render = module.exports.render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $3c8773837971e9c2$var$get = module.exports.get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if ($3c8773837971e9c2$var$checkboardCache[key]) return $3c8773837971e9c2$var$checkboardCache[key];
    var checkboard = $3c8773837971e9c2$var$render(c1, c2, size, serverCanvas);
    $3c8773837971e9c2$var$checkboardCache[key] = checkboard;
    return checkboard;
};

});

parcelRegister("1Zih2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1729a9bb219ba266$var$calculateChange = module.exports.calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};

});

parcelRegister("22zFL", function(module, exports) {

var $et6E7 = parcelRequire("et6E7");


var $b5U5s = parcelRequire("b5U5s");

/** `Object#toString` result references. */ var $17c7707f4ca4eb6f$var$asyncTag = '[object AsyncFunction]', $17c7707f4ca4eb6f$var$funcTag = '[object Function]', $17c7707f4ca4eb6f$var$genTag = '[object GeneratorFunction]', $17c7707f4ca4eb6f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $17c7707f4ca4eb6f$var$isFunction(value) {
    if (!$b5U5s(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $et6E7(value);
    return tag == $17c7707f4ca4eb6f$var$funcTag || tag == $17c7707f4ca4eb6f$var$genTag || tag == $17c7707f4ca4eb6f$var$asyncTag || tag == $17c7707f4ca4eb6f$var$proxyTag;
}
module.exports = $17c7707f4ca4eb6f$var$isFunction;

});

parcelRegister("b5U5s", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $813bab12b918ff15$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $813bab12b918ff15$var$isObject;

});

parcelRegister("4SKGa", function(module, exports) {

var $76Ogq = parcelRequire("76Ogq");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $38e06a15549c8ec8$var$baseFor = $76Ogq();
module.exports = $38e06a15549c8ec8$var$baseFor;

});

parcelRegister("2M85Y", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $20565807df0ce424$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $20565807df0ce424$var$overArg;

});

parcelRegister("p2YZ9", function(module, exports) {
/** Used for built-in method references. */ var $04b4a633fa66886b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $04b4a633fa66886b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $04b4a633fa66886b$var$objectProto;
    return value === proto;
}
module.exports = $04b4a633fa66886b$var$isPrototype;

});

parcelRegister("kxqKq", function(module, exports) {

var $9Xtec = parcelRequire("9Xtec");


var $pARw7 = parcelRequire("pARw7");

/** Used for built-in method references. */ var $ef3ba33e89061f54$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ef3ba33e89061f54$var$hasOwnProperty = $ef3ba33e89061f54$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ef3ba33e89061f54$var$propertyIsEnumerable = $ef3ba33e89061f54$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ef3ba33e89061f54$var$isArguments = $9Xtec(function() {
    return arguments;
}()) ? $9Xtec : function(value) {
    return $pARw7(value) && $ef3ba33e89061f54$var$hasOwnProperty.call(value, 'callee') && !$ef3ba33e89061f54$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $ef3ba33e89061f54$var$isArguments;

});

parcelRegister("23IbN", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $17fe23aa119b96ba$var$isArray = Array.isArray;
module.exports = $17fe23aa119b96ba$var$isArray;

});

parcelRegister("1tRgx", function(module, exports) {

var $22zFL = parcelRequire("22zFL");


var $eAk7h = parcelRequire("eAk7h");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1141d1587cdef30a$var$isArrayLike(value) {
    return value != null && $eAk7h(value.length) && !$22zFL(value);
}
module.exports = $1141d1587cdef30a$var$isArrayLike;

});

parcelRegister("pARw7", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $04ceedf97b6e4a66$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $04ceedf97b6e4a66$var$isObjectLike;

});

parcelRegister("et6E7", function(module, exports) {

var $3vSr6 = parcelRequire("3vSr6");


var $lhE8T = parcelRequire("lhE8T");


var $i70hz = parcelRequire("i70hz");

/** `Object#toString` result references. */ var $a888ede5ce58d269$var$nullTag = '[object Null]', $a888ede5ce58d269$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a888ede5ce58d269$var$symToStringTag = $3vSr6 ? $3vSr6.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a888ede5ce58d269$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a888ede5ce58d269$var$undefinedTag : $a888ede5ce58d269$var$nullTag;
    return $a888ede5ce58d269$var$symToStringTag && $a888ede5ce58d269$var$symToStringTag in Object(value) ? $lhE8T(value) : $i70hz(value);
}
module.exports = $a888ede5ce58d269$var$baseGetTag;

});

parcelRegister("jxBcJ", function(module, exports) {

var $e5SKF = parcelRequire("e5SKF");


var $cKu8p = parcelRequire("cKu8p");


var $baAzW = parcelRequire("baAzW");

/* Node.js helper references. */ var $e39df562eacdc279$var$nodeIsTypedArray = $baAzW && $baAzW.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $e39df562eacdc279$var$isTypedArray = $e39df562eacdc279$var$nodeIsTypedArray ? $cKu8p($e39df562eacdc279$var$nodeIsTypedArray) : $e5SKF;
module.exports = $e39df562eacdc279$var$isTypedArray;

});

parcelRegister("7BwDL", function(module, exports) {

var $6OpQk = parcelRequire("6OpQk");


var $kxqKq = parcelRequire("kxqKq");


var $23IbN = parcelRequire("23IbN");


var $b0TBZ = parcelRequire("b0TBZ");


var $hYxPn = parcelRequire("hYxPn");


var $jxBcJ = parcelRequire("jxBcJ");

/** Used for built-in method references. */ var $58954ecbad6e7691$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $58954ecbad6e7691$var$hasOwnProperty = $58954ecbad6e7691$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $58954ecbad6e7691$var$arrayLikeKeys(value, inherited) {
    var isArr = $23IbN(value), isArg = !isArr && $kxqKq(value), isBuff = !isArr && !isArg && $b0TBZ(value), isType = !isArr && !isArg && !isBuff && $jxBcJ(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6OpQk(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $58954ecbad6e7691$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $hYxPn(key, length)))) result.push(key);
    return result;
}
module.exports = $58954ecbad6e7691$var$arrayLikeKeys;

});

parcelRegister("g6oan", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $bb8ff3cd9b57807b$var$identity(value) {
    return value;
}
module.exports = $bb8ff3cd9b57807b$var$identity;

});

parcelRegister("hYxPn", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d16247c1dd15b106$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d16247c1dd15b106$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d16247c1dd15b106$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d16247c1dd15b106$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d16247c1dd15b106$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d16247c1dd15b106$var$isIndex;

});

parcelRegister("80b2b", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5d36e200eb7f6cb3$var$calculateChange = module.exports.calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};

});

parcelRegister("59urx", function(module, exports) {

var $b5U5s = parcelRequire("b5U5s");


var $g0ek7 = parcelRequire("g0ek7");


var $5VtA4 = parcelRequire("5VtA4");

/** Error message constants. */ var $3c0568642f26aac5$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3c0568642f26aac5$var$nativeMax = Math.max, $3c0568642f26aac5$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $3c0568642f26aac5$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($3c0568642f26aac5$var$FUNC_ERROR_TEXT);
    wait = $5VtA4(wait) || 0;
    if ($b5U5s(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $3c0568642f26aac5$var$nativeMax($5VtA4(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $3c0568642f26aac5$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $g0ek7();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($g0ek7());
    }
    function debounced() {
        var time = $g0ek7(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $3c0568642f26aac5$var$debounce;

});

parcelRegister("1SITn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isvalidColorString = module.exports.red = module.exports.getContrastingColor = module.exports.isValidHex = module.exports.toState = module.exports.simpleCheckForValidColor = undefined;
var $eaf17333876db603$exports = {};

$eaf17333876db603$exports = (parcelRequire("6N7Vt"));


var $15eda837933fc58a$var$_each2 = $15eda837933fc58a$var$_interopRequireDefault($eaf17333876db603$exports);

var $50tqW = parcelRequire("50tqW");

var $15eda837933fc58a$var$_tinycolor2 = $15eda837933fc58a$var$_interopRequireDefault($50tqW);
function $15eda837933fc58a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $15eda837933fc58a$var$simpleCheckForValidColor = module.exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, $15eda837933fc58a$var$_each2.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $15eda837933fc58a$var$toState = module.exports.toState = function toState(data, oldHue) {
    var color = data.hex ? (0, $15eda837933fc58a$var$_tinycolor2.default)(data.hex) : (0, $15eda837933fc58a$var$_tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $15eda837933fc58a$var$isValidHex = module.exports.isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $15eda837933fc58a$var$_tinycolor2.default)(hex).isValid();
};
var $15eda837933fc58a$var$getContrastingColor = module.exports.getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = $15eda837933fc58a$var$toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var $15eda837933fc58a$var$red = module.exports.red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $15eda837933fc58a$var$isvalidColorString = module.exports.isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, $15eda837933fc58a$var$_tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

});

parcelRegister("4vcQK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flattenNames = undefined;
var $9e5d1e02e4e01c7b$exports = {};

var $eK80t = parcelRequire("eK80t");


var $eioMK = parcelRequire("eioMK");


var $kyMnU = parcelRequire("kyMnU");

/** `Object#toString` result references. */ var $9e5d1e02e4e01c7b$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $9e5d1e02e4e01c7b$var$isString(value) {
    return typeof value == 'string' || !$eioMK(value) && $kyMnU(value) && $eK80t(value) == $9e5d1e02e4e01c7b$var$stringTag;
}
$9e5d1e02e4e01c7b$exports = $9e5d1e02e4e01c7b$var$isString;


var $3474065b9c0a7267$var$_isString3 = $3474065b9c0a7267$var$_interopRequireDefault($9e5d1e02e4e01c7b$exports);

var $36oQk = parcelRequire("36oQk");

var $3474065b9c0a7267$var$_forOwn3 = $3474065b9c0a7267$var$_interopRequireDefault($36oQk);
var $c27b7da5e1bf2bb7$exports = {};




var $bSmSC = parcelRequire("bSmSC");




/** `Object#toString` result references. */ var $c27b7da5e1bf2bb7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c27b7da5e1bf2bb7$var$funcProto = Function.prototype, $c27b7da5e1bf2bb7$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c27b7da5e1bf2bb7$var$funcToString = $c27b7da5e1bf2bb7$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c27b7da5e1bf2bb7$var$hasOwnProperty = $c27b7da5e1bf2bb7$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c27b7da5e1bf2bb7$var$objectCtorString = $c27b7da5e1bf2bb7$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c27b7da5e1bf2bb7$var$isPlainObject(value) {
    if (!$kyMnU(value) || $eK80t(value) != $c27b7da5e1bf2bb7$var$objectTag) return false;
    var proto = $bSmSC(value);
    if (proto === null) return true;
    var Ctor = $c27b7da5e1bf2bb7$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $c27b7da5e1bf2bb7$var$funcToString.call(Ctor) == $c27b7da5e1bf2bb7$var$objectCtorString;
}
$c27b7da5e1bf2bb7$exports = $c27b7da5e1bf2bb7$var$isPlainObject;


var $3474065b9c0a7267$var$_isPlainObject3 = $3474065b9c0a7267$var$_interopRequireDefault($c27b7da5e1bf2bb7$exports);
var $acea733442417e97$exports = {};
var $6b7a0204dd1b7621$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6b7a0204dd1b7621$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$6b7a0204dd1b7621$exports = $6b7a0204dd1b7621$var$arrayMap;


var $42212caab657e211$exports = {};
var $ca4fb26a0d92a2d8$exports = {};
var $3bbdb5149e95c3fa$exports = {};

var $ThBJA = parcelRequire("ThBJA");

var $f42117d8950a2454$exports = {};
var $a8558f1b897fd4bc$exports = {};



var $d60a7720271be048$exports = {};
var $f254d44a278ce0f1$exports = {};

var $lWYAi = parcelRequire("lWYAi");

var $95aa5a3867bea605$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $95aa5a3867bea605$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $95aa5a3867bea605$var$setCacheAdd(value) {
    this.__data__.set(value, $95aa5a3867bea605$var$HASH_UNDEFINED);
    return this;
}
$95aa5a3867bea605$exports = $95aa5a3867bea605$var$setCacheAdd;


var $1f9d9a9d1f17dc49$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $1f9d9a9d1f17dc49$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$1f9d9a9d1f17dc49$exports = $1f9d9a9d1f17dc49$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $f254d44a278ce0f1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $lWYAi;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$f254d44a278ce0f1$var$SetCache.prototype.add = $f254d44a278ce0f1$var$SetCache.prototype.push = $95aa5a3867bea605$exports;
$f254d44a278ce0f1$var$SetCache.prototype.has = $1f9d9a9d1f17dc49$exports;
$f254d44a278ce0f1$exports = $f254d44a278ce0f1$var$SetCache;


var $9dff02b5dc634b50$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9dff02b5dc634b50$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$9dff02b5dc634b50$exports = $9dff02b5dc634b50$var$arraySome;


var $b9d098da92c73c1f$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b9d098da92c73c1f$var$cacheHas(cache, key) {
    return cache.has(key);
}
$b9d098da92c73c1f$exports = $b9d098da92c73c1f$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $d60a7720271be048$var$COMPARE_PARTIAL_FLAG = 1, $d60a7720271be048$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $d60a7720271be048$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $d60a7720271be048$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $d60a7720271be048$var$COMPARE_UNORDERED_FLAG ? new $f254d44a278ce0f1$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$9dff02b5dc634b50$exports(other, function(othValue, othIndex) {
                if (!$b9d098da92c73c1f$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$d60a7720271be048$exports = $d60a7720271be048$var$equalArrays;


var $206478e37dc93b48$exports = {};

var $e1YiA = parcelRequire("e1YiA");


var $1Fbgg = parcelRequire("1Fbgg");


var $haa70 = parcelRequire("haa70");


var $de420763b560a793$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $de420763b560a793$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$de420763b560a793$exports = $de420763b560a793$var$mapToArray;


var $11af00fb09430fff$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11af00fb09430fff$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$11af00fb09430fff$exports = $11af00fb09430fff$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $206478e37dc93b48$var$COMPARE_PARTIAL_FLAG = 1, $206478e37dc93b48$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $206478e37dc93b48$var$boolTag = '[object Boolean]', $206478e37dc93b48$var$dateTag = '[object Date]', $206478e37dc93b48$var$errorTag = '[object Error]', $206478e37dc93b48$var$mapTag = '[object Map]', $206478e37dc93b48$var$numberTag = '[object Number]', $206478e37dc93b48$var$regexpTag = '[object RegExp]', $206478e37dc93b48$var$setTag = '[object Set]', $206478e37dc93b48$var$stringTag = '[object String]', $206478e37dc93b48$var$symbolTag = '[object Symbol]';
var $206478e37dc93b48$var$arrayBufferTag = '[object ArrayBuffer]', $206478e37dc93b48$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $206478e37dc93b48$var$symbolProto = $e1YiA ? $e1YiA.prototype : undefined, $206478e37dc93b48$var$symbolValueOf = $206478e37dc93b48$var$symbolProto ? $206478e37dc93b48$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $206478e37dc93b48$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $206478e37dc93b48$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $206478e37dc93b48$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $1Fbgg(object), new $1Fbgg(other))) return false;
            return true;
        case $206478e37dc93b48$var$boolTag:
        case $206478e37dc93b48$var$dateTag:
        case $206478e37dc93b48$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $haa70(+object, +other);
        case $206478e37dc93b48$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $206478e37dc93b48$var$regexpTag:
        case $206478e37dc93b48$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $206478e37dc93b48$var$mapTag:
            var convert = $de420763b560a793$exports;
        case $206478e37dc93b48$var$setTag:
            var isPartial = bitmask & $206478e37dc93b48$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $11af00fb09430fff$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $206478e37dc93b48$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $d60a7720271be048$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $206478e37dc93b48$var$symbolTag:
            if ($206478e37dc93b48$var$symbolValueOf) return $206478e37dc93b48$var$symbolValueOf.call(object) == $206478e37dc93b48$var$symbolValueOf.call(other);
    }
    return false;
}
$206478e37dc93b48$exports = $206478e37dc93b48$var$equalByTag;


var $638ba501eb6750d4$exports = {};

var $8D9dx = parcelRequire("8D9dx");

/** Used to compose bitmasks for value comparisons. */ var $638ba501eb6750d4$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $638ba501eb6750d4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $638ba501eb6750d4$var$hasOwnProperty = $638ba501eb6750d4$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $638ba501eb6750d4$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $638ba501eb6750d4$var$COMPARE_PARTIAL_FLAG, objProps = $8D9dx(object), objLength = objProps.length, othProps = $8D9dx(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $638ba501eb6750d4$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$638ba501eb6750d4$exports = $638ba501eb6750d4$var$equalObjects;



var $k4ejE = parcelRequire("k4ejE");





var $j7yqm = parcelRequire("j7yqm");


var $44M3z = parcelRequire("44M3z");

/** Used to compose bitmasks for value comparisons. */ var $a8558f1b897fd4bc$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $a8558f1b897fd4bc$var$argsTag = '[object Arguments]', $a8558f1b897fd4bc$var$arrayTag = '[object Array]', $a8558f1b897fd4bc$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a8558f1b897fd4bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a8558f1b897fd4bc$var$hasOwnProperty = $a8558f1b897fd4bc$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a8558f1b897fd4bc$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $eioMK(object), othIsArr = $eioMK(other), objTag = objIsArr ? $a8558f1b897fd4bc$var$arrayTag : $k4ejE(object), othTag = othIsArr ? $a8558f1b897fd4bc$var$arrayTag : $k4ejE(other);
    objTag = objTag == $a8558f1b897fd4bc$var$argsTag ? $a8558f1b897fd4bc$var$objectTag : objTag;
    othTag = othTag == $a8558f1b897fd4bc$var$argsTag ? $a8558f1b897fd4bc$var$objectTag : othTag;
    var objIsObj = objTag == $a8558f1b897fd4bc$var$objectTag, othIsObj = othTag == $a8558f1b897fd4bc$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $j7yqm(object)) {
        if (!$j7yqm(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $ThBJA);
        return objIsArr || $44M3z(object) ? $d60a7720271be048$exports(object, other, bitmask, customizer, equalFunc, stack) : $206478e37dc93b48$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $a8558f1b897fd4bc$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $a8558f1b897fd4bc$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $a8558f1b897fd4bc$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $ThBJA);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $ThBJA);
    return $638ba501eb6750d4$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$a8558f1b897fd4bc$exports = $a8558f1b897fd4bc$var$baseIsEqualDeep;





/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f42117d8950a2454$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$kyMnU(value) && !$kyMnU(other)) return value !== value && other !== other;
    return $a8558f1b897fd4bc$exports(value, other, bitmask, customizer, $f42117d8950a2454$var$baseIsEqual, stack);
}
$f42117d8950a2454$exports = $f42117d8950a2454$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $3bbdb5149e95c3fa$var$COMPARE_PARTIAL_FLAG = 1, $3bbdb5149e95c3fa$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $3bbdb5149e95c3fa$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $ThBJA;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f42117d8950a2454$exports(srcValue, objValue, $3bbdb5149e95c3fa$var$COMPARE_PARTIAL_FLAG | $3bbdb5149e95c3fa$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$3bbdb5149e95c3fa$exports = $3bbdb5149e95c3fa$var$baseIsMatch;


var $f639ee639d1e5f49$exports = {};
var $cfe63531ba627486$exports = {};

var $467Dm = parcelRequire("467Dm");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $cfe63531ba627486$var$isStrictComparable(value) {
    return value === value && !$467Dm(value);
}
$cfe63531ba627486$exports = $cfe63531ba627486$var$isStrictComparable;



var $89kUo = parcelRequire("89kUo");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $f639ee639d1e5f49$var$getMatchData(object) {
    var result = $89kUo(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $cfe63531ba627486$exports(value)
        ];
    }
    return result;
}
$f639ee639d1e5f49$exports = $f639ee639d1e5f49$var$getMatchData;


var $cb318bcb95af0473$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $cb318bcb95af0473$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$cb318bcb95af0473$exports = $cb318bcb95af0473$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $ca4fb26a0d92a2d8$var$baseMatches(source) {
    var matchData = $f639ee639d1e5f49$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $cb318bcb95af0473$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $3bbdb5149e95c3fa$exports(object, source, matchData);
    };
}
$ca4fb26a0d92a2d8$exports = $ca4fb26a0d92a2d8$var$baseMatches;


var $e332c9bf26885592$exports = {};

var $6ff3bd0290f8f9bd$exports = {};
var $a8f0f1b95cc58139$exports = {};
var $4dc97ecfa1a7c017$exports = {};



var $af0b365634efcdd6$exports = {};



var $b1f7405522de1654$exports = {};






/** `Object#toString` result references. */ var $b1f7405522de1654$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b1f7405522de1654$var$isSymbol(value) {
    return typeof value == 'symbol' || $kyMnU(value) && $eK80t(value) == $b1f7405522de1654$var$symbolTag;
}
$b1f7405522de1654$exports = $b1f7405522de1654$var$isSymbol;


/** Used to match property names within property paths. */ var $af0b365634efcdd6$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $af0b365634efcdd6$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $af0b365634efcdd6$var$isKey(value, object) {
    if ($eioMK(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $b1f7405522de1654$exports(value)) return true;
    return $af0b365634efcdd6$var$reIsPlainProp.test(value) || !$af0b365634efcdd6$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$af0b365634efcdd6$exports = $af0b365634efcdd6$var$isKey;


var $675becb36b0be5c9$exports = {};
var $8e8bfb3d79fd747f$exports = {};
var $53b17ad7fe08f138$exports = {};



/** Error message constants. */ var $53b17ad7fe08f138$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $53b17ad7fe08f138$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($53b17ad7fe08f138$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($53b17ad7fe08f138$var$memoize.Cache || $lWYAi);
    return memoized;
}
// Expose `MapCache`.
$53b17ad7fe08f138$var$memoize.Cache = $lWYAi;
$53b17ad7fe08f138$exports = $53b17ad7fe08f138$var$memoize;


/** Used as the maximum memoize cache size. */ var $8e8bfb3d79fd747f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $8e8bfb3d79fd747f$var$memoizeCapped(func) {
    var result = $53b17ad7fe08f138$exports(func, function(key) {
        if (cache.size === $8e8bfb3d79fd747f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$8e8bfb3d79fd747f$exports = $8e8bfb3d79fd747f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $675becb36b0be5c9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $675becb36b0be5c9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $675becb36b0be5c9$var$stringToPath = $8e8bfb3d79fd747f$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($675becb36b0be5c9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($675becb36b0be5c9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$675becb36b0be5c9$exports = $675becb36b0be5c9$var$stringToPath;


var $5dccb17f73832b07$exports = {};
var $407e840d051f7f40$exports = {};








/** Used as references for various `Number` constants. */ var $407e840d051f7f40$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $407e840d051f7f40$var$symbolProto = $e1YiA ? $e1YiA.prototype : undefined, $407e840d051f7f40$var$symbolToString = $407e840d051f7f40$var$symbolProto ? $407e840d051f7f40$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $407e840d051f7f40$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($eioMK(value)) // Recursively convert values (susceptible to call stack limits).
    return $6b7a0204dd1b7621$exports(value, $407e840d051f7f40$var$baseToString) + '';
    if ($b1f7405522de1654$exports(value)) return $407e840d051f7f40$var$symbolToString ? $407e840d051f7f40$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$407e840d051f7f40$var$INFINITY ? '-0' : result;
}
$407e840d051f7f40$exports = $407e840d051f7f40$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $5dccb17f73832b07$var$toString(value) {
    return value == null ? '' : $407e840d051f7f40$exports(value);
}
$5dccb17f73832b07$exports = $5dccb17f73832b07$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4dc97ecfa1a7c017$var$castPath(value, object) {
    if ($eioMK(value)) return value;
    return $af0b365634efcdd6$exports(value, object) ? [
        value
    ] : $675becb36b0be5c9$exports($5dccb17f73832b07$exports(value));
}
$4dc97ecfa1a7c017$exports = $4dc97ecfa1a7c017$var$castPath;


var $a0d117119746bd69$exports = {};

/** Used as references for various `Number` constants. */ var $a0d117119746bd69$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $a0d117119746bd69$var$toKey(value) {
    if (typeof value == 'string' || $b1f7405522de1654$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$a0d117119746bd69$var$INFINITY ? '-0' : result;
}
$a0d117119746bd69$exports = $a0d117119746bd69$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $a8f0f1b95cc58139$var$baseGet(object, path) {
    path = $4dc97ecfa1a7c017$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$a0d117119746bd69$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$a8f0f1b95cc58139$exports = $a8f0f1b95cc58139$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $6ff3bd0290f8f9bd$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $a8f0f1b95cc58139$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$6ff3bd0290f8f9bd$exports = $6ff3bd0290f8f9bd$var$get;


var $2b6930c7222d5c96$exports = {};
var $37f29a075431d7c5$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $37f29a075431d7c5$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$37f29a075431d7c5$exports = $37f29a075431d7c5$var$baseHasIn;


var $b5bbb8f5da36c610$exports = {};


var $d3SZr = parcelRequire("d3SZr");





var $7wEyS = parcelRequire("7wEyS");


var $j9392 = parcelRequire("j9392");


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b5bbb8f5da36c610$var$hasPath(object, path, hasFunc) {
    path = $4dc97ecfa1a7c017$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $a0d117119746bd69$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $j9392(length) && $7wEyS(key, length) && ($eioMK(object) || $d3SZr(object));
}
$b5bbb8f5da36c610$exports = $b5bbb8f5da36c610$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $2b6930c7222d5c96$var$hasIn(object, path) {
    return object != null && $b5bbb8f5da36c610$exports(object, path, $37f29a075431d7c5$exports);
}
$2b6930c7222d5c96$exports = $2b6930c7222d5c96$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $e332c9bf26885592$var$COMPARE_PARTIAL_FLAG = 1, $e332c9bf26885592$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e332c9bf26885592$var$baseMatchesProperty(path, srcValue) {
    if ($af0b365634efcdd6$exports(path) && $cfe63531ba627486$exports(srcValue)) return $cb318bcb95af0473$exports($a0d117119746bd69$exports(path), srcValue);
    return function(object) {
        var objValue = $6ff3bd0290f8f9bd$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $2b6930c7222d5c96$exports(object, path) : $f42117d8950a2454$exports(srcValue, objValue, $e332c9bf26885592$var$COMPARE_PARTIAL_FLAG | $e332c9bf26885592$var$COMPARE_UNORDERED_FLAG);
    };
}
$e332c9bf26885592$exports = $e332c9bf26885592$var$baseMatchesProperty;



var $1lfjI = parcelRequire("1lfjI");




var $ce65b4f8bcc7d508$exports = {};
var $6da25f6e44f05eef$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $6da25f6e44f05eef$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$6da25f6e44f05eef$exports = $6da25f6e44f05eef$var$baseProperty;


var $261f77f25cef2474$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $261f77f25cef2474$var$basePropertyDeep(path) {
    return function(object) {
        return $a8f0f1b95cc58139$exports(object, path);
    };
}
$261f77f25cef2474$exports = $261f77f25cef2474$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ce65b4f8bcc7d508$var$property(path) {
    return $af0b365634efcdd6$exports(path) ? $6da25f6e44f05eef$exports($a0d117119746bd69$exports(path)) : $261f77f25cef2474$exports(path);
}
$ce65b4f8bcc7d508$exports = $ce65b4f8bcc7d508$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $42212caab657e211$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $1lfjI;
    if (typeof value == 'object') return $eioMK(value) ? $e332c9bf26885592$exports(value[0], value[1]) : $ca4fb26a0d92a2d8$exports(value);
    return $ce65b4f8bcc7d508$exports(value);
}
$42212caab657e211$exports = $42212caab657e211$var$baseIteratee;


var $f7fc95742c979669$exports = {};
var $212479bd0ed72897$exports = {};

var $bclWo = parcelRequire("bclWo");

var $59d55101be895acc$exports = {};

var $8W5BJ = parcelRequire("8W5BJ");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $59d55101be895acc$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$8W5BJ(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$59d55101be895acc$exports = $59d55101be895acc$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $212479bd0ed72897$var$baseEach = $59d55101be895acc$exports($bclWo);
$212479bd0ed72897$exports = $212479bd0ed72897$var$baseEach;





/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $f7fc95742c979669$var$baseMap(collection, iteratee) {
    var index = -1, result = $8W5BJ(collection) ? Array(collection.length) : [];
    $212479bd0ed72897$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$f7fc95742c979669$exports = $f7fc95742c979669$var$baseMap;





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $acea733442417e97$var$map(collection, iteratee) {
    var func = $eioMK(collection) ? $6b7a0204dd1b7621$exports : $f7fc95742c979669$exports;
    return func(collection, $42212caab657e211$exports(iteratee, 3));
}
$acea733442417e97$exports = $acea733442417e97$var$map;


var $3474065b9c0a7267$var$_map3 = $3474065b9c0a7267$var$_interopRequireDefault($acea733442417e97$exports);
function $3474065b9c0a7267$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3474065b9c0a7267$var$flattenNames = module.exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $3474065b9c0a7267$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $3474065b9c0a7267$var$_isPlainObject3.default)(thing)) (0, $3474065b9c0a7267$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, $3474065b9c0a7267$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
module.exports.default = $3474065b9c0a7267$var$flattenNames;

});

parcelRegister("4DHhB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mergeClasses = undefined;

var $36oQk = parcelRequire("36oQk");

var $360c6104cab9a44a$var$_forOwn3 = $360c6104cab9a44a$var$_interopRequireDefault($36oQk);
var $d97aa43229ec5a0d$exports = {};
var $832c71fd73fcd9df$exports = {};

var $ThBJA = parcelRequire("ThBJA");

var $d8835e71035c15a0$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d8835e71035c15a0$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$d8835e71035c15a0$exports = $d8835e71035c15a0$var$arrayEach;


var $3002e05a6cdd6d96$exports = {};
var $bbd99941ef22cbae$exports = {};
var $7fbb1514804ee379$exports = {};

var $3y9vZ = parcelRequire("3y9vZ");

var $7fbb1514804ee379$var$defineProperty = function() {
    try {
        var func = $3y9vZ(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$7fbb1514804ee379$exports = $7fbb1514804ee379$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bbd99941ef22cbae$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $7fbb1514804ee379$exports) $7fbb1514804ee379$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$bbd99941ef22cbae$exports = $bbd99941ef22cbae$var$baseAssignValue;



var $haa70 = parcelRequire("haa70");

/** Used for built-in method references. */ var $3002e05a6cdd6d96$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3002e05a6cdd6d96$var$hasOwnProperty = $3002e05a6cdd6d96$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3002e05a6cdd6d96$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3002e05a6cdd6d96$var$hasOwnProperty.call(object, key) && $haa70(objValue, value)) || value === undefined && !(key in object)) $bbd99941ef22cbae$exports(object, key, value);
}
$3002e05a6cdd6d96$exports = $3002e05a6cdd6d96$var$assignValue;


var $153e2ba3173f33a3$exports = {};
var $2e7f4a31ca1ce6f1$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2e7f4a31ca1ce6f1$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $bbd99941ef22cbae$exports(object, key, newValue);
        else $3002e05a6cdd6d96$exports(object, key, newValue);
    }
    return object;
}
$2e7f4a31ca1ce6f1$exports = $2e7f4a31ca1ce6f1$var$copyObject;



var $89kUo = parcelRequire("89kUo");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $153e2ba3173f33a3$var$baseAssign(object, source) {
    return object && $2e7f4a31ca1ce6f1$exports(source, $89kUo(source), object);
}
$153e2ba3173f33a3$exports = $153e2ba3173f33a3$var$baseAssign;


var $dad509f31e85a3d1$exports = {};

var $1df7bbd64f943fae$exports = {};

var $ibEs2 = parcelRequire("ibEs2");

var $8db73e58ab0b8fee$exports = {};

var $467Dm = parcelRequire("467Dm");


var $hJadS = parcelRequire("hJadS");

var $063498c3ed8b3b71$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $063498c3ed8b3b71$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$063498c3ed8b3b71$exports = $063498c3ed8b3b71$var$nativeKeysIn;


/** Used for built-in method references. */ var $8db73e58ab0b8fee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8db73e58ab0b8fee$var$hasOwnProperty = $8db73e58ab0b8fee$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8db73e58ab0b8fee$var$baseKeysIn(object) {
    if (!$467Dm(object)) return $063498c3ed8b3b71$exports(object);
    var isProto = $hJadS(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$8db73e58ab0b8fee$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$8db73e58ab0b8fee$exports = $8db73e58ab0b8fee$var$baseKeysIn;



var $8W5BJ = parcelRequire("8W5BJ");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $1df7bbd64f943fae$var$keysIn(object) {
    return $8W5BJ(object) ? $ibEs2(object, true) : $8db73e58ab0b8fee$exports(object);
}
$1df7bbd64f943fae$exports = $1df7bbd64f943fae$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $dad509f31e85a3d1$var$baseAssignIn(object, source) {
    return object && $2e7f4a31ca1ce6f1$exports(source, $1df7bbd64f943fae$exports(source), object);
}
$dad509f31e85a3d1$exports = $dad509f31e85a3d1$var$baseAssignIn;



var $cZKRB = parcelRequire("cZKRB");

var $7bc67571f11cc919$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7bc67571f11cc919$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$7bc67571f11cc919$exports = $7bc67571f11cc919$var$copyArray;


var $f8f45876046577ee$exports = {};


var $7ND8c = parcelRequire("7ND8c");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f8f45876046577ee$var$copySymbols(source, object) {
    return $2e7f4a31ca1ce6f1$exports(source, $7ND8c(source), object);
}
$f8f45876046577ee$exports = $f8f45876046577ee$var$copySymbols;


var $f6c383ebeb5d661f$exports = {};

var $90a75cc192a23db3$exports = {};

var $730jH = parcelRequire("730jH");


var $bSmSC = parcelRequire("bSmSC");





var $hFCqO = parcelRequire("hFCqO");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $90a75cc192a23db3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $90a75cc192a23db3$var$getSymbolsIn = !$90a75cc192a23db3$var$nativeGetSymbols ? $hFCqO : function(object) {
    var result = [];
    while(object){
        $730jH(result, $7ND8c(object));
        object = $bSmSC(object);
    }
    return result;
};
$90a75cc192a23db3$exports = $90a75cc192a23db3$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $f6c383ebeb5d661f$var$copySymbolsIn(source, object) {
    return $2e7f4a31ca1ce6f1$exports(source, $90a75cc192a23db3$exports(source), object);
}
$f6c383ebeb5d661f$exports = $f6c383ebeb5d661f$var$copySymbolsIn;



var $8D9dx = parcelRequire("8D9dx");

var $37a71fff4561ebd7$exports = {};

var $2T90T = parcelRequire("2T90T");



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $37a71fff4561ebd7$var$getAllKeysIn(object) {
    return $2T90T(object, $1df7bbd64f943fae$exports, $90a75cc192a23db3$exports);
}
$37a71fff4561ebd7$exports = $37a71fff4561ebd7$var$getAllKeysIn;



var $k4ejE = parcelRequire("k4ejE");

var $ccfb5e97fc70b309$exports = {};
/** Used for built-in method references. */ var $ccfb5e97fc70b309$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ccfb5e97fc70b309$var$hasOwnProperty = $ccfb5e97fc70b309$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $ccfb5e97fc70b309$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $ccfb5e97fc70b309$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$ccfb5e97fc70b309$exports = $ccfb5e97fc70b309$var$initCloneArray;


var $a58f343d04628246$exports = {};
var $094a6c612787100a$exports = {};

var $1Fbgg = parcelRequire("1Fbgg");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $094a6c612787100a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $1Fbgg(result).set(new $1Fbgg(arrayBuffer));
    return result;
}
$094a6c612787100a$exports = $094a6c612787100a$var$cloneArrayBuffer;


var $74e4051677301ecd$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $74e4051677301ecd$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $094a6c612787100a$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$74e4051677301ecd$exports = $74e4051677301ecd$var$cloneDataView;


var $14353f33a2d2d283$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $14353f33a2d2d283$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $14353f33a2d2d283$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $14353f33a2d2d283$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$14353f33a2d2d283$exports = $14353f33a2d2d283$var$cloneRegExp;


var $5b23696352078bef$exports = {};

var $e1YiA = parcelRequire("e1YiA");

/** Used to convert symbols to primitives and strings. */ var $5b23696352078bef$var$symbolProto = $e1YiA ? $e1YiA.prototype : undefined, $5b23696352078bef$var$symbolValueOf = $5b23696352078bef$var$symbolProto ? $5b23696352078bef$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $5b23696352078bef$var$cloneSymbol(symbol) {
    return $5b23696352078bef$var$symbolValueOf ? Object($5b23696352078bef$var$symbolValueOf.call(symbol)) : {};
}
$5b23696352078bef$exports = $5b23696352078bef$var$cloneSymbol;


var $90be5bf8ff6db92f$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $90be5bf8ff6db92f$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $094a6c612787100a$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$90be5bf8ff6db92f$exports = $90be5bf8ff6db92f$var$cloneTypedArray;


/** `Object#toString` result references. */ var $a58f343d04628246$var$boolTag = '[object Boolean]', $a58f343d04628246$var$dateTag = '[object Date]', $a58f343d04628246$var$mapTag = '[object Map]', $a58f343d04628246$var$numberTag = '[object Number]', $a58f343d04628246$var$regexpTag = '[object RegExp]', $a58f343d04628246$var$setTag = '[object Set]', $a58f343d04628246$var$stringTag = '[object String]', $a58f343d04628246$var$symbolTag = '[object Symbol]';
var $a58f343d04628246$var$arrayBufferTag = '[object ArrayBuffer]', $a58f343d04628246$var$dataViewTag = '[object DataView]', $a58f343d04628246$var$float32Tag = '[object Float32Array]', $a58f343d04628246$var$float64Tag = '[object Float64Array]', $a58f343d04628246$var$int8Tag = '[object Int8Array]', $a58f343d04628246$var$int16Tag = '[object Int16Array]', $a58f343d04628246$var$int32Tag = '[object Int32Array]', $a58f343d04628246$var$uint8Tag = '[object Uint8Array]', $a58f343d04628246$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a58f343d04628246$var$uint16Tag = '[object Uint16Array]', $a58f343d04628246$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $a58f343d04628246$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $a58f343d04628246$var$arrayBufferTag:
            return $094a6c612787100a$exports(object);
        case $a58f343d04628246$var$boolTag:
        case $a58f343d04628246$var$dateTag:
            return new Ctor(+object);
        case $a58f343d04628246$var$dataViewTag:
            return $74e4051677301ecd$exports(object, isDeep);
        case $a58f343d04628246$var$float32Tag:
        case $a58f343d04628246$var$float64Tag:
        case $a58f343d04628246$var$int8Tag:
        case $a58f343d04628246$var$int16Tag:
        case $a58f343d04628246$var$int32Tag:
        case $a58f343d04628246$var$uint8Tag:
        case $a58f343d04628246$var$uint8ClampedTag:
        case $a58f343d04628246$var$uint16Tag:
        case $a58f343d04628246$var$uint32Tag:
            return $90be5bf8ff6db92f$exports(object, isDeep);
        case $a58f343d04628246$var$mapTag:
            return new Ctor;
        case $a58f343d04628246$var$numberTag:
        case $a58f343d04628246$var$stringTag:
            return new Ctor(object);
        case $a58f343d04628246$var$regexpTag:
            return $14353f33a2d2d283$exports(object);
        case $a58f343d04628246$var$setTag:
            return new Ctor;
        case $a58f343d04628246$var$symbolTag:
            return $5b23696352078bef$exports(object);
    }
}
$a58f343d04628246$exports = $a58f343d04628246$var$initCloneByTag;


var $0011e41005eb6171$exports = {};
var $0ba6231a0f7a4aa7$exports = {};



/** Built-in value references. */ var $0ba6231a0f7a4aa7$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $0ba6231a0f7a4aa7$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$467Dm(proto)) return {};
        if ($0ba6231a0f7a4aa7$var$objectCreate) return $0ba6231a0f7a4aa7$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$0ba6231a0f7a4aa7$exports = $0ba6231a0f7a4aa7$var$baseCreate;








/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0011e41005eb6171$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$hJadS(object) ? $0ba6231a0f7a4aa7$exports($bSmSC(object)) : {};
}
$0011e41005eb6171$exports = $0011e41005eb6171$var$initCloneObject;



var $eioMK = parcelRequire("eioMK");


var $j7yqm = parcelRequire("j7yqm");

var $e3b885e0659e84f7$exports = {};
var $9830a896ab4bd885$exports = {};




var $kyMnU = parcelRequire("kyMnU");

/** `Object#toString` result references. */ var $9830a896ab4bd885$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9830a896ab4bd885$var$baseIsMap(value) {
    return $kyMnU(value) && $k4ejE(value) == $9830a896ab4bd885$var$mapTag;
}
$9830a896ab4bd885$exports = $9830a896ab4bd885$var$baseIsMap;



var $1VX1z = parcelRequire("1VX1z");


var $llRc8 = parcelRequire("llRc8");

/* Node.js helper references. */ var $e3b885e0659e84f7$var$nodeIsMap = $llRc8 && $llRc8.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e3b885e0659e84f7$var$isMap = $e3b885e0659e84f7$var$nodeIsMap ? $1VX1z($e3b885e0659e84f7$var$nodeIsMap) : $9830a896ab4bd885$exports;
$e3b885e0659e84f7$exports = $e3b885e0659e84f7$var$isMap;





var $63877614b5ce319c$exports = {};
var $809f36f6026a58be$exports = {};






/** `Object#toString` result references. */ var $809f36f6026a58be$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $809f36f6026a58be$var$baseIsSet(value) {
    return $kyMnU(value) && $k4ejE(value) == $809f36f6026a58be$var$setTag;
}
$809f36f6026a58be$exports = $809f36f6026a58be$var$baseIsSet;








/* Node.js helper references. */ var $63877614b5ce319c$var$nodeIsSet = $llRc8 && $llRc8.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $63877614b5ce319c$var$isSet = $63877614b5ce319c$var$nodeIsSet ? $1VX1z($63877614b5ce319c$var$nodeIsSet) : $809f36f6026a58be$exports;
$63877614b5ce319c$exports = $63877614b5ce319c$var$isSet;






/** Used to compose bitmasks for cloning. */ var $832c71fd73fcd9df$var$CLONE_DEEP_FLAG = 1, $832c71fd73fcd9df$var$CLONE_FLAT_FLAG = 2, $832c71fd73fcd9df$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $832c71fd73fcd9df$var$argsTag = '[object Arguments]', $832c71fd73fcd9df$var$arrayTag = '[object Array]', $832c71fd73fcd9df$var$boolTag = '[object Boolean]', $832c71fd73fcd9df$var$dateTag = '[object Date]', $832c71fd73fcd9df$var$errorTag = '[object Error]', $832c71fd73fcd9df$var$funcTag = '[object Function]', $832c71fd73fcd9df$var$genTag = '[object GeneratorFunction]', $832c71fd73fcd9df$var$mapTag = '[object Map]', $832c71fd73fcd9df$var$numberTag = '[object Number]', $832c71fd73fcd9df$var$objectTag = '[object Object]', $832c71fd73fcd9df$var$regexpTag = '[object RegExp]', $832c71fd73fcd9df$var$setTag = '[object Set]', $832c71fd73fcd9df$var$stringTag = '[object String]', $832c71fd73fcd9df$var$symbolTag = '[object Symbol]', $832c71fd73fcd9df$var$weakMapTag = '[object WeakMap]';
var $832c71fd73fcd9df$var$arrayBufferTag = '[object ArrayBuffer]', $832c71fd73fcd9df$var$dataViewTag = '[object DataView]', $832c71fd73fcd9df$var$float32Tag = '[object Float32Array]', $832c71fd73fcd9df$var$float64Tag = '[object Float64Array]', $832c71fd73fcd9df$var$int8Tag = '[object Int8Array]', $832c71fd73fcd9df$var$int16Tag = '[object Int16Array]', $832c71fd73fcd9df$var$int32Tag = '[object Int32Array]', $832c71fd73fcd9df$var$uint8Tag = '[object Uint8Array]', $832c71fd73fcd9df$var$uint8ClampedTag = '[object Uint8ClampedArray]', $832c71fd73fcd9df$var$uint16Tag = '[object Uint16Array]', $832c71fd73fcd9df$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $832c71fd73fcd9df$var$cloneableTags = {};
$832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$argsTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$arrayTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$arrayBufferTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$dataViewTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$boolTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$dateTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$float32Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$float64Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$int8Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$int16Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$int32Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$mapTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$numberTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$objectTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$regexpTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$setTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$stringTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$symbolTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$uint8Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$uint8ClampedTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$uint16Tag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$uint32Tag] = true;
$832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$errorTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$funcTag] = $832c71fd73fcd9df$var$cloneableTags[$832c71fd73fcd9df$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $832c71fd73fcd9df$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $832c71fd73fcd9df$var$CLONE_DEEP_FLAG, isFlat = bitmask & $832c71fd73fcd9df$var$CLONE_FLAT_FLAG, isFull = bitmask & $832c71fd73fcd9df$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$467Dm(value)) return value;
    var isArr = $eioMK(value);
    if (isArr) {
        result = $ccfb5e97fc70b309$exports(value);
        if (!isDeep) return $7bc67571f11cc919$exports(value, result);
    } else {
        var tag = $k4ejE(value), isFunc = tag == $832c71fd73fcd9df$var$funcTag || tag == $832c71fd73fcd9df$var$genTag;
        if ($j7yqm(value)) return $cZKRB(value, isDeep);
        if (tag == $832c71fd73fcd9df$var$objectTag || tag == $832c71fd73fcd9df$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $0011e41005eb6171$exports(value);
            if (!isDeep) return isFlat ? $f6c383ebeb5d661f$exports(value, $dad509f31e85a3d1$exports(result, value)) : $f8f45876046577ee$exports(value, $153e2ba3173f33a3$exports(result, value));
        } else {
            if (!$832c71fd73fcd9df$var$cloneableTags[tag]) return object ? value : {};
            result = $a58f343d04628246$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $ThBJA);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($63877614b5ce319c$exports(value)) value.forEach(function(subValue) {
        result.add($832c71fd73fcd9df$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($e3b885e0659e84f7$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $832c71fd73fcd9df$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $37a71fff4561ebd7$exports : $8D9dx : isFlat ? $1df7bbd64f943fae$exports : $89kUo;
    var props = isArr ? undefined : keysFunc(value);
    $d8835e71035c15a0$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $3002e05a6cdd6d96$exports(result, key, $832c71fd73fcd9df$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$832c71fd73fcd9df$exports = $832c71fd73fcd9df$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $d97aa43229ec5a0d$var$CLONE_DEEP_FLAG = 1, $d97aa43229ec5a0d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d97aa43229ec5a0d$var$cloneDeep(value) {
    return $832c71fd73fcd9df$exports(value, $d97aa43229ec5a0d$var$CLONE_DEEP_FLAG | $d97aa43229ec5a0d$var$CLONE_SYMBOLS_FLAG);
}
$d97aa43229ec5a0d$exports = $d97aa43229ec5a0d$var$cloneDeep;


var $360c6104cab9a44a$var$_cloneDeep3 = $360c6104cab9a44a$var$_interopRequireDefault($d97aa43229ec5a0d$exports);
var $360c6104cab9a44a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $360c6104cab9a44a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $360c6104cab9a44a$var$mergeClasses = module.exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $360c6104cab9a44a$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $360c6104cab9a44a$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $360c6104cab9a44a$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
module.exports.default = $360c6104cab9a44a$var$mergeClasses;

});

parcelRegister("9O6Wo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.autoprefix = undefined;

var $36oQk = parcelRequire("36oQk");

var $723e2adb10f73dba$var$_forOwn3 = $723e2adb10f73dba$var$_interopRequireDefault($36oQk);
var $723e2adb10f73dba$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $723e2adb10f73dba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $723e2adb10f73dba$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var $723e2adb10f73dba$var$autoprefix = module.exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $723e2adb10f73dba$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $723e2adb10f73dba$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $723e2adb10f73dba$var$transforms[key];
            if (transform) expanded = $723e2adb10f73dba$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
module.exports.default = $723e2adb10f73dba$var$autoprefix;

});

parcelRegister("4Yofb", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hover = undefined;
var $39ef9259038ed8ea$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $42omo = parcelRequire("42omo");

var $39ef9259038ed8ea$var$_react2 = $39ef9259038ed8ea$var$_interopRequireDefault($42omo);
function $39ef9259038ed8ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $39ef9259038ed8ea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $39ef9259038ed8ea$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $39ef9259038ed8ea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $39ef9259038ed8ea$var$hover = module.exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $39ef9259038ed8ea$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $39ef9259038ed8ea$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $39ef9259038ed8ea$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $39ef9259038ed8ea$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $39ef9259038ed8ea$var$_react2.default.createElement(Component, $39ef9259038ed8ea$var$_extends({}, _this.props, _this.state)));
            }, _temp), $39ef9259038ed8ea$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($39ef9259038ed8ea$var$_react2.default.Component);
};
module.exports.default = $39ef9259038ed8ea$var$hover;

});

parcelRegister("7Mo1n", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.active = undefined;
var $5a9fa636eb7d6983$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $42omo = parcelRequire("42omo");

var $5a9fa636eb7d6983$var$_react2 = $5a9fa636eb7d6983$var$_interopRequireDefault($42omo);
function $5a9fa636eb7d6983$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5a9fa636eb7d6983$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a9fa636eb7d6983$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a9fa636eb7d6983$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5a9fa636eb7d6983$var$active = module.exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        $5a9fa636eb7d6983$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $5a9fa636eb7d6983$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $5a9fa636eb7d6983$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $5a9fa636eb7d6983$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $5a9fa636eb7d6983$var$_react2.default.createElement(Component, $5a9fa636eb7d6983$var$_extends({}, _this.props, _this.state)));
            }, _temp), $5a9fa636eb7d6983$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($5a9fa636eb7d6983$var$_react2.default.Component);
};
module.exports.default = $5a9fa636eb7d6983$var$active;

});

parcelRegister("d7XbQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $98e9d7bd2c5b5114$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
module.exports.default = $98e9d7bd2c5b5114$var$loopable;

});

parcelRegister("76Ogq", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $0155efd3d2ef7c0a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $0155efd3d2ef7c0a$var$createBaseFor;

});

parcelRegister("9Xtec", function(module, exports) {

var $et6E7 = parcelRequire("et6E7");


var $pARw7 = parcelRequire("pARw7");

/** `Object#toString` result references. */ var $74004bd63386964c$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $74004bd63386964c$var$baseIsArguments(value) {
    return $pARw7(value) && $et6E7(value) == $74004bd63386964c$var$argsTag;
}
module.exports = $74004bd63386964c$var$baseIsArguments;

});

parcelRegister("eAk7h", function(module, exports) {
/** Used as references for various `Number` constants. */ var $a9e4082c7e421749$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $a9e4082c7e421749$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $a9e4082c7e421749$var$MAX_SAFE_INTEGER;
}
module.exports = $a9e4082c7e421749$var$isLength;

});

parcelRegister("3vSr6", function(module, exports) {

var $lHZjR = parcelRequire("lHZjR");

/** Built-in value references. */ var $28ee7e37b3cf1486$var$Symbol = $lHZjR.Symbol;
module.exports = $28ee7e37b3cf1486$var$Symbol;

});

parcelRegister("lhE8T", function(module, exports) {

var $3vSr6 = parcelRequire("3vSr6");

/** Used for built-in method references. */ var $f7ea52f07f2bfb8f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f7ea52f07f2bfb8f$var$hasOwnProperty = $f7ea52f07f2bfb8f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f7ea52f07f2bfb8f$var$nativeObjectToString = $f7ea52f07f2bfb8f$var$objectProto.toString;
/** Built-in value references. */ var $f7ea52f07f2bfb8f$var$symToStringTag = $3vSr6 ? $3vSr6.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f7ea52f07f2bfb8f$var$getRawTag(value) {
    var isOwn = $f7ea52f07f2bfb8f$var$hasOwnProperty.call(value, $f7ea52f07f2bfb8f$var$symToStringTag), tag = value[$f7ea52f07f2bfb8f$var$symToStringTag];
    try {
        value[$f7ea52f07f2bfb8f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f7ea52f07f2bfb8f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f7ea52f07f2bfb8f$var$symToStringTag] = tag;
        else delete value[$f7ea52f07f2bfb8f$var$symToStringTag];
    }
    return result;
}
module.exports = $f7ea52f07f2bfb8f$var$getRawTag;

});

parcelRegister("i70hz", function(module, exports) {
/** Used for built-in method references. */ var $d2f91987607dc8a6$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d2f91987607dc8a6$var$nativeObjectToString = $d2f91987607dc8a6$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $d2f91987607dc8a6$var$objectToString(value) {
    return $d2f91987607dc8a6$var$nativeObjectToString.call(value);
}
module.exports = $d2f91987607dc8a6$var$objectToString;

});

parcelRegister("e5SKF", function(module, exports) {

var $et6E7 = parcelRequire("et6E7");


var $eAk7h = parcelRequire("eAk7h");


var $pARw7 = parcelRequire("pARw7");

/** `Object#toString` result references. */ var $a42c00dbe2c57531$var$argsTag = '[object Arguments]', $a42c00dbe2c57531$var$arrayTag = '[object Array]', $a42c00dbe2c57531$var$boolTag = '[object Boolean]', $a42c00dbe2c57531$var$dateTag = '[object Date]', $a42c00dbe2c57531$var$errorTag = '[object Error]', $a42c00dbe2c57531$var$funcTag = '[object Function]', $a42c00dbe2c57531$var$mapTag = '[object Map]', $a42c00dbe2c57531$var$numberTag = '[object Number]', $a42c00dbe2c57531$var$objectTag = '[object Object]', $a42c00dbe2c57531$var$regexpTag = '[object RegExp]', $a42c00dbe2c57531$var$setTag = '[object Set]', $a42c00dbe2c57531$var$stringTag = '[object String]', $a42c00dbe2c57531$var$weakMapTag = '[object WeakMap]';
var $a42c00dbe2c57531$var$arrayBufferTag = '[object ArrayBuffer]', $a42c00dbe2c57531$var$dataViewTag = '[object DataView]', $a42c00dbe2c57531$var$float32Tag = '[object Float32Array]', $a42c00dbe2c57531$var$float64Tag = '[object Float64Array]', $a42c00dbe2c57531$var$int8Tag = '[object Int8Array]', $a42c00dbe2c57531$var$int16Tag = '[object Int16Array]', $a42c00dbe2c57531$var$int32Tag = '[object Int32Array]', $a42c00dbe2c57531$var$uint8Tag = '[object Uint8Array]', $a42c00dbe2c57531$var$uint8ClampedTag = '[object Uint8ClampedArray]', $a42c00dbe2c57531$var$uint16Tag = '[object Uint16Array]', $a42c00dbe2c57531$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $a42c00dbe2c57531$var$typedArrayTags = {};
$a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$float32Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$float64Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$int8Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$int16Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$int32Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$uint8Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$uint8ClampedTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$uint16Tag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$uint32Tag] = true;
$a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$argsTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$arrayTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$arrayBufferTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$boolTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$dataViewTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$dateTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$errorTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$funcTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$mapTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$numberTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$objectTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$regexpTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$setTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$stringTag] = $a42c00dbe2c57531$var$typedArrayTags[$a42c00dbe2c57531$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a42c00dbe2c57531$var$baseIsTypedArray(value) {
    return $pARw7(value) && $eAk7h(value.length) && !!$a42c00dbe2c57531$var$typedArrayTags[$et6E7(value)];
}
module.exports = $a42c00dbe2c57531$var$baseIsTypedArray;

});

parcelRegister("cKu8p", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $94812809f05eb165$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $94812809f05eb165$var$baseUnary;

});

parcelRegister("6OpQk", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4f5b7576e71e922a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $4f5b7576e71e922a$var$baseTimes;

});

parcelRegister("g0ek7", function(module, exports) {

var $lHZjR = parcelRequire("lHZjR");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ba67c1c7dc8f15cb$var$now = function() {
    return $lHZjR.Date.now();
};
module.exports = $ba67c1c7dc8f15cb$var$now;

});

parcelRegister("5VtA4", function(module, exports) {

var $81qFf = parcelRequire("81qFf");


var $b5U5s = parcelRequire("b5U5s");


var $3PNM4 = parcelRequire("3PNM4");

/** Used as references for various `Number` constants. */ var $450938ba1cef2d1c$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $450938ba1cef2d1c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $450938ba1cef2d1c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $450938ba1cef2d1c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $450938ba1cef2d1c$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $450938ba1cef2d1c$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($3PNM4(value)) return $450938ba1cef2d1c$var$NAN;
    if ($b5U5s(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b5U5s(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $81qFf(value);
    var isBinary = $450938ba1cef2d1c$var$reIsBinary.test(value);
    return isBinary || $450938ba1cef2d1c$var$reIsOctal.test(value) ? $450938ba1cef2d1c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $450938ba1cef2d1c$var$reIsBadHex.test(value) ? $450938ba1cef2d1c$var$NAN : +value;
}
module.exports = $450938ba1cef2d1c$var$toNumber;

});

parcelRegister("50tqW", function(module, exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

});

parcelRegister("36oQk", function(module, exports) {

var $bclWo = parcelRequire("bclWo");


var $8QJsv = parcelRequire("8QJsv");

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $242533f567596500$var$forOwn(object, iteratee) {
    return object && $bclWo(object, $8QJsv(iteratee));
}
module.exports = $242533f567596500$var$forOwn;

});

parcelRegister("ThBJA", function(module, exports) {

var $6vSTA = parcelRequire("6vSTA");


var $3Yi1j = parcelRequire("3Yi1j");


var $ctctG = parcelRequire("ctctG");


var $ispza = parcelRequire("ispza");


var $8U8Jk = parcelRequire("8U8Jk");


var $d1lGS = parcelRequire("d1lGS");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0a62cbacc5d512a6$var$Stack(entries) {
    var data = this.__data__ = new $6vSTA(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$0a62cbacc5d512a6$var$Stack.prototype.clear = $3Yi1j;
$0a62cbacc5d512a6$var$Stack.prototype['delete'] = $ctctG;
$0a62cbacc5d512a6$var$Stack.prototype.get = $ispza;
$0a62cbacc5d512a6$var$Stack.prototype.has = $8U8Jk;
$0a62cbacc5d512a6$var$Stack.prototype.set = $d1lGS;
module.exports = $0a62cbacc5d512a6$var$Stack;

});

parcelRegister("3y9vZ", function(module, exports) {

var $hDaMm = parcelRequire("hDaMm");


var $ir6wg = parcelRequire("ir6wg");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $295bed8783fd5455$var$getNative(object, key) {
    var value = $ir6wg(object, key);
    return $hDaMm(value) ? value : undefined;
}
module.exports = $295bed8783fd5455$var$getNative;

});

parcelRegister("haa70", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $c7eb36da2ac78af9$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $c7eb36da2ac78af9$var$eq;

});

parcelRegister("89kUo", function(module, exports) {

var $ibEs2 = parcelRequire("ibEs2");


var $lDQLA = parcelRequire("lDQLA");


var $8W5BJ = parcelRequire("8W5BJ");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0187fd7395d78d93$var$keys(object) {
    return $8W5BJ(object) ? $ibEs2(object) : $lDQLA(object);
}
module.exports = $0187fd7395d78d93$var$keys;

});

parcelRegister("ibEs2", function(module, exports) {

var $5W7Qb = parcelRequire("5W7Qb");


var $d3SZr = parcelRequire("d3SZr");


var $eioMK = parcelRequire("eioMK");


var $j7yqm = parcelRequire("j7yqm");


var $7wEyS = parcelRequire("7wEyS");


var $44M3z = parcelRequire("44M3z");

/** Used for built-in method references. */ var $d3d8a1d2417097a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d3d8a1d2417097a0$var$hasOwnProperty = $d3d8a1d2417097a0$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $d3d8a1d2417097a0$var$arrayLikeKeys(value, inherited) {
    var isArr = $eioMK(value), isArg = !isArr && $d3SZr(value), isBuff = !isArr && !isArg && $j7yqm(value), isType = !isArr && !isArg && !isBuff && $44M3z(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5W7Qb(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $d3d8a1d2417097a0$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $7wEyS(key, length)))) result.push(key);
    return result;
}
module.exports = $d3d8a1d2417097a0$var$arrayLikeKeys;

});

parcelRegister("467Dm", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2fbda4e1cf3c4745$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $2fbda4e1cf3c4745$var$isObject;

});

parcelRegister("hJadS", function(module, exports) {
/** Used for built-in method references. */ var $ce7e91b34da3563b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ce7e91b34da3563b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $ce7e91b34da3563b$var$objectProto;
    return value === proto;
}
module.exports = $ce7e91b34da3563b$var$isPrototype;

});

parcelRegister("8W5BJ", function(module, exports) {

var $cjOBa = parcelRequire("cjOBa");


var $j9392 = parcelRequire("j9392");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $68181713f3a01bfb$var$isArrayLike(value) {
    return value != null && $j9392(value.length) && !$cjOBa(value);
}
module.exports = $68181713f3a01bfb$var$isArrayLike;

});

parcelRegister("7ND8c", function(module, exports) {

var $87tVU = parcelRequire("87tVU");


var $hFCqO = parcelRequire("hFCqO");

/** Used for built-in method references. */ var $5adb76aa7241c6d0$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5adb76aa7241c6d0$var$propertyIsEnumerable = $5adb76aa7241c6d0$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5adb76aa7241c6d0$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5adb76aa7241c6d0$var$getSymbols = !$5adb76aa7241c6d0$var$nativeGetSymbols ? $hFCqO : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $87tVU($5adb76aa7241c6d0$var$nativeGetSymbols(object), function(symbol) {
        return $5adb76aa7241c6d0$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $5adb76aa7241c6d0$var$getSymbols;

});

parcelRegister("730jH", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $52190f222e2f878f$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $52190f222e2f878f$var$arrayPush;

});

parcelRegister("bSmSC", function(module, exports) {

var $dqrGF = parcelRequire("dqrGF");

/** Built-in value references. */ var $8a567c543f57ff55$var$getPrototype = $dqrGF(Object.getPrototypeOf, Object);
module.exports = $8a567c543f57ff55$var$getPrototype;

});

parcelRegister("hFCqO", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $cdd413b22f1868d7$var$stubArray() {
    return [];
}
module.exports = $cdd413b22f1868d7$var$stubArray;

});

parcelRegister("8D9dx", function(module, exports) {

var $2T90T = parcelRequire("2T90T");


var $7ND8c = parcelRequire("7ND8c");


var $89kUo = parcelRequire("89kUo");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $64891da101f643d7$var$getAllKeys(object) {
    return $2T90T(object, $89kUo, $7ND8c);
}
module.exports = $64891da101f643d7$var$getAllKeys;

});

parcelRegister("2T90T", function(module, exports) {

var $730jH = parcelRequire("730jH");


var $eioMK = parcelRequire("eioMK");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $21a7b5b6056d73ca$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $eioMK(object) ? result : $730jH(result, symbolsFunc(object));
}
module.exports = $21a7b5b6056d73ca$var$baseGetAllKeys;

});

parcelRegister("k4ejE", function(module, exports) {

var $iik8s = parcelRequire("iik8s");


var $kqabl = parcelRequire("kqabl");


var $1q8eT = parcelRequire("1q8eT");


var $i5rkF = parcelRequire("i5rkF");


var $78GVE = parcelRequire("78GVE");


var $eK80t = parcelRequire("eK80t");


var $k676m = parcelRequire("k676m");

/** `Object#toString` result references. */ var $e9bf4937432ba7ce$var$mapTag = '[object Map]', $e9bf4937432ba7ce$var$objectTag = '[object Object]', $e9bf4937432ba7ce$var$promiseTag = '[object Promise]', $e9bf4937432ba7ce$var$setTag = '[object Set]', $e9bf4937432ba7ce$var$weakMapTag = '[object WeakMap]';
var $e9bf4937432ba7ce$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $e9bf4937432ba7ce$var$dataViewCtorString = $k676m($iik8s), $e9bf4937432ba7ce$var$mapCtorString = $k676m($kqabl), $e9bf4937432ba7ce$var$promiseCtorString = $k676m($1q8eT), $e9bf4937432ba7ce$var$setCtorString = $k676m($i5rkF), $e9bf4937432ba7ce$var$weakMapCtorString = $k676m($78GVE);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $e9bf4937432ba7ce$var$getTag = $eK80t;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($iik8s && $e9bf4937432ba7ce$var$getTag(new $iik8s(new ArrayBuffer(1))) != $e9bf4937432ba7ce$var$dataViewTag || $kqabl && $e9bf4937432ba7ce$var$getTag(new $kqabl) != $e9bf4937432ba7ce$var$mapTag || $1q8eT && $e9bf4937432ba7ce$var$getTag($1q8eT.resolve()) != $e9bf4937432ba7ce$var$promiseTag || $i5rkF && $e9bf4937432ba7ce$var$getTag(new $i5rkF) != $e9bf4937432ba7ce$var$setTag || $78GVE && $e9bf4937432ba7ce$var$getTag(new $78GVE) != $e9bf4937432ba7ce$var$weakMapTag) $e9bf4937432ba7ce$var$getTag = function(value) {
    var result = $eK80t(value), Ctor = result == $e9bf4937432ba7ce$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $k676m(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $e9bf4937432ba7ce$var$dataViewCtorString:
            return $e9bf4937432ba7ce$var$dataViewTag;
        case $e9bf4937432ba7ce$var$mapCtorString:
            return $e9bf4937432ba7ce$var$mapTag;
        case $e9bf4937432ba7ce$var$promiseCtorString:
            return $e9bf4937432ba7ce$var$promiseTag;
        case $e9bf4937432ba7ce$var$setCtorString:
            return $e9bf4937432ba7ce$var$setTag;
        case $e9bf4937432ba7ce$var$weakMapCtorString:
            return $e9bf4937432ba7ce$var$weakMapTag;
    }
    return result;
};
module.exports = $e9bf4937432ba7ce$var$getTag;

});

parcelRegister("1Fbgg", function(module, exports) {

var $8tFmL = parcelRequire("8tFmL");

/** Built-in value references. */ var $13625b0f013ae6fc$var$Uint8Array = $8tFmL.Uint8Array;
module.exports = $13625b0f013ae6fc$var$Uint8Array;

});

parcelRegister("e1YiA", function(module, exports) {

var $8tFmL = parcelRequire("8tFmL");

/** Built-in value references. */ var $a36feec474300ba6$var$Symbol = $8tFmL.Symbol;
module.exports = $a36feec474300ba6$var$Symbol;

});

parcelRegister("eioMK", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $a685f8f282464865$var$isArray = Array.isArray;
module.exports = $a685f8f282464865$var$isArray;

});

parcelRegister("kyMnU", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ef7c83ca3b7c409f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $ef7c83ca3b7c409f$var$isObjectLike;

});

parcelRegister("1VX1z", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $1688e64fa1cf9983$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $1688e64fa1cf9983$var$baseUnary;

});

parcelRegister("81qFf", function(module, exports) {

var $6l4QC = parcelRequire("6l4QC");

/** Used to match leading whitespace. */ var $5d7319b307abc2be$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $5d7319b307abc2be$var$baseTrim(string) {
    return string ? string.slice(0, $6l4QC(string) + 1).replace($5d7319b307abc2be$var$reTrimStart, '') : string;
}
module.exports = $5d7319b307abc2be$var$baseTrim;

});

parcelRegister("3PNM4", function(module, exports) {

var $et6E7 = parcelRequire("et6E7");


var $pARw7 = parcelRequire("pARw7");

/** `Object#toString` result references. */ var $2cacbea4d2d301e5$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2cacbea4d2d301e5$var$isSymbol(value) {
    return typeof value == 'symbol' || $pARw7(value) && $et6E7(value) == $2cacbea4d2d301e5$var$symbolTag;
}
module.exports = $2cacbea4d2d301e5$var$isSymbol;

});

parcelRegister("bclWo", function(module, exports) {

var $9L3Vr = parcelRequire("9L3Vr");


var $89kUo = parcelRequire("89kUo");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $8271d5b4f18c0988$var$baseForOwn(object, iteratee) {
    return object && $9L3Vr(object, iteratee, $89kUo);
}
module.exports = $8271d5b4f18c0988$var$baseForOwn;

});

parcelRegister("8QJsv", function(module, exports) {

var $1lfjI = parcelRequire("1lfjI");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $67167138a3df6a2e$var$castFunction(value) {
    return typeof value == 'function' ? value : $1lfjI;
}
module.exports = $67167138a3df6a2e$var$castFunction;

});

parcelRegister("6vSTA", function(module, exports) {

var $44fjT = parcelRequire("44fjT");


var $kDmxX = parcelRequire("kDmxX");


var $11LRx = parcelRequire("11LRx");


var $3d2Jr = parcelRequire("3d2Jr");


var $ipQvK = parcelRequire("ipQvK");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4be038777476a022$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4be038777476a022$var$ListCache.prototype.clear = $44fjT;
$4be038777476a022$var$ListCache.prototype['delete'] = $kDmxX;
$4be038777476a022$var$ListCache.prototype.get = $11LRx;
$4be038777476a022$var$ListCache.prototype.has = $3d2Jr;
$4be038777476a022$var$ListCache.prototype.set = $ipQvK;
module.exports = $4be038777476a022$var$ListCache;

});

parcelRegister("3Yi1j", function(module, exports) {

var $6vSTA = parcelRequire("6vSTA");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $2e44f42199e2ed16$var$stackClear() {
    this.__data__ = new $6vSTA;
    this.size = 0;
}
module.exports = $2e44f42199e2ed16$var$stackClear;

});

parcelRegister("ctctG", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9141df4bb70587d0$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $9141df4bb70587d0$var$stackDelete;

});

parcelRegister("ispza", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d6feac746f9bc3d4$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $d6feac746f9bc3d4$var$stackGet;

});

parcelRegister("8U8Jk", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $67ba5348d9dfe31d$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $67ba5348d9dfe31d$var$stackHas;

});

parcelRegister("d1lGS", function(module, exports) {

var $6vSTA = parcelRequire("6vSTA");


var $kqabl = parcelRequire("kqabl");


var $lWYAi = parcelRequire("lWYAi");

/** Used as the size to enable large array optimizations. */ var $97ac31a97b84a86a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $97ac31a97b84a86a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6vSTA) {
        var pairs = data.__data__;
        if (!$kqabl || pairs.length < $97ac31a97b84a86a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $lWYAi(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $97ac31a97b84a86a$var$stackSet;

});

parcelRegister("hDaMm", function(module, exports) {

var $cjOBa = parcelRequire("cjOBa");


var $jMiGj = parcelRequire("jMiGj");


var $467Dm = parcelRequire("467Dm");


var $k676m = parcelRequire("k676m");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $cd5e70b08cac5179$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $cd5e70b08cac5179$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $cd5e70b08cac5179$var$funcProto = Function.prototype, $cd5e70b08cac5179$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $cd5e70b08cac5179$var$funcToString = $cd5e70b08cac5179$var$funcProto.toString;
/** Used to check objects for own properties. */ var $cd5e70b08cac5179$var$hasOwnProperty = $cd5e70b08cac5179$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $cd5e70b08cac5179$var$reIsNative = RegExp('^' + $cd5e70b08cac5179$var$funcToString.call($cd5e70b08cac5179$var$hasOwnProperty).replace($cd5e70b08cac5179$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $cd5e70b08cac5179$var$baseIsNative(value) {
    if (!$467Dm(value) || $jMiGj(value)) return false;
    var pattern = $cjOBa(value) ? $cd5e70b08cac5179$var$reIsNative : $cd5e70b08cac5179$var$reIsHostCtor;
    return pattern.test($k676m(value));
}
module.exports = $cd5e70b08cac5179$var$baseIsNative;

});

parcelRegister("ir6wg", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d6bfce3bf912e3f5$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d6bfce3bf912e3f5$var$getValue;

});

parcelRegister("lDQLA", function(module, exports) {

var $hJadS = parcelRequire("hJadS");


var $9WWIe = parcelRequire("9WWIe");

/** Used for built-in method references. */ var $fc162bd829388273$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fc162bd829388273$var$hasOwnProperty = $fc162bd829388273$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fc162bd829388273$var$baseKeys(object) {
    if (!$hJadS(object)) return $9WWIe(object);
    var result = [];
    for(var key in Object(object))if ($fc162bd829388273$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $fc162bd829388273$var$baseKeys;

});

parcelRegister("5W7Qb", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4528738b6fce5a54$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $4528738b6fce5a54$var$baseTimes;

});

parcelRegister("d3SZr", function(module, exports) {

var $3nqiR = parcelRequire("3nqiR");


var $kyMnU = parcelRequire("kyMnU");

/** Used for built-in method references. */ var $9826360a2335c5fb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9826360a2335c5fb$var$hasOwnProperty = $9826360a2335c5fb$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $9826360a2335c5fb$var$propertyIsEnumerable = $9826360a2335c5fb$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $9826360a2335c5fb$var$isArguments = $3nqiR(function() {
    return arguments;
}()) ? $3nqiR : function(value) {
    return $kyMnU(value) && $9826360a2335c5fb$var$hasOwnProperty.call(value, 'callee') && !$9826360a2335c5fb$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $9826360a2335c5fb$var$isArguments;

});

parcelRegister("7wEyS", function(module, exports) {
/** Used as references for various `Number` constants. */ var $57aafc3eb44f1c6f$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $57aafc3eb44f1c6f$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $57aafc3eb44f1c6f$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $57aafc3eb44f1c6f$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $57aafc3eb44f1c6f$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $57aafc3eb44f1c6f$var$isIndex;

});

parcelRegister("44M3z", function(module, exports) {

var $34GUy = parcelRequire("34GUy");


var $1VX1z = parcelRequire("1VX1z");


var $llRc8 = parcelRequire("llRc8");

/* Node.js helper references. */ var $2f7cd031fcfac37f$var$nodeIsTypedArray = $llRc8 && $llRc8.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $2f7cd031fcfac37f$var$isTypedArray = $2f7cd031fcfac37f$var$nodeIsTypedArray ? $1VX1z($2f7cd031fcfac37f$var$nodeIsTypedArray) : $34GUy;
module.exports = $2f7cd031fcfac37f$var$isTypedArray;

});

parcelRegister("cjOBa", function(module, exports) {

var $eK80t = parcelRequire("eK80t");


var $467Dm = parcelRequire("467Dm");

/** `Object#toString` result references. */ var $8f7e82307b939015$var$asyncTag = '[object AsyncFunction]', $8f7e82307b939015$var$funcTag = '[object Function]', $8f7e82307b939015$var$genTag = '[object GeneratorFunction]', $8f7e82307b939015$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8f7e82307b939015$var$isFunction(value) {
    if (!$467Dm(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eK80t(value);
    return tag == $8f7e82307b939015$var$funcTag || tag == $8f7e82307b939015$var$genTag || tag == $8f7e82307b939015$var$asyncTag || tag == $8f7e82307b939015$var$proxyTag;
}
module.exports = $8f7e82307b939015$var$isFunction;

});

parcelRegister("j9392", function(module, exports) {
/** Used as references for various `Number` constants. */ var $df014c1584aa9c8c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $df014c1584aa9c8c$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $df014c1584aa9c8c$var$MAX_SAFE_INTEGER;
}
module.exports = $df014c1584aa9c8c$var$isLength;

});

parcelRegister("87tVU", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $5e9632432e0e4b88$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $5e9632432e0e4b88$var$arrayFilter;

});

parcelRegister("dqrGF", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $9c632e2ed2366a7a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $9c632e2ed2366a7a$var$overArg;

});

parcelRegister("iik8s", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");


var $8tFmL = parcelRequire("8tFmL");

/* Built-in method references that are verified to be native. */ var $d51986e8335844e6$var$DataView = $3y9vZ($8tFmL, 'DataView');
module.exports = $d51986e8335844e6$var$DataView;

});

parcelRegister("kqabl", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");


var $8tFmL = parcelRequire("8tFmL");

/* Built-in method references that are verified to be native. */ var $edde224f040b332b$var$Map = $3y9vZ($8tFmL, 'Map');
module.exports = $edde224f040b332b$var$Map;

});

parcelRegister("1q8eT", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");


var $8tFmL = parcelRequire("8tFmL");

/* Built-in method references that are verified to be native. */ var $108e9c472d383644$var$Promise = $3y9vZ($8tFmL, 'Promise');
module.exports = $108e9c472d383644$var$Promise;

});

parcelRegister("i5rkF", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");


var $8tFmL = parcelRequire("8tFmL");

/* Built-in method references that are verified to be native. */ var $d2ade53fdf2f2b03$var$Set = $3y9vZ($8tFmL, 'Set');
module.exports = $d2ade53fdf2f2b03$var$Set;

});

parcelRegister("78GVE", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");


var $8tFmL = parcelRequire("8tFmL");

/* Built-in method references that are verified to be native. */ var $532a948b78c5ee52$var$WeakMap = $3y9vZ($8tFmL, 'WeakMap');
module.exports = $532a948b78c5ee52$var$WeakMap;

});

parcelRegister("eK80t", function(module, exports) {

var $e1YiA = parcelRequire("e1YiA");


var $dAOU3 = parcelRequire("dAOU3");


var $d604S = parcelRequire("d604S");

/** `Object#toString` result references. */ var $abbb928b15f7a2ab$var$nullTag = '[object Null]', $abbb928b15f7a2ab$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $abbb928b15f7a2ab$var$symToStringTag = $e1YiA ? $e1YiA.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $abbb928b15f7a2ab$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $abbb928b15f7a2ab$var$undefinedTag : $abbb928b15f7a2ab$var$nullTag;
    return $abbb928b15f7a2ab$var$symToStringTag && $abbb928b15f7a2ab$var$symToStringTag in Object(value) ? $dAOU3(value) : $d604S(value);
}
module.exports = $abbb928b15f7a2ab$var$baseGetTag;

});

parcelRegister("k676m", function(module, exports) {
/** Used for built-in method references. */ var $ea19e066c466517f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ea19e066c466517f$var$funcToString = $ea19e066c466517f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ea19e066c466517f$var$toSource(func) {
    if (func != null) {
        try {
            return $ea19e066c466517f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $ea19e066c466517f$var$toSource;

});

parcelRegister("6l4QC", function(module, exports) {
/** Used to match a single whitespace character. */ var $49d876e83cc7d48b$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $49d876e83cc7d48b$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $49d876e83cc7d48b$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $49d876e83cc7d48b$var$trimmedEndIndex;

});

parcelRegister("9L3Vr", function(module, exports) {

var $g4Mka = parcelRequire("g4Mka");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $71ab8c5f99573a2a$var$baseFor = $g4Mka();
module.exports = $71ab8c5f99573a2a$var$baseFor;

});

parcelRegister("1lfjI", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0fa3a23d94907c58$var$identity(value) {
    return value;
}
module.exports = $0fa3a23d94907c58$var$identity;

});

parcelRegister("44fjT", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $2f636b5d63f32e74$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $2f636b5d63f32e74$var$listCacheClear;

});

parcelRegister("kDmxX", function(module, exports) {

var $dnYa2 = parcelRequire("dnYa2");

/** Used for built-in method references. */ var $f058f07f15e0a289$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $f058f07f15e0a289$var$splice = $f058f07f15e0a289$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f058f07f15e0a289$var$listCacheDelete(key) {
    var data = this.__data__, index = $dnYa2(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $f058f07f15e0a289$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $f058f07f15e0a289$var$listCacheDelete;

});

parcelRegister("11LRx", function(module, exports) {

var $dnYa2 = parcelRequire("dnYa2");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0bfb02ef7c90621c$var$listCacheGet(key) {
    var data = this.__data__, index = $dnYa2(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $0bfb02ef7c90621c$var$listCacheGet;

});

parcelRegister("3d2Jr", function(module, exports) {

var $dnYa2 = parcelRequire("dnYa2");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2564b47ed4df68ae$var$listCacheHas(key) {
    return $dnYa2(this.__data__, key) > -1;
}
module.exports = $2564b47ed4df68ae$var$listCacheHas;

});

parcelRegister("ipQvK", function(module, exports) {

var $dnYa2 = parcelRequire("dnYa2");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $d6834b6699743245$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dnYa2(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $d6834b6699743245$var$listCacheSet;

});

parcelRegister("lWYAi", function(module, exports) {

var $867Gj = parcelRequire("867Gj");


var $9pFf9 = parcelRequire("9pFf9");


var $5njEZ = parcelRequire("5njEZ");


var $jNey8 = parcelRequire("jNey8");


var $1pnhB = parcelRequire("1pnhB");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ffae02905e83d5b6$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$ffae02905e83d5b6$var$MapCache.prototype.clear = $867Gj;
$ffae02905e83d5b6$var$MapCache.prototype['delete'] = $9pFf9;
$ffae02905e83d5b6$var$MapCache.prototype.get = $5njEZ;
$ffae02905e83d5b6$var$MapCache.prototype.has = $jNey8;
$ffae02905e83d5b6$var$MapCache.prototype.set = $1pnhB;
module.exports = $ffae02905e83d5b6$var$MapCache;

});

parcelRegister("jMiGj", function(module, exports) {

var $jTm1o = parcelRequire("jTm1o");

/** Used to detect methods masquerading as native. */ var $e660fdbd3fb22f74$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($jTm1o && $jTm1o.keys && $jTm1o.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e660fdbd3fb22f74$var$isMasked(func) {
    return !!$e660fdbd3fb22f74$var$maskSrcKey && $e660fdbd3fb22f74$var$maskSrcKey in func;
}
module.exports = $e660fdbd3fb22f74$var$isMasked;

});

parcelRegister("9WWIe", function(module, exports) {

var $dqrGF = parcelRequire("dqrGF");

/* Built-in method references for those with the same name as other `lodash` methods. */ var $73e712e27004863e$var$nativeKeys = $dqrGF(Object.keys, Object);
module.exports = $73e712e27004863e$var$nativeKeys;

});

parcelRegister("3nqiR", function(module, exports) {

var $eK80t = parcelRequire("eK80t");


var $kyMnU = parcelRequire("kyMnU");

/** `Object#toString` result references. */ var $2757ec530607c60a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $2757ec530607c60a$var$baseIsArguments(value) {
    return $kyMnU(value) && $eK80t(value) == $2757ec530607c60a$var$argsTag;
}
module.exports = $2757ec530607c60a$var$baseIsArguments;

});

parcelRegister("34GUy", function(module, exports) {

var $eK80t = parcelRequire("eK80t");


var $j9392 = parcelRequire("j9392");


var $kyMnU = parcelRequire("kyMnU");

/** `Object#toString` result references. */ var $23d30815f80310a0$var$argsTag = '[object Arguments]', $23d30815f80310a0$var$arrayTag = '[object Array]', $23d30815f80310a0$var$boolTag = '[object Boolean]', $23d30815f80310a0$var$dateTag = '[object Date]', $23d30815f80310a0$var$errorTag = '[object Error]', $23d30815f80310a0$var$funcTag = '[object Function]', $23d30815f80310a0$var$mapTag = '[object Map]', $23d30815f80310a0$var$numberTag = '[object Number]', $23d30815f80310a0$var$objectTag = '[object Object]', $23d30815f80310a0$var$regexpTag = '[object RegExp]', $23d30815f80310a0$var$setTag = '[object Set]', $23d30815f80310a0$var$stringTag = '[object String]', $23d30815f80310a0$var$weakMapTag = '[object WeakMap]';
var $23d30815f80310a0$var$arrayBufferTag = '[object ArrayBuffer]', $23d30815f80310a0$var$dataViewTag = '[object DataView]', $23d30815f80310a0$var$float32Tag = '[object Float32Array]', $23d30815f80310a0$var$float64Tag = '[object Float64Array]', $23d30815f80310a0$var$int8Tag = '[object Int8Array]', $23d30815f80310a0$var$int16Tag = '[object Int16Array]', $23d30815f80310a0$var$int32Tag = '[object Int32Array]', $23d30815f80310a0$var$uint8Tag = '[object Uint8Array]', $23d30815f80310a0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $23d30815f80310a0$var$uint16Tag = '[object Uint16Array]', $23d30815f80310a0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $23d30815f80310a0$var$typedArrayTags = {};
$23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$float32Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$float64Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$int8Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$int16Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$int32Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$uint8Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$uint8ClampedTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$uint16Tag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$uint32Tag] = true;
$23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$argsTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$arrayTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$arrayBufferTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$boolTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$dataViewTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$dateTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$errorTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$funcTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$mapTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$numberTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$objectTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$regexpTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$setTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$stringTag] = $23d30815f80310a0$var$typedArrayTags[$23d30815f80310a0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $23d30815f80310a0$var$baseIsTypedArray(value) {
    return $kyMnU(value) && $j9392(value.length) && !!$23d30815f80310a0$var$typedArrayTags[$eK80t(value)];
}
module.exports = $23d30815f80310a0$var$baseIsTypedArray;

});

parcelRegister("dAOU3", function(module, exports) {

var $e1YiA = parcelRequire("e1YiA");

/** Used for built-in method references. */ var $9e561f6e5d5ff1be$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9e561f6e5d5ff1be$var$hasOwnProperty = $9e561f6e5d5ff1be$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9e561f6e5d5ff1be$var$nativeObjectToString = $9e561f6e5d5ff1be$var$objectProto.toString;
/** Built-in value references. */ var $9e561f6e5d5ff1be$var$symToStringTag = $e1YiA ? $e1YiA.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9e561f6e5d5ff1be$var$getRawTag(value) {
    var isOwn = $9e561f6e5d5ff1be$var$hasOwnProperty.call(value, $9e561f6e5d5ff1be$var$symToStringTag), tag = value[$9e561f6e5d5ff1be$var$symToStringTag];
    try {
        value[$9e561f6e5d5ff1be$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9e561f6e5d5ff1be$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9e561f6e5d5ff1be$var$symToStringTag] = tag;
        else delete value[$9e561f6e5d5ff1be$var$symToStringTag];
    }
    return result;
}
module.exports = $9e561f6e5d5ff1be$var$getRawTag;

});

parcelRegister("d604S", function(module, exports) {
/** Used for built-in method references. */ var $988be55212eace48$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $988be55212eace48$var$nativeObjectToString = $988be55212eace48$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $988be55212eace48$var$objectToString(value) {
    return $988be55212eace48$var$nativeObjectToString.call(value);
}
module.exports = $988be55212eace48$var$objectToString;

});

parcelRegister("g4Mka", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $bb42814849175217$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $bb42814849175217$var$createBaseFor;

});

parcelRegister("dnYa2", function(module, exports) {

var $haa70 = parcelRequire("haa70");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $9bec17079e409441$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($haa70(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $9bec17079e409441$var$assocIndexOf;

});

parcelRegister("867Gj", function(module, exports) {

var $FlDeT = parcelRequire("FlDeT");


var $6vSTA = parcelRequire("6vSTA");


var $kqabl = parcelRequire("kqabl");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $5e54d7a1f9274125$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $FlDeT,
        'map': new ($kqabl || $6vSTA),
        'string': new $FlDeT
    };
}
module.exports = $5e54d7a1f9274125$var$mapCacheClear;

});

parcelRegister("9pFf9", function(module, exports) {

var $jxyLr = parcelRequire("jxyLr");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6da670ede59453ad$var$mapCacheDelete(key) {
    var result = $jxyLr(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $6da670ede59453ad$var$mapCacheDelete;

});

parcelRegister("5njEZ", function(module, exports) {

var $jxyLr = parcelRequire("jxyLr");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3e9e59d6272230ea$var$mapCacheGet(key) {
    return $jxyLr(this, key).get(key);
}
module.exports = $3e9e59d6272230ea$var$mapCacheGet;

});

parcelRegister("jNey8", function(module, exports) {

var $jxyLr = parcelRequire("jxyLr");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e68de127e24cb7ba$var$mapCacheHas(key) {
    return $jxyLr(this, key).has(key);
}
module.exports = $e68de127e24cb7ba$var$mapCacheHas;

});

parcelRegister("1pnhB", function(module, exports) {

var $jxyLr = parcelRequire("jxyLr");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $106a2fbd851b9a33$var$mapCacheSet(key, value) {
    var data = $jxyLr(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $106a2fbd851b9a33$var$mapCacheSet;

});

parcelRegister("jTm1o", function(module, exports) {

var $8tFmL = parcelRequire("8tFmL");

/** Used to detect overreaching core-js shims. */ var $e7b43c5d56c26728$var$coreJsData = $8tFmL["__core-js_shared__"];
module.exports = $e7b43c5d56c26728$var$coreJsData;

});

parcelRegister("FlDeT", function(module, exports) {

var $gMATZ = parcelRequire("gMATZ");


var $4UqmI = parcelRequire("4UqmI");


var $2Hb4o = parcelRequire("2Hb4o");


var $2DC4I = parcelRequire("2DC4I");


var $aN4Lq = parcelRequire("aN4Lq");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $07c49c17cabcbe0a$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$07c49c17cabcbe0a$var$Hash.prototype.clear = $gMATZ;
$07c49c17cabcbe0a$var$Hash.prototype['delete'] = $4UqmI;
$07c49c17cabcbe0a$var$Hash.prototype.get = $2Hb4o;
$07c49c17cabcbe0a$var$Hash.prototype.has = $2DC4I;
$07c49c17cabcbe0a$var$Hash.prototype.set = $aN4Lq;
module.exports = $07c49c17cabcbe0a$var$Hash;

});

parcelRegister("jxyLr", function(module, exports) {

var $ffjCA = parcelRequire("ffjCA");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e39c10cf17c9a1ec$var$getMapData(map, key) {
    var data = map.__data__;
    return $ffjCA(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $e39c10cf17c9a1ec$var$getMapData;

});

parcelRegister("gMATZ", function(module, exports) {

var $2cSgQ = parcelRequire("2cSgQ");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c37dc108f2fe2a2b$var$hashClear() {
    this.__data__ = $2cSgQ ? $2cSgQ(null) : {};
    this.size = 0;
}
module.exports = $c37dc108f2fe2a2b$var$hashClear;

});

parcelRegister("4UqmI", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3930d7fe7eeb02ec$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $3930d7fe7eeb02ec$var$hashDelete;

});

parcelRegister("2Hb4o", function(module, exports) {

var $2cSgQ = parcelRequire("2cSgQ");

/** Used to stand-in for `undefined` hash values. */ var $1f682f2a52569373$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $1f682f2a52569373$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1f682f2a52569373$var$hasOwnProperty = $1f682f2a52569373$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1f682f2a52569373$var$hashGet(key) {
    var data = this.__data__;
    if ($2cSgQ) {
        var result = data[key];
        return result === $1f682f2a52569373$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1f682f2a52569373$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $1f682f2a52569373$var$hashGet;

});

parcelRegister("2DC4I", function(module, exports) {

var $2cSgQ = parcelRequire("2cSgQ");

/** Used for built-in method references. */ var $1ebcc22ea96ba4bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ebcc22ea96ba4bd$var$hasOwnProperty = $1ebcc22ea96ba4bd$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1ebcc22ea96ba4bd$var$hashHas(key) {
    var data = this.__data__;
    return $2cSgQ ? data[key] !== undefined : $1ebcc22ea96ba4bd$var$hasOwnProperty.call(data, key);
}
module.exports = $1ebcc22ea96ba4bd$var$hashHas;

});

parcelRegister("aN4Lq", function(module, exports) {

var $2cSgQ = parcelRequire("2cSgQ");

/** Used to stand-in for `undefined` hash values. */ var $7db22cfbee13fd24$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7db22cfbee13fd24$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $2cSgQ && value === undefined ? $7db22cfbee13fd24$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $7db22cfbee13fd24$var$hashSet;

});

parcelRegister("ffjCA", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b1977a1dfd2aad6e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $b1977a1dfd2aad6e$var$isKeyable;

});

parcelRegister("2cSgQ", function(module, exports) {

var $3y9vZ = parcelRequire("3y9vZ");

/* Built-in method references that are verified to be native. */ var $19b6ccc3e1ef1b1e$var$nativeCreate = $3y9vZ(Object, 'create');
module.exports = $19b6ccc3e1ef1b1e$var$nativeCreate;

});


$parcel$global.rlb("51haJ")
//# sourceMappingURL=cards-extension.79d1aa01.js.map
